(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9278,2210],{

/***/ 76489:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */



/**
 * Module exports.
 * @public
 */

exports.parse = parse;
exports.serialize = serialize;

/**
 * Module variables.
 * @private
 */

var decode = decodeURIComponent;
var encode = encodeURIComponent;

/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */

var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;

/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */

function parse(str, options) {
  if (typeof str !== 'string') {
    throw new TypeError('argument str must be a string');
  }

  var obj = {}
  var opt = options || {};
  var pairs = str.split(';')
  var dec = opt.decode || decode;

  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i];
    var index = pair.indexOf('=')

    // skip things that don't look like key=value
    if (index < 0) {
      continue;
    }

    var key = pair.substring(0, index).trim()

    // only assign once
    if (undefined == obj[key]) {
      var val = pair.substring(index + 1, pair.length).trim()

      // quoted values
      if (val[0] === '"') {
        val = val.slice(1, -1)
      }

      obj[key] = tryDecode(val, dec);
    }
  }

  return obj;
}

/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */

function serialize(name, val, options) {
  var opt = options || {};
  var enc = opt.encode || encode;

  if (typeof enc !== 'function') {
    throw new TypeError('option encode is invalid');
  }

  if (!fieldContentRegExp.test(name)) {
    throw new TypeError('argument name is invalid');
  }

  var value = enc(val);

  if (value && !fieldContentRegExp.test(value)) {
    throw new TypeError('argument val is invalid');
  }

  var str = name + '=' + value;

  if (null != opt.maxAge) {
    var maxAge = opt.maxAge - 0;

    if (isNaN(maxAge) || !isFinite(maxAge)) {
      throw new TypeError('option maxAge is invalid')
    }

    str += '; Max-Age=' + Math.floor(maxAge);
  }

  if (opt.domain) {
    if (!fieldContentRegExp.test(opt.domain)) {
      throw new TypeError('option domain is invalid');
    }

    str += '; Domain=' + opt.domain;
  }

  if (opt.path) {
    if (!fieldContentRegExp.test(opt.path)) {
      throw new TypeError('option path is invalid');
    }

    str += '; Path=' + opt.path;
  }

  if (opt.expires) {
    if (typeof opt.expires.toUTCString !== 'function') {
      throw new TypeError('option expires is invalid');
    }

    str += '; Expires=' + opt.expires.toUTCString();
  }

  if (opt.httpOnly) {
    str += '; HttpOnly';
  }

  if (opt.secure) {
    str += '; Secure';
  }

  if (opt.sameSite) {
    var sameSite = typeof opt.sameSite === 'string'
      ? opt.sameSite.toLowerCase() : opt.sameSite;

    switch (sameSite) {
      case true:
        str += '; SameSite=Strict';
        break;
      case 'lax':
        str += '; SameSite=Lax';
        break;
      case 'strict':
        str += '; SameSite=Strict';
        break;
      case 'none':
        str += '; SameSite=None';
        break;
      default:
        throw new TypeError('option sameSite is invalid');
    }
  }

  return str;
}

/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */

function tryDecode(str, decode) {
  try {
    return decode(str);
  } catch (e) {
    return str;
  }
}


/***/ }),

/***/ 15623:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* binding */ resetSyncUserProfile; },
  "c": function() { return /* binding */ syncUserProfile; }
});

;// CONCATENATED MODULE: ./utils/CreateThunk.js
var createThunk = function createThunk(_ref) {
  var apiCall = _ref.apiCall,
      type = _ref.type;
  return function (requestPayload) {
    return function (dispatch, getState) {
      dispatch({
        payload: requestPayload,
        type: type
      });
      return apiCall({
        getState: getState,
        payload: requestPayload
      }).then(function (payload) {
        return dispatch({
          type: "".concat(type, "_SUCCESS"),
          payload: payload,
          requestPayload: requestPayload
        });
      }, function (payload) {
        return dispatch({
          type: "".concat(type, "_FAILURE"),
          payload: payload,
          requestPayload: requestPayload
        });
      });
    };
  };
};
var createRejectableThunk = function createRejectableThunk(_ref2) {
  var apiCall = _ref2.apiCall,
      type = _ref2.type;
  return function (requestPayload) {
    return function (dispatch, getState) {
      dispatch({
        payload: requestPayload,
        type: type
      });
      return apiCall({
        getState: getState,
        payload: requestPayload
      }).then(function (payload) {
        return dispatch({
          type: "".concat(type, "_SUCCESS"),
          payload: payload,
          requestPayload: requestPayload
        });
      });
    };
  };
};
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./utils/microServices.js
var microServices = __webpack_require__(49366);
;// CONCATENATED MODULE: ./services/userProfileService.js




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var syncUserPorfile = /*#__PURE__*/function () {
  var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(_ref) {
    var _profileInfoRequest$r, _profileInfoRequest$r2, _profileInfo$result, _profileInfo$result2, _profileInfoRequest$e;

    var payload, params, profileInfoRequest, profileInfo;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            payload = _ref.payload;

            if (payload.cartId) {
              params = {
                guestCartId: payload.cartId
              };
            }

            _context.next = 4;
            return microServices/* default.post */.Z.post("api", "profileSync", {}, params);

          case 4:
            profileInfoRequest = _context.sent;
            profileInfo = (_profileInfoRequest$r = profileInfoRequest.response) === null || _profileInfoRequest$r === void 0 ? void 0 : (_profileInfoRequest$r2 = _profileInfoRequest$r.data) === null || _profileInfoRequest$r2 === void 0 ? void 0 : _profileInfoRequest$r2.result;

            if (!(!profileInfoRequest.fail && profileInfo && profileInfo !== null && profileInfo !== void 0 && profileInfo.result && profileInfo !== null && profileInfo !== void 0 && (_profileInfo$result = profileInfo.result) !== null && _profileInfo$result !== void 0 && _profileInfo$result.magentoProfileResponse && profileInfo !== null && profileInfo !== void 0 && (_profileInfo$result2 = profileInfo.result) !== null && _profileInfo$result2 !== void 0 && _profileInfo$result2.magentoProfileResponse[0])) {
              _context.next = 10;
              break;
            }

            return _context.abrupt("return", _objectSpread(_objectSpread({}, profileInfo), {}, {
              pageAction: payload.pageAction
            }));

          case 10:
            if (!(((_profileInfoRequest$e = profileInfoRequest.error) === null || _profileInfoRequest$e === void 0 ? void 0 : _profileInfoRequest$e.status) == 401)) {
              _context.next = 14;
              break;
            }

            throw {
              apiFailStatus: "401"
            };

          case 14:
            throw new Error();

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function syncUserPorfile(_x) {
    return _ref2.apply(this, arguments);
  };
}();
// EXTERNAL MODULE: ./Redux/actionTypes/index.js
var actionTypes = __webpack_require__(1369);
;// CONCATENATED MODULE: ./Redux/actions/userProfileAction.js



var syncUserProfile = createThunk({
  apiCall: syncUserPorfile,
  type: actionTypes/* SYNC_USER_PROFILE */.fR
});
var resetSyncUserProfile = function resetSyncUserProfile() {
  return {
    type: actionTypes/* SYNC_USER_PROFILE_RESET */.gC
  };
};

/***/ }),

/***/ 14413:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _backButton_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7249);
/* harmony import */ var _backButton_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_backButton_module_scss__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);





var BackButton = function BackButton(_ref) {
  var labelText = _ref.labelText,
      handleClick = _ref.handleClick,
      counter = _ref.counter,
      labelStyle = _ref.labelStyle,
      className = _ref.className,
      arrowStyle = _ref.arrowStyle,
      id = _ref.id;

  var generateCounter = function generateCounter(counter) {
    if (counter >= 0) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("span", {
        className: (_backButton_module_scss__WEBPACK_IMPORTED_MODULE_2___default()["back-button__counter"]),
        children: [" (", counter, ")"]
      });
    }

    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {});
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
    className: "".concat((_backButton_module_scss__WEBPACK_IMPORTED_MODULE_2___default()["back-button"]), " ").concat((_backButton_module_scss__WEBPACK_IMPORTED_MODULE_2___default())[className]),
    onClick: function onClick() {
      return handleClick();
    },
    id: id,
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("i", {
      className: "".concat((_backButton_module_scss__WEBPACK_IMPORTED_MODULE_2___default()["back-button__arrow-left"]), " ").concat((_backButton_module_scss__WEBPACK_IMPORTED_MODULE_2___default())[arrowStyle])
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("label", {
      className: "".concat((_backButton_module_scss__WEBPACK_IMPORTED_MODULE_2___default()["back-button__label"]), " ").concat(labelStyle, " ").concat((_backButton_module_scss__WEBPACK_IMPORTED_MODULE_2___default())[labelStyle]),
      children: labelText
    }), generateCounter(counter)]
  });
};

/* harmony default export */ __webpack_exports__["default"] = (BackButton);

/***/ }),

/***/ 38975:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _LabelText_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88447);
/* harmony import */ var _LabelText_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_LabelText_module_scss__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var LabelText = function LabelText(_ref) {
  var children = _ref.children,
      className = _ref.className,
      style = _ref.style,
      onClickHandler = _ref.onClickHandler,
      uniqueLabelId = _ref.uniqueLabelId;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("label", {
    className: "".concat(className, " ").concat((_LabelText_module_scss__WEBPACK_IMPORTED_MODULE_2___default()["label-text"])),
    style: style,
    onClick: onClickHandler,
    id: uniqueLabelId,
    children: children
  });
};

/* harmony default export */ __webpack_exports__["default"] = (LabelText);

/***/ }),

/***/ 19456:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _pageHeading_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9213);
/* harmony import */ var _pageHeading_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_pageHeading_module_scss__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_helperServices__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64036);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var PageHeading = function PageHeading(_ref) {
  var text = _ref.text,
      className = _ref.className,
      level = _ref.level,
      variant = _ref.variant,
      alignment = _ref.alignment,
      id = _ref.id;
  var heading;
  var variantClass = variant ? "page-heading--".concat(variant) : "";
  var newId = id ? id : "heading-" + text;

  var generateAlignment = function generateAlignment() {
    switch (alignment) {
      case "left":
      case "LEFT":
        return alignment ? "".concat((_pageHeading_module_scss__WEBPACK_IMPORTED_MODULE_2___default())["alignment--" + alignment.toLowerCase()]) : "";

      case "RIGHT":
      case "right":
        return alignment ? "".concat((_pageHeading_module_scss__WEBPACK_IMPORTED_MODULE_2___default())["alignment--" + alignment.toLowerCase()]) : "";

      default:
        return "".concat((_pageHeading_module_scss__WEBPACK_IMPORTED_MODULE_2___default()["alignment--center"]));
    }
  };

  switch (level) {
    case 4:
      heading = /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("label", {
        className: "".concat(className, " ").concat((_pageHeading_module_scss__WEBPACK_IMPORTED_MODULE_2___default())[variantClass], " ").concat(generateAlignment()),
        id: newId,
        dangerouslySetInnerHTML: (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_0__/* .createMarkup */ .KU)(text)
      });
      break;

    case 3:
      heading = /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("label", {
        className: "".concat(className, " ").concat((_pageHeading_module_scss__WEBPACK_IMPORTED_MODULE_2___default())[variantClass], " ").concat(generateAlignment()),
        id: newId,
        children: text
      });
      break;

    case 2:
      heading = /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h2", {
        className: "".concat((_pageHeading_module_scss__WEBPACK_IMPORTED_MODULE_2___default()["page-heading"]), " ").concat((_pageHeading_module_scss__WEBPACK_IMPORTED_MODULE_2___default()["page-heading--l2"]), " ").concat((_pageHeading_module_scss__WEBPACK_IMPORTED_MODULE_2___default())[variantClass], " ").concat(className),
        dangerouslySetInnerHTML: (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_0__/* .createMarkup */ .KU)(text),
        id: newId
      });
      break;

    default:
      heading = /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h1", {
        className: "".concat((_pageHeading_module_scss__WEBPACK_IMPORTED_MODULE_2___default()["page-heading"]), " ").concat(variantClass, " ").concat(className, " ").concat((_pageHeading_module_scss__WEBPACK_IMPORTED_MODULE_2___default())[variantClass]),
        id: newId,
        dangerouslySetInnerHTML: (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_0__/* .createMarkup */ .KU)(text)
      });
  }

  return heading;
};

PageHeading.defaultProps = {
  text: "",
  level: 1,
  className: "",
  variant: ""
};
/* harmony default export */ __webpack_exports__["Z"] = (PageHeading);

/***/ }),

/***/ 4648:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _tag_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58428);
/* harmony import */ var _tag_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_tag_module_scss__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _config_colors__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93957);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var Tag = function Tag(_ref) {
  var label = _ref.label,
      variant = _ref.variant,
      className = _ref.className,
      labelColor = _ref.labelColor;
  var labels = {
    custom: label,
    "brand-new": label || "Brand new",
    discount: label || "X% off",
    "device-deal": label || "Double device deal",
    "limited-offer": label || "Limited offer",
    "low-stock": label || "Low stock",
    "no-stock": label || "Out of stock",
    "on-backorder": label || "Currently on backorder",
    "pre-order": label || "Pre-order",
    "top-pick": label || "Top pick",
    "currently-viewing": label || "Currently viewing",
    "one-time-offer": label || "One-time offer",
    "today-only": label || "Today Only",
    "for-today-only": label || "For today only",
    "exclusive-to-online": label || "Exclusive to Online",
    "read-hot-dealz": label || "Red Hot Dealz",
    "red-hot-deal": label || "Red Hot Deal",
    "buy-one-get-one-free": label || "Buy One Get One Free",
    "Black-Friday": "Black Friday",
    "black-friday": label || "Black Friday",
    "badge-style-1": label || "badge-style-1",
    Recommended: label || "Recommended"
  };

  var colorValue = function colorValue(value, defaultColor) {
    switch (value) {
      case "no-stock":
        {
          return "".concat(_config_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"].Red75 */ .Z.Red75);
        }

      case "low-stock":
      case "on-backorder":
        {
          return "".concat(_config_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"].Yellow50 */ .Z.Yellow50);
        }

      case "discount":
      case "buy-one-get-one-free":
        {
          return "".concat(_config_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"].Teal51 */ .Z.Teal51);
        }

      case "pre-order":
        {
          return "".concat(_config_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"].Teal75 */ .Z.Teal75);
        }

      case "top-pick":
      case "Recommended":
        {
          return "".concat(_config_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"].Purple53 */ .Z.Purple53);
        }

      default:
        return defaultColor && defaultColor !== null ? defaultColor : labelColor;
    }
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
    id: labels[variant] ? "tag_".concat(labels[variant.toLowerCase()]) : "tag_".concat(label),
    className: "".concat((_tag_module_scss__WEBPACK_IMPORTED_MODULE_2___default().tag), " ").concat(className),
    style: {
      backgroundColor: labelColor && labelColor !== null ? colorValue(variant) : colorValue(variant, "".concat(_config_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"].Black40 */ .Z.Black40))
    },
    children: labels[variant] ? labels[variant.toLowerCase()] : label
  });
};

Tag.defaultProps = {
  variant: "custom",
  className: ""
};
/* harmony default export */ __webpack_exports__["Z"] = (Tag);

/***/ }),

/***/ 52441:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _ErrorCard_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(90609);
/* harmony import */ var _ErrorCard_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_ErrorCard_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _config_index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26125);
/* harmony import */ var _config_index__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_config_index__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21608);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(31555);
/* harmony import */ var _services_analyticsUtag__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69152);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);









var ErrorCard = function ErrorCard(_ref) {
  var errorMsg = _ref.errorMsg,
      fullWidth = _ref.fullWidth;
  var env = (_config_index__WEBPACK_IMPORTED_MODULE_0___default().env);
  var imagePrefix = (_config_index__WEBPACK_IMPORTED_MODULE_0___default().envConfigs)[env].imagePrefix;
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    if (errorMsg) {
      if (fullWidth === 1) {
        var heading = errorMsg.heading ? errorMsg.heading + ". " : "";
        var subHeading1 = errorMsg.subHeading1 ? errorMsg.subHeading1 + ". " : "";
        var subHeading2 = errorMsg.subHeading2 ? errorMsg.subHeading2 + ". " : "";
        _services_analyticsUtag__WEBPACK_IMPORTED_MODULE_1__/* .error */ .vU("".concat(heading).concat(subHeading1).concat(subHeading2));
      } else {
        _services_analyticsUtag__WEBPACK_IMPORTED_MODULE_1__/* .error */ .vU(errorMsg);
      }
    }
  }, []);

  var errorBlock = function errorBlock() {
    switch (fullWidth) {
      case 1:
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("img", {
            src: "".concat(imagePrefix, "/assets/images/close-black-icon.svg"),
            width: 66,
            height: 66
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
            className: (_ErrorCard_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["error-card__heading"]),
            children: errorMsg && errorMsg.heading ? errorMsg.heading : ''
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
            className: (_ErrorCard_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["error-card__subheading"]),
            children: errorMsg && errorMsg.subHeading1 ? errorMsg.subHeading1 : ''
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
            className: (_ErrorCard_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["error-card__subheading"]),
            children: errorMsg && errorMsg.subHeading2 ? errorMsg.subHeading2 : ''
          })]
        });

      default:
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
          className: (_ErrorCard_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["error-card-block"]),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
            className: (_ErrorCard_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["error-card-image"]),
            xs: 1,
            md: 1,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("img", {
              src: "".concat(imagePrefix, "/assets/images/close-black-icon.svg"),
              width: 27,
              height: 27
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
            className: (_ErrorCard_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["error-sub-text"]),
            xs: 11,
            md: 11,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("span", {
              children: errorMsg ? errorMsg : ''
            })
          })]
        });
    }
  };

  return errorBlock();
};

/* harmony default export */ __webpack_exports__["Z"] = (ErrorCard);

/***/ }),

/***/ 83318:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28658);
/* harmony import */ var _atoms_image_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39489);
/* harmony import */ var _IconWithText_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46043);
/* harmony import */ var _IconWithText_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_IconWithText_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);






var IconWithText = function IconWithText(_ref) {
  var icon = _ref.icon,
      value = _ref.value,
      description = _ref.description,
      className = _ref.className,
      imageClass = _ref.imageClass,
      valueStyle = _ref.valueStyle,
      typeStyle = _ref.typeStyle,
      descriptionStyle = _ref.descriptionStyle;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.CustomContainer, {
    className: "".concat((_IconWithText_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["detail-container"]), " ").concat(className),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_atoms_image_image__WEBPACK_IMPORTED_MODULE_1__["default"], {
      className: "".concat((_IconWithText_module_scss__WEBPACK_IMPORTED_MODULE_3___default().icon), " ").concat(imageClass),
      img_path: icon
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.CustomContainer, {
      className: "".concat((_IconWithText_module_scss__WEBPACK_IMPORTED_MODULE_3___default().description), " ").concat(descriptionStyle),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Text, {
        className: "".concat((_IconWithText_module_scss__WEBPACK_IMPORTED_MODULE_3___default().value), " ").concat(valueStyle),
        children: value
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Text, {
        className: "".concat((_IconWithText_module_scss__WEBPACK_IMPORTED_MODULE_3___default().type), " ").concat(typeStyle),
        children: description
      })]
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (IconWithText);

/***/ }),

/***/ 72210:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var errorMessages = {
  compare_count_desktop_err: "You can compare up to 3 products. Try removing one to add another.",
  compare_count_mobile_err: "You can compare up to 2 products. Try removing one to add another.",
  compare_category_err: "You can compare only products within same category.",
  not_allow_place_order: "Checkout is currently unavailable. Our team is aware of this issue and are working on it. Please try again later.",
  out_of_stock: {
    collect_info: "This order can be collected from a Vodacom Shop\nYou can choose between delivery or collection options during checkout",
    multicart_standalone_out_of_stock: "One or more of the products in your cart is currently out of stock. Please remove it in order to start checkout.",
    any_out_of_stock: "One or more of the products in your cart is currently out of stock. Please remove it in order to start checkout.",
    long_delivery: "One of the items in your cart is currently not available. Delivery of your whole order will take longer than usual since we’ll need to wait for this item to become available for dispatch."
  },
  checkout: {
    errors: {
      addressForm: {
        delivery: {
          addressName: "Please enter a name for this address",
          addressType: "Please select your address type",
          companyName: "Please enter your company name",
          addressLine1: "Please enter your postal address(Line 1)",
          addressLine2: "Please enter your postal address(Line 2)",
          unitNo: "Please enter a unit no.",
          floorNo: "Please enter a unit / floor no.",
          complexName: "Please enter your complex name",
          officeComplexName: "Please enter your office park / building name",
          streetNo: "Please enter your street no.",
          streetName: "Please enter your street name",
          suburb: "Please enter and select suburb",
          postalCode: "Please enter your postal code",
          town: "Please enter your town/city name",
          province: "Please select your province",
          instructions: "Please enter special instructions"
        },
        billing: {
          addressName: "Please enter a name for this address",
          addressType: "Please select your address type",
          companyName: "Please enter your company name",
          addressLine1: "Please enter your postal address(Line 1)",
          addressLine2: "Please enter your postal address(Line 2)",
          unitNo: "Please enter a unit no.",
          floorNo: "Please enter a unit / floor no.",
          complexName: "Please enter your complex name",
          officeComplexName: "Please enter your office park / building name",
          streetNo: "Please enter your street no.",
          streetName: "Please enter your street name",
          suburb: "Please enter and select suburb",
          postalCode: "Please enter your postal code",
          town: "Please enter your town/city name",
          province: "Please select your province",
          instructions: "Please enter special instructions"
        },
        companyInformation: {
          addressName: "Please enter a name for this address",
          addressType: "Please select your address type",
          companyName: "Please enter your company name",
          addressLine1: "Please enter your postal address(Line 1)",
          addressLine2: "Please enter your postal address(Line 2)",
          unitNo: "Please enter a unit no.",
          floorNo: "Please enter a unit / floor no.",
          complexName: "Please enter your complex name",
          officeComplexName: "Please enter your office park / building name",
          streetNo: "Please enter your street no.",
          streetName: "Please enter your street name",
          suburb: "Please enter and select suburb",
          postalCode: "Please enter your postal code",
          town: "Please enter your town/city name",
          province: "Please select your province",
          instructions: "Please enter special instructions",
          companyVatName: "Please enter your company name",
          companyVatNumber: "Please enter your company VAT number"
        },
        details: {
          firstName: "Please enter your first name",
          surName: "Please enter your surname",
          cellNumber: "Please enter your cellphone number",
          email: "Please enter your email address"
        },
        contactDetails: {
          firstName: "Please enter your first name",
          surName: "Please enter your surname",
          cellNumber: "Please enter a cellphone number"
        },
        instructions: {
          instructions: "Please enter special instructions"
        }
      }
    },
    delivery: {
      unitNo: {
        onlyNumber: "Unit no. should be a number"
      },
      floorNo: {
        onlyNumber: "Unit / Floor no. should be a number"
      },
      streetNo: {
        onlyValid: "Please enter a valid street number"
      },
      streetName: {
        onlyValid: "This field cannot contain special characters"
      },
      postalCode: {
        onlyNumber: "Postal code should be a number",
        onlyValid: "Please enter valid postal code"
      }
    },
    billing: {
      unitNo: {
        onlyNumber: "Unit no. should be a number"
      },
      floorNo: {
        onlyNumber: "Unit / Floor no. should be a number"
      },
      streetNo: {
        onlyValid: "Please enter a valid street number"
      },
      streetName: {
        onlyValid: "This field cannot contain special characters"
      },
      postalCode: {
        onlyNumber: "Postal code should be a number",
        onlyValid: "Please enter valid postal code"
      }
    },
    details: {
      firstName: {
        minCharacters: "Must be longer than 2 characters"
      },
      surName: {
        minCharacters: "Must be longer than 2 characters"
      },
      email: {
        onlyValid: "Invalid email address"
      },
      cellNumber: {
        onlyNumber: "This field should only contain numbers",
        startWith: "Cellphone number must start with 0 or 27"
      }
    },
    contactDetails: {
      firstName: {
        minCharacters: "Must be longer than 2 characters"
      },
      surName: {
        minCharacters: "Must be longer than 2 characters"
      },
      cellNumber: {
        onlyNumber: "This field should only contain numbers",
        startWith: "Cellphone number must start with 0 or 27"
      }
    }
  },
  staticFormfieldErrorsMessage: {
    upgradeNumber: {
      cellNumber: "Please enter your cellphone number"
    },
    specialNeeds: {
      name: "Please enter your first name",
      surName: "Please enter your surname",
      cellNumber: "Please enter your cellphone number",
      email: "Please enter your email address",
      confirmEmail: "Please enter your email address",
      contact: "Please select your contact",
      document: "Please upload your document"
    },
    nextLevel: {
      name: "Please enter your first name",
      surName: "Please enter your surname",
      cellNumber: "Please enter your cellphone number",
      email: "Please enter your email address",
      confirmEmail: "Please enter your email address",
      saId: "Please enter your Id number"
    },
    ecommerce: {
      name: "Please enter your first name",
      surName: "Please enter your surname",
      cellNumber: "Please enter your cellphone number",
      email: "Please enter your email address",
      confirmEmail: "Please enter your email address"
    }
  },
  checkoutAuthentication: {
    errors: {
      auth: {
        idType: "Please select your ID type",
        idNumber: "Please enter your ID number",
        cellNumber: "Please enter your cellphone number",
        passportNumber: "Please enter your passport number",
        passportExpiry: "Please enter your passport expiry date",
        countryOrigin: "Please select a country of origin"
      }
    },
    idNumber: {
      onlyNumber: "This field should only contain numbers",
      minCharacters: "Please enter at least 13 characters"
    },
    cellNumber: {
      onlyNumber: "This field should only contain numbers",
      startWith: "Cellphone number must start with 0 or 27"
    },
    passportNumber: {
      onlyValid: "Please enter a valid passport number"
    },
    passportExpiry: {
      onlyValid: "Please enter a valid passport expiry date",
      sixMonthsExpiry: "Passport expiry date shouldn't be less than 6 months"
    }
  },
  creditCheckout: {
    errors: {
      personal: {
        personalDetails: {
          title: "Please select your title",
          initials: "Please enter your initials",
          firstName: "Please enter your first name",
          surName: "Please enter your last name",
          gender: "Please enter your gender",
          dob: "Please enter your date of birth",
          maritalStatus: "Please select your marital status"
        }
      },
      contact: {
        contactDetails: {
          cellNumber: "Please enter your cellphone number",
          emailAddress: "Please enter your email address"
        }
      },
      employment: {
        employmentDetails: {
          employerName: "Please enter your employer's name",
          employerNumber: "Please enter your employer's number",
          employmentType: "Please select your employment type",
          employmentCategory: "Please select your employment category",
          occupation: "Please select your occupation",
          salaryDate: "Please select your salary date",
          grossMonthlySalary: "Please enter your monthly salary before tax"
        }
      },
      home: {
        homeDetails: {
          unitNo: "Please enter a unit no.",
          complexName: "Please enter your complex name",
          streetNo: "Please enter your street no.",
          streetName: "Please enter your street name",
          suburb: "Please enter your suburb",
          postalCode: "Please enter your postal code",
          province: "Please select your province",
          residence: "Please select do you own or rent this property",
          town: "Please enter your town/city name",
          currentAddressPeriod: "Please enter a valid number of years and months",
          previousAddressPeriod: "Please enter a valid number of years and months"
        }
      },
      debit: {
        debitDetails: {
          bank: "Please select your bank",
          accountType: "Please select the type of account this is",
          accountNumber: "Please enter your account number",
          initials: "Please enter valid initials",
          surname: "Please enter valid surname",
          duration: "Please enter a valid number of years and months",
          debitOrderDate: "Please select the debit order date you’d prefer",
          branchName: "Please enter branch name ",
          branchCode: "Please enter your branch code"
        }
      },
      delivery: {
        deliveryDetails: {
          addressName: "Please enter a name for this address",
          addressType: "Please select your address type",
          companyName: "Please enter your company name",
          unitNo: "Please enter a unit no.",
          floorNo: "Please enter a unit / floor no.",
          complexName: "Please enter your complex name",
          officeComplexName: "Please enter your office park / building name",
          streetNo: "Please enter your street no.",
          streetName: "Please enter your street name",
          suburb: "Please enter and select suburb",
          postalCode: "Please enter your postal code",
          town: "Please enter your town/city name",
          province: "Please select your province"
        }
      }
    },
    personalDetails: {
      initials: {
        onlyValid: "Please enter valid initials"
      },
      firstName: {
        onlyValid: "Please enter a valid name",
        minCharacters: "Your first name should contain more than 2 characters"
      },
      surName: {
        onlyValid: "Please enter a valid name",
        minCharacters: "Your last name should contain more than 2 characters"
      },
      dob: {
        onlyValid: "Please enter a valid date of birth",
        minAge: "Please note that you must be over 18 to apply for a contract"
      },
      gender: {
        matchValue: "Title does not match gender"
      }
    },
    employmentDetails: {
      grossMonthlySalary: {
        onlyValid: "Please enter a valid salary amount",
        onlyZero: "This amount must be more than R0"
      },
      employerNumber: {
        onlyNumber: "This field should only contain numbers",
        startWith: "Employer's number must start with 0 or 27"
      }
    },
    homeDetails: {
      unitNo: {
        onlyNumber: "Unit no. should be a number"
      },
      streetNo: {
        onlyValid: "Please enter a valid street number"
      },
      streetName: {
        onlyValid: "This field cannot contain special characters"
      },
      postalCode: {
        onlyNumber: "Postal code should be a number",
        onlyValid: "Please enter valid postal code"
      },
      currentAddressPeriod: {
        onlyValid: "Please enter a valid number of years and months"
      },
      previousAddressPeriod: {
        onlyValid: "Please enter a valid number of years and months"
      }
    },
    debitDetails: {
      accountNumber: {
        onlyValid: "Please enter valid account number"
      },
      duration: {
        onlyValid: "Please enter a valid number of years and months"
      },
      branchCode: {
        onlyValid: "Please enter valid branch code"
      }
    },
    deliveryDetails: {
      unitNo: {
        onlyNumber: "Unit no. should be a number"
      },
      floorNo: {
        onlyNumber: "Unit / Floor no. should be a number"
      },
      streetNo: {
        onlyValid: "Please enter a valid street number"
      },
      streetName: {
        onlyValid: "This field cannot contain special characters"
      },
      postalCode: {
        onlyNumber: "Postal code should be a number",
        onlyValid: "Please enter valid postal code"
      }
    },
    contactDetails: {
      emailAddress: {
        onlyValid: "Invalid format. Please check your email address."
      },
      cellNumber: {
        onlyNumber: "This field should only contain numbers",
        startWith: "Cellphone number must start with 0 or 27"
      }
    }
  }
};
/* harmony default export */ __webpack_exports__["Z"] = (errorMessages);

/***/ }),

/***/ 23390:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ cart; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(27812);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./Redux/actions/cartAction.js
var cartAction = __webpack_require__(35311);
// EXTERNAL MODULE: ./Redux/actions/commonAction.js
var commonAction = __webpack_require__(88093);
// EXTERNAL MODULE: ./Redux/actions/navAction.js
var navAction = __webpack_require__(42220);
// EXTERNAL MODULE: ./Redux/actionTypes/index.js
var actionTypes = __webpack_require__(1369);
// EXTERNAL MODULE: ./Redux/actions/userProfileAction.js + 2 modules
var userProfileAction = __webpack_require__(15623);
// EXTERNAL MODULE: ./Redux/actions/getHelpAction.js
var getHelpAction = __webpack_require__(87524);
// EXTERNAL MODULE: ./Redux/actions/geoLocationAction.js
var geoLocationAction = __webpack_require__(28935);
// EXTERNAL MODULE: ./services/analyticsUtag.js
var analyticsUtag = __webpack_require__(69152);
// EXTERNAL MODULE: ./services/pageService.js
var pageService = __webpack_require__(76173);
// EXTERNAL MODULE: ./services/upgradeService.js
var upgradeService = __webpack_require__(70098);
// EXTERNAL MODULE: ./services/vasDataService.js
var vasDataService = __webpack_require__(10686);
// EXTERNAL MODULE: ./utils/ajaxServices.js + 6 modules
var ajaxServices = __webpack_require__(18517);
// EXTERNAL MODULE: ./utils/helperServices.js + 3 modules
var helperServices = __webpack_require__(64036);
// EXTERNAL MODULE: ./config/index.js
var config = __webpack_require__(26125);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ./config/labels.js
var labels = __webpack_require__(99599);
// EXTERNAL MODULE: ./config/errorMessages.js
var errorMessages = __webpack_require__(72210);
// EXTERNAL MODULE: ./config/queries.js
var queries = __webpack_require__(91250);
// EXTERNAL MODULE: ./node_modules/cookie/index.js
var cookie = __webpack_require__(76489);
;// CONCATENATED MODULE: ./lib/parseCookies.js

function parseCookies(req) {
  return cookie.parse(req ? req.headers.cookie || '' : document.cookie);
}
// EXTERNAL MODULE: ./components/atoms/DependencyHelper.js + 81 modules
var DependencyHelper = __webpack_require__(28658);
// EXTERNAL MODULE: ./components/atoms/loginModal/LoginModal.jsx
var LoginModal = __webpack_require__(24671);
// EXTERNAL MODULE: ./components/atoms/pageHeading/PageHeading.jsx
var PageHeading = __webpack_require__(19456);
// EXTERNAL MODULE: ./components/molecules/errorCard/ErrorCard.jsx
var ErrorCard = __webpack_require__(52441);
// EXTERNAL MODULE: ./components/atoms/infoBox/InfoBox.js
var InfoBox = __webpack_require__(91566);
// EXTERNAL MODULE: ./components/atoms/label/LabelText.jsx
var LabelText = __webpack_require__(38975);
// EXTERNAL MODULE: ./components/atoms/image/image.jsx + 1 modules
var image_image = __webpack_require__(39489);
// EXTERNAL MODULE: ./components/atoms/infoClickCollect/InfoClickCollect.module.scss
var InfoClickCollect_module = __webpack_require__(36345);
var InfoClickCollect_module_default = /*#__PURE__*/__webpack_require__.n(InfoClickCollect_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/atoms/infoClickCollect/InfoClickCollect.js








var InfoClickCollect = function InfoClickCollect(_ref) {
  var className = _ref.className,
      type = _ref.type,
      text = _ref.text,
      imageSrc = _ref.imageSrc,
      imageWidth = _ref.imageWidth,
      imageHeight = _ref.imageHeight;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
    className: "".concat((InfoClickCollect_module_default())["info-click-collect"], " ").concat((InfoClickCollect_module_default())[type], " ").concat(className),
    children: [imageSrc && /*#__PURE__*/(0,jsx_runtime.jsx)(image_image["default"], {
      className: (InfoClickCollect_module_default())["info-click-collect--img"],
      img_path: imageSrc,
      img_width: imageWidth,
      img_height: imageHeight,
      img_alt: type || "icon"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(LabelText["default"], {
      className: (InfoClickCollect_module_default())["info-click-collect--label"],
      children: text
    })]
  });
};

InfoClickCollect.defaultProps = {
  className: "info-click-collect",
  type: "info",
  text: "",
  imageSrc: "",
  imageWidth: "1.3125rem",
  imageHeight: "1.3125rem"
};
/* harmony default export */ var infoClickCollect_InfoClickCollect = (InfoClickCollect);
// EXTERNAL MODULE: ./components/atoms/Seo/Seo.js
var Seo = __webpack_require__(22505);
// EXTERNAL MODULE: ./components/atoms/buttons/backButton/BackButton.jsx
var BackButton = __webpack_require__(14413);
// EXTERNAL MODULE: ./services/labelBackgroundService.js
var labelBackgroundService = __webpack_require__(24795);
// EXTERNAL MODULE: ./components/atoms/stepCounter/StepCounter.jsx
var StepCounter = __webpack_require__(67433);
// EXTERNAL MODULE: ./components/atoms/buttons/buttonWithIcon/ButtonWithIcon.jsx
var ButtonWithIcon = __webpack_require__(30390);
// EXTERNAL MODULE: ./components/atoms/tag/Tag.jsx
var Tag = __webpack_require__(4648);
// EXTERNAL MODULE: ./components/molecules/iconWithText/IconWithText.jsx
var IconWithText = __webpack_require__(83318);
// EXTERNAL MODULE: ./components/molecules/cartProductOptions/CartProductOptions.jsx
var CartProductOptions = __webpack_require__(91710);
// EXTERNAL MODULE: ./components/molecules/changeLabel/ChangeLabelWithOutOfStock.jsx
var ChangeLabelWithOutOfStock = __webpack_require__(61492);
// EXTERNAL MODULE: ./config/types.js
var types = __webpack_require__(69842);
// EXTERNAL MODULE: ./components/molecules/cartProductCard/CartProductCard.module.scss
var CartProductCard_module = __webpack_require__(50641);
var CartProductCard_module_default = /*#__PURE__*/__webpack_require__.n(CartProductCard_module);
;// CONCATENATED MODULE: ./components/molecules/cartProductCard/CartProductCard.jsx




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }


























var CartProductCard = function CartProductCard(_ref) {
  var _cartProduct$product, _cartProduct$product51, _cartProduct$product54, _attributesForDeal$it, _attributesForDeal$at, _attributesForDeal$at2, _attributesForDeal$at3, _cartProduct$config_c, _cartProduct$config_c2, _cartProduct$config_c3, _cartProduct$config_c4, _cartProduct$config_c5, _cartProduct$config_c6, _vasDescription, _cartProduct$config_c7, _cartProduct$config_c8, _cartProduct$config_c9, _cartProduct$config_c10, _cartProduct$config_c11, _cartProduct$config_c12;

  var cartProductItems = _ref.cartProductItems,
      dealSku = _ref.dealSku,
      cartProduct = _ref.cartProduct,
      totalQuantity = _ref.totalQuantity,
      _removeCartProduct = _ref.removeCartProduct,
      _updateCartProduct = _ref.updateCartProduct;

  var _useState = (0,react.useState)(false),
      showModal = _useState[0],
      setShowModal = _useState[1];

  var _useState2 = (0,react.useState)(false),
      modalShow = _useState2[0],
      setModalShow = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      updatePage = _useState3[0],
      setUpdatePage = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      showDeal = _useState4[0],
      setShowDeal = _useState4[1];

  var _useState5 = (0,react.useState)(null),
      attributesForDeal = _useState5[0],
      setAttributesForDeal = _useState5[1];

  var router = (0,DependencyHelper.useRouter)();
  var dispatch = (0,es/* useDispatch */.I0)();

  var setLoadingState = function setLoadingState(isLoading) {
    return dispatch({
      type: actionTypes/* SET_IS_LOADING */.GA,
      payload: isLoading
    });
  };

  var isMobile = (0,helperServices/* componentResize */.Y4)();
  var env = (config_default()).env;
  var imagePrefix = (config_default()).envConfigs[env].imagePrefix;
  var urlPrefix = (config_default()).envConfigs[env].shoppingUrlPrefix;

  var _ref2 = (cartProduct === null || cartProduct === void 0 ? void 0 : cartProduct.product) || {},
      name = _ref2.name,
      __typename = _ref2.__typename;

  var _ref3 = (cartProduct === null || cartProduct === void 0 ? void 0 : cartProduct.prices) || {},
      row_total_including_tax = _ref3.row_total_including_tax,
      row_total_original = _ref3.row_total_original;

  var isDealProduct = (cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product = cartProduct.product) === null || _cartProduct$product === void 0 ? void 0 : _cartProduct$product.is_deal_product) === 1;
  var isVASProduct = false;

  if (cartProduct !== null && cartProduct !== void 0 && cartProduct.parent_product_sku) {
    dealSku.forEach(function (prodSku) {
      if (prodSku && (cartProduct === null || cartProduct === void 0 ? void 0 : cartProduct.parent_product_sku) == prodSku) {
        isVASProduct = true;
      }
    });
  }

  var paymentTerms = null;

  if (isVASProduct) {
    var _dealProduct$, _dealProduct$$product;

    var dealProduct = cartProductItems.filter(function (cartProduct) {
      var _cartProduct$product2;

      return (cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product2 = cartProduct.product) === null || _cartProduct$product2 === void 0 ? void 0 : _cartProduct$product2.is_deal_product) === 1;
    });
    paymentTerms = (_dealProduct$ = dealProduct[0]) === null || _dealProduct$ === void 0 ? void 0 : (_dealProduct$$product = _dealProduct$.product) === null || _dealProduct$$product === void 0 ? void 0 : _dealProduct$$product.payment_terms_label;
  }

  var handleTermLinkClick = function handleTermLinkClick() {
    var pageName = analyticsUtag/* getUtagData */.GS(["page_name"]).page_name;
    analyticsUtag/* link */.p4({
      link_type: "o",
      page_tool_event: "use",
      page_tool_name: "".concat(pageName, ": vodasure ").concat(name, " T&Cs apply")
    });
  };

  var optList = [];

  if (__typename === labels/* default.lbl_product_typeName_configurable */.Z.lbl_product_typeName_configurable && cartProduct.product.variants !== undefined && cartProduct.product.variants.length > 0) {
    var _cartProduct$product3;

    var optionsList = cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product3 = cartProduct.product) === null || _cartProduct$product3 === void 0 ? void 0 : _cartProduct$product3.configurable_options.map(function (val) {
      var _ref4 = val || {},
          attribute_code = _ref4.attribute_code,
          attribute_id = _ref4.attribute_id;

      var obj = {
        attribute_code: attribute_code,
        attribute_id: attribute_id
      };
      return obj;
    });
    var productOptions;

    try {
      var _cartProduct$product4, _cartProduct$product5, _cartProduct$product6, _cartProduct$product7, _cartProduct$product8, _cartProduct$product9;

      if ((cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product4 = cartProduct.product) === null || _cartProduct$product4 === void 0 ? void 0 : (_cartProduct$product5 = _cartProduct$product4.configurable_options) === null || _cartProduct$product5 === void 0 ? void 0 : (_cartProduct$product6 = _cartProduct$product5[1]) === null || _cartProduct$product6 === void 0 ? void 0 : _cartProduct$product6.position) > (cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product7 = cartProduct.product) === null || _cartProduct$product7 === void 0 ? void 0 : (_cartProduct$product8 = _cartProduct$product7.configurable_options) === null || _cartProduct$product8 === void 0 ? void 0 : (_cartProduct$product9 = _cartProduct$product8[0]) === null || _cartProduct$product9 === void 0 ? void 0 : _cartProduct$product9.position)) {
        var _cartProduct$product10;

        productOptions = cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product10 = cartProduct.product) === null || _cartProduct$product10 === void 0 ? void 0 : _cartProduct$product10.configurable_options.sort(function (a, b) {
          return b.position - a.position;
        });
      } else {
        var _cartProduct$product11;

        productOptions = cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product11 = cartProduct.product) === null || _cartProduct$product11 === void 0 ? void 0 : _cartProduct$product11.configurable_options;
      }
    } catch (error) {
      var _cartProduct$product12;

      productOptions = cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product12 = cartProduct.product) === null || _cartProduct$product12 === void 0 ? void 0 : _cartProduct$product12.configurable_options;
    }

    optionsList.forEach(function (option) {
      var _cartProduct$product13;

      var optionVal = (0,helperServices/* options */.YM)(productOptions, option.attribute_code).map(function (opt) {
        var _ref5 = opt || {},
            label = _ref5.label,
            swatch_data = _ref5.swatch_data,
            value_index = _ref5.value_index;

        var obj = {
          label: label,
          swatch_data: swatch_data,
          value_index: value_index,
          attribute_id: option.attribute_id
        };
        return obj;
      });
      var variantsProducts = cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product13 = cartProduct.product) === null || _cartProduct$product13 === void 0 ? void 0 : _cartProduct$product13.variants;
      var inStockOptionList = {};

      var _iterator = _createForOfIteratorHelper(optionVal),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var oVal = _step.value;

          var _iterator2 = _createForOfIteratorHelper(variantsProducts),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var variant = _step2.value;

              var _iterator3 = _createForOfIteratorHelper(variant.attributes),
                  _step3;

              try {
                for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                  var attr = _step3.value;

                  if (oVal.label === attr.label && (variant.product.stock_status === labels/* default.lbl_in_stock */.Z.lbl_in_stock || variant.product.quantity > 0)) {
                    inStockOptionList[oVal.value_index] = oVal;
                  }
                }
              } catch (err) {
                _iterator3.e(err);
              } finally {
                _iterator3.f();
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      var optionObj = {};
      optionObj[option.attribute_code] = Object.values(inStockOptionList);
      optList.push(optionObj);
    });
  }

  var cartId;
  var regularPrice, regularPriceString, finalPrice, finalPriceString, selectedVariant, small_image, promoTag, promoBadge, lowStockFlag, lowStockCount, promoForDeal, nonPromoArray, vasDescription, vasTermLink;
  var cartProductQuantity = cartProduct === null || cartProduct === void 0 ? void 0 : cartProduct.quantity;
  var optionObj = {};

  if (__typename === labels/* default.lbl_product_typeName_configurable */.Z.lbl_product_typeName_configurable && cartProduct.product.variants !== undefined && cartProduct.product.variants.length > 0) {
    var _cartProduct$product15, _selectedVariant, _selectedVariant$prod, _selectedVariant$prod2, _cartProduct$product16, _cartProduct$product17, _selectedVariant2, _selectedVariant3, _selectedVariant3$pro;

    var getLabel = function getLabel(label) {
      var _cartProduct$product14;

      var headingObj = cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product14 = cartProduct.product) === null || _cartProduct$product14 === void 0 ? void 0 : _cartProduct$product14.configurable_options.find(function (config) {
        return config.attribute_code === label[0];
      });
      return headingObj === null || headingObj === void 0 ? void 0 : headingObj.label;
    };

    optList.forEach(function (obj) {
      cartProduct === null || cartProduct === void 0 ? void 0 : cartProduct.configurable_options.forEach(function (addedOption) {
        if (getLabel(Object.keys(obj)) === addedOption.option_label) {
          optionObj[Object.keys(obj)] = addedOption.value_label;
        }
      });
    });
    selectedVariant = (0,helperServices/* getSelectedVariant */.c)(cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product15 = cartProduct.product) === null || _cartProduct$product15 === void 0 ? void 0 : _cartProduct$product15.variants, optionObj);
    small_image = (_selectedVariant = selectedVariant) === null || _selectedVariant === void 0 ? void 0 : (_selectedVariant$prod = _selectedVariant.product) === null || _selectedVariant$prod === void 0 ? void 0 : (_selectedVariant$prod2 = _selectedVariant$prod.small_image) === null || _selectedVariant$prod2 === void 0 ? void 0 : _selectedVariant$prod2.url;
    promoTag = cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product16 = cartProduct.product) === null || _cartProduct$product16 === void 0 ? void 0 : _cartProduct$product16.promotion_tag_label;
    promoBadge = cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product17 = cartProduct.product) === null || _cartProduct$product17 === void 0 ? void 0 : _cartProduct$product17.promotion_tag;
    lowStockFlag = (0,helperServices/* checkIsLowStock */.yB)((_selectedVariant2 = selectedVariant) === null || _selectedVariant2 === void 0 ? void 0 : _selectedVariant2.product);
    lowStockCount = (_selectedVariant3 = selectedVariant) === null || _selectedVariant3 === void 0 ? void 0 : (_selectedVariant3$pro = _selectedVariant3.product) === null || _selectedVariant3$pro === void 0 ? void 0 : _selectedVariant3$pro.quantity;
  } else {
    var _cartProduct$product18, _cartProduct$product19, _cartProduct$product20, _cartProduct$product21, _cartProduct$product22;

    small_image = cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product18 = cartProduct.product) === null || _cartProduct$product18 === void 0 ? void 0 : (_cartProduct$product19 = _cartProduct$product18.small_image) === null || _cartProduct$product19 === void 0 ? void 0 : _cartProduct$product19.url;
    promoTag = cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product20 = cartProduct.product) === null || _cartProduct$product20 === void 0 ? void 0 : _cartProduct$product20.promotion_tag_label;
    promoBadge = cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product21 = cartProduct.product) === null || _cartProduct$product21 === void 0 ? void 0 : _cartProduct$product21.promotion_tag;
    lowStockFlag = (0,helperServices/* checkIsLowStock */.yB)(cartProduct === null || cartProduct === void 0 ? void 0 : cartProduct.product);
    lowStockCount = cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product22 = cartProduct.product) === null || _cartProduct$product22 === void 0 ? void 0 : _cartProduct$product22.quantity;
  }

  if (isDealProduct || isVASProduct) {
    var _cartProduct$product23, _cartProduct$product24, _cartProduct$product25, _cartProduct$product26;

    finalPrice = isDealProduct ? cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product23 = cartProduct.product) === null || _cartProduct$product23 === void 0 ? void 0 : _cartProduct$product23.monthly_recurring : cartProduct === null || cartProduct === void 0 ? void 0 : cartProduct.monthly_recurring;
    regularPrice = cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product24 = cartProduct.product) === null || _cartProduct$product24 === void 0 ? void 0 : _cartProduct$product24.old_monthly_recurring;
    finalPriceString = "R".concat((0,helperServices/* formatNumbersWithComma */.G0)(finalPrice), " \xD7 ").concat(paymentTerms == null ? cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product25 = cartProduct.product) === null || _cartProduct$product25 === void 0 ? void 0 : _cartProduct$product25.payment_terms_label : paymentTerms);
    regularPriceString = "R".concat((0,helperServices/* formatNumbersWithComma */.G0)(regularPrice), " \xD7 ").concat(paymentTerms == null ? cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product26 = cartProduct.product) === null || _cartProduct$product26 === void 0 ? void 0 : _cartProduct$product26.payment_terms_label : paymentTerms);
    lowStockFlag = false;

    if (isDealProduct) {
      var _cartProduct$product27, _cartProduct$product28, _cartProduct$product29, _cartProduct$product30, _cartProduct$product31, _cartProduct$product32;

      promoForDeal = cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product27 = cartProduct.product) === null || _cartProduct$product27 === void 0 ? void 0 : (_cartProduct$product28 = _cartProduct$product27.items) === null || _cartProduct$product28 === void 0 ? void 0 : (_cartProduct$product29 = _cartProduct$product28.find(function (deal) {
        return deal.title === "Promo";
      })) === null || _cartProduct$product29 === void 0 ? void 0 : (_cartProduct$product30 = _cartProduct$product29.options[0]) === null || _cartProduct$product30 === void 0 ? void 0 : _cartProduct$product30.label;
      var nonPromoValues = cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product31 = cartProduct.product) === null || _cartProduct$product31 === void 0 ? void 0 : (_cartProduct$product32 = _cartProduct$product31.items) === null || _cartProduct$product32 === void 0 ? void 0 : _cartProduct$product32.filter(function (deal) {
        return deal.title !== "Promo" && deal.title !== "Smartphones";
      });
      nonPromoArray = nonPromoValues === null || nonPromoValues === void 0 ? void 0 : nonPromoValues.map(function (nPmv) {
        return nPmv.options.reduce(function (prouctAcc, prod) {
          if ((prod === null || prod === void 0 ? void 0 : prod.is_hidden_product) === "0") {
            prouctAcc.push(prod.label);
          }

          return prouctAcc;
        }, []);
      }).flat();
    }

    if (isVASProduct) {
      var _cartProduct$product33, _cartProduct$product34, _cartProduct$product35, _cartProduct$product37, _cartProduct$product38;

      var categories = cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product33 = cartProduct.product) === null || _cartProduct$product33 === void 0 ? void 0 : _cartProduct$product33.categories.sort(function (a, b) {
        return b.level - a.level;
      })[0];
      vasDescription = cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product34 = cartProduct.product) === null || _cartProduct$product34 === void 0 ? void 0 : _cartProduct$product34.description;

      if (cartProduct !== null && cartProduct !== void 0 && (_cartProduct$product35 = cartProduct.product) !== null && _cartProduct$product35 !== void 0 && _cartProduct$product35.promotion_link) {
        var _cartProduct$product36;

        vasTermLink = cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product36 = cartProduct.product) === null || _cartProduct$product36 === void 0 ? void 0 : _cartProduct$product36.promotion_link;
      } else {
        vasTermLink = categories !== null && categories !== void 0 && categories.category_url ? categories === null || categories === void 0 ? void 0 : categories.category_url : "#";
      }

      if (cartProduct !== null && cartProduct !== void 0 && (_cartProduct$product37 = cartProduct.product) !== null && _cartProduct$product37 !== void 0 && _cartProduct$product37.image.url.match("No_image") || (cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product38 = cartProduct.product) === null || _cartProduct$product38 === void 0 ? void 0 : _cartProduct$product38.image.url) == null) {
        small_image = categories === null || categories === void 0 ? void 0 : categories.image;
      } else {
        var _cartProduct$product39;

        small_image = cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product39 = cartProduct.product) === null || _cartProduct$product39 === void 0 ? void 0 : _cartProduct$product39.image.url;
      }
    } else {
      var _cartProduct$product40;

      small_image = cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product40 = cartProduct.product) === null || _cartProduct$product40 === void 0 ? void 0 : _cartProduct$product40.primary_product_image;
    }
  } else {
    finalPrice = row_total_including_tax === null || row_total_including_tax === void 0 ? void 0 : row_total_including_tax.value;
    regularPrice = row_total_original === null || row_total_original === void 0 ? void 0 : row_total_original.value;
    finalPriceString = "R".concat((0,helperServices/* formatNumbersWithComma */.G0)(finalPrice));
    regularPriceString = "R".concat((0,helperServices/* formatNumbersWithComma */.G0)(regularPrice));
  }

  var renderPage = function renderPage() {
    setUpdatePage(true);
  };

  (0,react.useEffect)(function () {
    setUpdatePage(false);
  }, [updatePage]);

  var removeProductFromCart = /*#__PURE__*/function () {
    var _ref6 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var _cartProduct$product41, _cartProduct$product42, _cartProduct$product43, _cartProduct$product44, _cartProduct$product45, _cartProduct$product46, _cartProduct$product47;

      var analyticsData, _cartProduct$product48;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              cartId = (0,helperServices/* getCookieValue */.Do)("cart_id");
              _context.next = 3;
              return _removeCartProduct(cartId, cartProduct.id, cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product41 = cartProduct.product) === null || _cartProduct$product41 === void 0 ? void 0 : _cartProduct$product41.name, cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product42 = cartProduct.product) === null || _cartProduct$product42 === void 0 ? void 0 : _cartProduct$product42.is_deal_product);

            case 3:
              analyticsData = _objectSpread({
                sales_event: "cart_remove",
                sales_order_discount: [(0,helperServices/* getAmountOffValue */.Dd)(cartProduct === null || cartProduct === void 0 ? void 0 : cartProduct.product)],
                page_name: "shopping: cart",
                page_channel: "shopping",
                page_master_tab: "personal",
                sales_product_category: [cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product43 = cartProduct.product) === null || _cartProduct$product43 === void 0 ? void 0 : (_cartProduct$product44 = _cartProduct$product43.categories) === null || _cartProduct$product44 === void 0 ? void 0 : (_cartProduct$product45 = _cartProduct$product44[0]) === null || _cartProduct$product45 === void 0 ? void 0 : _cartProduct$product45.name],
                sales_product_id: [cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product46 = cartProduct.product) === null || _cartProduct$product46 === void 0 ? void 0 : _cartProduct$product46.name],
                sales_product_price: [finalPrice],
                sales_product_quantity: [cartProductQuantity]
              }, analyticsUtag/* getUtagData */.GS(["visitor_login_status", "visitor_subscription_type", "visitor_msisdn_hash", "visitor_id_hash"]));
              analyticsData.link_type = "o";
              analyticsData.link_name = "shopping: cart: remove";

              if (cartProduct !== null && cartProduct !== void 0 && (_cartProduct$product47 = cartProduct.product) !== null && _cartProduct$product47 !== void 0 && _cartProduct$product47.promotion_tag_label) {
                analyticsData.sales_promo_name = [cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product48 = cartProduct.product) === null || _cartProduct$product48 === void 0 ? void 0 : _cartProduct$product48.promotion_tag_label];
              }

              analyticsUtag/* link */.p4(analyticsData);

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function removeProductFromCart() {
      return _ref6.apply(this, arguments);
    };
  }();

  var stepIncrement = /*#__PURE__*/function () {
    var _ref7 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
      var qty;
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              cartId = (0,helperServices/* getCookieValue */.Do)("cart_id");
              qty = cartProductQuantity + 1;
              _context2.next = 4;
              return _updateCartProduct(cartId, cartProduct.id, qty);

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function stepIncrement() {
      return _ref7.apply(this, arguments);
    };
  }();

  var stepDecrement = /*#__PURE__*/function () {
    var _ref8 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3() {
      var qty, _cartProduct$product49, _cartProduct$product50;

      return regenerator_default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              cartId = (0,helperServices/* getCookieValue */.Do)("cart_id");

              if (!(cartProductQuantity > 1)) {
                _context3.next = 10;
                break;
              }

              qty = cartProductQuantity - 1;

              if (!(isDealProduct || isVASProduct)) {
                _context3.next = 8;
                break;
              }

              _context3.next = 6;
              return _updateCartProduct(cartId, cartProduct.id, qty, cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product49 = cartProduct.product) === null || _cartProduct$product49 === void 0 ? void 0 : _cartProduct$product49.name, cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product50 = cartProduct.product) === null || _cartProduct$product50 === void 0 ? void 0 : _cartProduct$product50.is_deal_product);

            case 6:
              _context3.next = 10;
              break;

            case 8:
              _context3.next = 10;
              return _updateCartProduct(cartId, cartProduct.id, qty);

            case 10:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function stepDecrement() {
      return _ref8.apply(this, arguments);
    };
  }();

  var promotionLabelColor = (0,labelBackgroundService/* LabelConfiguration */.v)(promoTag ? promoTag : "");

  var showOptions = function showOptions() {
    setShowModal(true);
  };

  var closeOptions = function closeOptions() {
    setShowModal(false);
  };

  var renderChangeLable = function renderChangeLable() {
    setModalShow(true);
  };

  var closeChangeable = function closeChangeable() {
    setModalShow(false);
  };

  var showModel = optList && optList.length > 0;

  var PriceComponent = /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "\n        ".concat((CartProductCard_module_default())[isMobile ? "price-container" : "cart-product--price-container"], "\n        ").concat((CartProductCard_module_default())[cartProduct !== null && cartProduct !== void 0 && cartProduct.hasBackOrderLabel || (cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product51 = cartProduct.product) === null || _cartProduct$product51 === void 0 ? void 0 : _cartProduct$product51.promotion_tag_label) == types/* default.TYPE_PREORDER */.Z.TYPE_PREORDER ? "promo-top-spacing" : ""], "\n      "),
    children: cartProduct !== null && cartProduct !== void 0 && cartProduct.isOutOfStock && !(cartProduct !== null && cartProduct !== void 0 && cartProduct.hasBackOrderLabel) ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (CartProductCard_module_default())["out-of-stock-label"],
      children: isDealProduct ? labels/* default.lbl_menu_top.lbl_deal_404_heading */.Z.lbl_menu_top.lbl_deal_404_heading : labels/* default.lbl_menu_top.lbl_product_404_label */.Z.lbl_menu_top.lbl_product_404_label
    }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [finalPrice !== regularPrice && !!regularPrice && /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
        className: isDealProduct ? (CartProductCard_module_default())["cart-product--deal-price"] : (CartProductCard_module_default())["cart-product--price"],
        children: regularPriceString
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
        className: (CartProductCard_module_default())["cart-product--finalprice"],
        children: finalPriceString
      })]
    })
  });

  var isRenderStepCounter = function isRenderStepCounter() {
    var _cartProduct$product52, _cartProduct$product53;

    if (isDealProduct || isVASProduct) {
      return false;
    }

    if ((cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product52 = cartProduct.product) === null || _cartProduct$product52 === void 0 ? void 0 : _cartProduct$product52.is_deal_product) === 0 && (cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product53 = cartProduct.product) === null || _cartProduct$product53 === void 0 ? void 0 : _cartProduct$product53.stock_status) !== labels/* default.lbl_out_of_stock */.Z.lbl_out_of_stock && ((cartProduct === null || cartProduct === void 0 ? void 0 : cartProduct.parent_product_sku) == null || (cartProduct === null || cartProduct === void 0 ? void 0 : cartProduct.parent_product_sku) == "")) {
      return true;
    } else {
      return false;
    }
  };

  var RenderRightComponent = /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Col, {
    md: 4,
    className: (CartProductCard_module_default())["cart-product-options"],
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "".concat((CartProductCard_module_default())["cart-product--display"], "\n          ").concat((CartProductCard_module_default())[(cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product54 = cartProduct.product) === null || _cartProduct$product54 === void 0 ? void 0 : _cartProduct$product54.promotion_tag_label) == types/* default.TYPE_PREORDER */.Z.TYPE_PREORDER ? "promo-top-spacing" : ""], "\n        "),
      children: [isRenderStepCounter() && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        style: {
          top: 0
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(StepCounter/* default */.Z, {
          id: cartProduct === null || cartProduct === void 0 ? void 0 : cartProduct.id,
          value: cartProductQuantity,
          stepDecrement: stepDecrement,
          stepIncrement: stepIncrement,
          totalQuantity: totalQuantity,
          disableIncrement: lowStockFlag && lowStockCount === cartProductQuantity ? true : false
        })
      }), PriceComponent]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: !isVASProduct ? (CartProductCard_module_default())["cart-product--buttons"] : (CartProductCard_module_default())["cart-product-vas--buttons"],
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonWithIcon/* default */.Z, {
        buttonLabelStyle: (CartProductCard_module_default())["action-btn"],
        labelText: labels/* default.lbl_remove */.Z.lbl_remove,
        img_url_inactive: "".concat(imagePrefix, "/assets/images/icon-trash-inactive.svg"),
        img_url_active: "".concat(imagePrefix, "/assets/images/icon-trash-active.svg"),
        img_width: 18,
        img_height: 18,
        clickHandler: (isDealProduct || isVASProduct) && cartProductQuantity > 1 ? stepDecrement : removeProductFromCart,
        id: labels/* default.lbl_remove */.Z.lbl_remove
      })
    })]
  });

  var optionValues = optionObj && Object.values(optionObj);

  function fetchData() {
    return _fetchData.apply(this, arguments);
  }

  function _fetchData() {
    _fetchData = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4() {
      var _cartProduct$product61;

      var result;
      return regenerator_default().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return ajaxServices/* default.fetchGraphQLPOSTRequest */.Z.fetchGraphQLPOSTRequest(queries/* getAttributes */.u9, {
                sku: cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product61 = cartProduct.product) === null || _cartProduct$product61 === void 0 ? void 0 : _cartProduct$product61.primary_product_sku
              });

            case 2:
              result = _context4.sent;

              if (result && result.products) {
                setAttributesForDeal(result.products);
              }

            case 4:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));
    return _fetchData.apply(this, arguments);
  }

  (0,react.useEffect)(function () {
    var _cartProduct$product55;

    if ((cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product55 = cartProduct.product) === null || _cartProduct$product55 === void 0 ? void 0 : _cartProduct$product55.is_deal_product) === 1) {
      fetchData();
    }
  }, []);
  var attributeCode = attributesForDeal === null || attributesForDeal === void 0 ? void 0 : (_attributesForDeal$it = attributesForDeal.items[0]) === null || _attributesForDeal$it === void 0 ? void 0 : _attributesForDeal$it.attribute_set_id;
  var attributeVals = attributesForDeal === null || attributesForDeal === void 0 ? void 0 : (_attributesForDeal$at = attributesForDeal.attribute_set_config) === null || _attributesForDeal$at === void 0 ? void 0 : (_attributesForDeal$at2 = _attributesForDeal$at.find(function (val) {
    return val.attribute_set_id == attributeCode;
  })) === null || _attributesForDeal$at2 === void 0 ? void 0 : (_attributesForDeal$at3 = _attributesForDeal$at2.configurable_product_attribute_set_attributes) === null || _attributesForDeal$at3 === void 0 ? void 0 : _attributesForDeal$at3.split(",");
  var updatedLabels = attributeVals === null || attributeVals === void 0 ? void 0 : attributeVals.map(function (val) {
    return "".concat(val, "_label");
  });
  var dealOptions = [];

  if (Array.isArray(attributesForDeal === null || attributesForDeal === void 0 ? void 0 : attributesForDeal.items) && Array.isArray(updatedLabels)) {
    var _iterator4 = _createForOfIteratorHelper(attributesForDeal.items),
        _step4;

    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        var attr = _step4.value;

        var _iterator5 = _createForOfIteratorHelper(updatedLabels),
            _step5;

        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var label = _step5.value;

            if (attr["".concat(label)]) {
              dealOptions.push(attr["".concat(label)]);
            }
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }
  }

  var promoSection = /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: promoTag && promoBadge ? /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
      className: (CartProductCard_module_default())["promo-container"],
      style: {
        marginLeft: showDeal && isMobile ? "-6.5rem" : ""
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(image_image["default"], {
        className: (CartProductCard_module_default()).img,
        img_path: "".concat(imagePrefix, "/assets/images/icon-buy-tag.svg"),
        img_width: "0.8125rem",
        img_height: "0.8125rem"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(LabelText["default"], {
        className: (CartProductCard_module_default())["promo-label"],
        children: labels/* default.lbl_promotion */.Z.lbl_promotion
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(LabelText["default"], {
        className: (CartProductCard_module_default())["promo-label-name"],
        style: {
          color: promotionLabelColor
        },
        children: promoTag
      })]
    }) : null
  });

  var vasSection = /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: isVASProduct && !isMobile && vasTermLink ? /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
      className: (CartProductCard_module_default())["promo-container"],
      style: {
        marginLeft: showDeal && isMobile ? "-6.5rem" : ""
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Link, {
        legacyBehavior: true,
        href: vasTermLink,
        passHref: true,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          target: "_blank",
          onClick: handleTermLinkClick,
          className: "".concat((CartProductCard_module_default())["vas-link"]),
          children: "T&Cs apply"
        })
      })
    }) : null
  });

  var renderLowStockTag = function renderLowStockTag() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: (CartProductCard_module_default())["low-stock-tag"],
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(LabelText["default"], {
          className: (CartProductCard_module_default())["stock-label"],
          children: ["Only ", lowStockCount, " left!"]
        })
      })
    });
  };

  var renderBackOrderTag = function renderBackOrderTag() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
      className: (CartProductCard_module_default())["order-tag--container"],
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Tag/* default */.Z, {
        className: (CartProductCard_module_default())["order-tag--label"],
        label: "Currently on backorder",
        variant: "on-backorder"
      })
    });
  };

  var renderPreOrderTag = function renderPreOrderTag() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
      className: (CartProductCard_module_default())["order-tag--container"],
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Tag/* default */.Z, {
        className: (CartProductCard_module_default())["order-tag--label"],
        label: "Pre-order",
        variant: "pre-order"
      })
    });
  };

  var renderRenderSelectedSpecs = function renderRenderSelectedSpecs() {
    var _cartProduct$colorSel4, _cartProduct$colorSel5;

    if (cartProduct !== null && cartProduct !== void 0 && cartProduct.isDoubleDeal) {
      var _cartProduct$colorSel, _cartProduct$colorSel2, _cartProduct$colorSel3;

      var primaryName = cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$colorSel = cartProduct.colorSelection) === null || _cartProduct$colorSel === void 0 ? void 0 : (_cartProduct$colorSel2 = _cartProduct$colorSel.product) === null || _cartProduct$colorSel2 === void 0 ? void 0 : _cartProduct$colorSel2.name;
      var primaryColor = cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$colorSel3 = cartProduct.colorSelection) === null || _cartProduct$colorSel3 === void 0 ? void 0 : _cartProduct$colorSel3.label;
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
        className: (CartProductCard_module_default())["product-details"],
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("label", {
          className: (CartProductCard_module_default())["product-details--title"],
          children: "Primary Device:"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
          className: (CartProductCard_module_default())["product-details--device-name"],
          children: [primaryName, " | ", primaryColor]
        })]
      });
    }

    return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: __typename !== labels/* default.lbl_product_typeName_simple */.Z.lbl_product_typeName_simple && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: !isVASProduct ? (CartProductCard_module_default())["cart-product--display-specs"] : (CartProductCard_module_default())[" "],
        children: [showModel || dealOptions && dealOptions.length > 0 ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (CartProductCard_module_default())["cart-product--value"],
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("label", {
            children: optionValues && optionValues[0] || dealOptions && dealOptions[0]
          }), optionValues && optionValues.length > 1 || dealOptions && dealOptions.length > 1 ? /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
            className: (CartProductCard_module_default())["cart-product--value-line"],
            children: "|"
          }) : null]
        }) : null, optionValues && optionValues.length > 1 || dealOptions && dealOptions.length > 1 ? /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
          className: (CartProductCard_module_default())["cart-product--value"],
          children: optionValues[1] || dealOptions[1]
        }) : null, __typename === labels/* default.lbl_product_typeName_configurable */.Z.lbl_product_typeName_configurable && !isMobile ? /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
          className: (CartProductCard_module_default()).changeEvent,
          onClick: renderChangeLable,
          children: "Change"
        }) : null, !!(cartProduct !== null && cartProduct !== void 0 && (_cartProduct$colorSel4 = cartProduct.colorSelection) !== null && _cartProduct$colorSel4 !== void 0 && _cartProduct$colorSel4.label) && /*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
          className: (CartProductCard_module_default())["cart-product--value"],
          children: ["| ", cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$colorSel5 = cartProduct.colorSelection) === null || _cartProduct$colorSel5 === void 0 ? void 0 : _cartProduct$colorSel5.label]
        })]
      })
    });
  };

  var renderSecondaryDeal = function renderSecondaryDeal() {
    var _cartProduct$colorSel6, _cartProduct$colorSel7, _cartProduct$colorSel8, _cartProduct$colorSel9, _cartProduct$colorSel10, _cartProduct$colorSel11;

    var secondaryImg = cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$colorSel6 = cartProduct.colorSelectionSecondary) === null || _cartProduct$colorSel6 === void 0 ? void 0 : (_cartProduct$colorSel7 = _cartProduct$colorSel6.product) === null || _cartProduct$colorSel7 === void 0 ? void 0 : (_cartProduct$colorSel8 = _cartProduct$colorSel7.image) === null || _cartProduct$colorSel8 === void 0 ? void 0 : _cartProduct$colorSel8.url;
    var secondaryName = cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$colorSel9 = cartProduct.colorSelectionSecondary) === null || _cartProduct$colorSel9 === void 0 ? void 0 : (_cartProduct$colorSel10 = _cartProduct$colorSel9.product) === null || _cartProduct$colorSel10 === void 0 ? void 0 : _cartProduct$colorSel10.name;
    var secondaryColor = cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$colorSel11 = cartProduct.colorSelectionSecondary) === null || _cartProduct$colorSel11 === void 0 ? void 0 : _cartProduct$colorSel11.label;
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
      className: (CartProductCard_module_default())["secondary-product"],
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: (CartProductCard_module_default())["product-image--secondary"],
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(image_image["default"], {
          img_path: secondaryImg,
          img_width: "4rem",
          img_height: "4rem",
          className: (CartProductCard_module_default())["product-image-style"],
          alt: "image"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
        className: (CartProductCard_module_default())["secondary-product-details"],
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("label", {
          className: (CartProductCard_module_default())["secondary-product-details--title"],
          children: "Secondary Device:"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
          className: (CartProductCard_module_default())["secondary-product-details--device-name"],
          children: [secondaryName, " | ", secondaryColor]
        })]
      })]
    });
  };

  var getHighlights = function getHighlights(item) {
    var highlights = [{
      id: "1",
      value: "",
      displayUnit: "Anytime Data",
      unit: "promo_data",
      icon: "".concat(imagePrefix, "/assets/images/data.svg")
    }, {
      id: "2",
      value: "",
      displayUnit: "Night Owl Data",
      unit: "nightowl_units",
      icon: "".concat(imagePrefix, "/assets/images/data.svg")
    }, {
      id: "3",
      value: "",
      displayUnit: "voice minutes",
      unit: "minutes_label",
      icon: "".concat(imagePrefix, "/assets/images/phone.svg")
    }, {
      id: "4",
      value: "",
      displayUnit: "airtime",
      unit: "airtime",
      icon: "".concat(imagePrefix, "/assets/images/combo.svg")
    }, {
      id: "5",
      value: "",
      displayUnit: "SMSs",
      unit: "sms",
      icon: "".concat(imagePrefix, "/assets/images/sms.svg")
    }];
    highlights.forEach(function (highlight) {
      highlight.value = item[highlight === null || highlight === void 0 ? void 0 : highlight.unit];
    });
    var newHighlight = highlights.filter(function (item) {
      if (item.value > 0 || item.value == "Unlimited") {
        return item;
      }
    });
    var dataIndex = newHighlight.findIndex(function (highLight) {
      return highLight.unit === "promo_data";
    });

    if (dataIndex >= 0) {
      var _cartProduct$product56, _cartProduct$product57, _title_promo$options;

      var title_promo = cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product56 = cartProduct.product) === null || _cartProduct$product56 === void 0 ? void 0 : (_cartProduct$product57 = _cartProduct$product56.items) === null || _cartProduct$product57 === void 0 ? void 0 : _cartProduct$product57.find(function (promoName) {
        return promoName.title === 'Promo';
      });
      var getAnytime = (_title_promo$options = title_promo.options) === null || _title_promo$options === void 0 ? void 0 : _title_promo$options.find(function (promoSku) {
        var _promoSku$product, _cartProduct$product58;

        return ((_promoSku$product = promoSku.product) === null || _promoSku$product === void 0 ? void 0 : _promoSku$product.sku) === (cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product58 = cartProduct.product) === null || _cartProduct$product58 === void 0 ? void 0 : _cartProduct$product58.anytime_product_sku);
      });
      newHighlight[dataIndex].value = getAnytime.product.promo_data != null ? "".concat((0,helperServices/* formatBytes */.td)(getAnytime.product.promo_data)) : "".concat((0,helperServices/* formatBytes */.td)(newHighlight[dataIndex].value));
    }

    var airtimeIndex = newHighlight.findIndex(function (highLight) {
      return highLight.unit === "airtime";
    });

    if (airtimeIndex >= 0) {
      newHighlight[airtimeIndex].value = "R".concat(newHighlight[airtimeIndex].value);
    }

    var nightData = newHighlight.findIndex(function (highLight) {
      return highLight.unit === "nightowl_units";
    });

    if (nightData >= 0) {
      var _cartProduct$product59, _newHighlight$nightDa, _cartProduct$product60;

      newHighlight[nightData].value = (cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product59 = cartProduct.product) === null || _cartProduct$product59 === void 0 ? void 0 : _cartProduct$product59.nightowl_uom) != null ? "".concat((_newHighlight$nightDa = newHighlight[nightData]) === null || _newHighlight$nightDa === void 0 ? void 0 : _newHighlight$nightDa.value).concat(cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product60 = cartProduct.product) === null || _cartProduct$product60 === void 0 ? void 0 : _cartProduct$product60.nightowl_uom) : "".concat(newHighlight[nightData].value);
    }

    return newHighlight;
  };

  var toggleDeal = function toggleDeal() {
    setShowDeal(function (deal) {
      return !deal;
    });
    var salesEvent;

    if (showDeal && !isMobile) {
      salesEvent = "hide deal details";
    } else if (showDeal && isMobile) {
      salesEvent = "hide details";
    } else {
      salesEvent = "show details";
    }

    var analyticsData = _objectSpread({
      page_name: "shopping: cart",
      page_channel: "shopping",
      page_master_tab: "personal"
    }, analyticsUtag/* getUtagData */.GS(["visitor_login_status", "visitor_subscription_type", "visitor_msisdn_hash", "visitor_id_hash"]));

    analyticsData.link_type = "o";
    analyticsData.link_name = "shopping: cart: ".concat(salesEvent);
    analyticsUtag/* link */.p4(analyticsData);
  };

  var navigateToDealSelection = function navigateToDealSelection() {
    setLoadingState(true);

    var analyticsData = _objectSpread({
      sales_event: "choose_another_deal",
      page_name: "shopping: cart",
      page_channel: "shopping",
      page_master_tab: "personal"
    }, analyticsUtag/* getUtagData */.GS(["visitor_login_status", "visitor_subscription_type", "visitor_msisdn_hash", "visitor_id_hash"]));

    analyticsData.link_type = "o";
    analyticsData.link_name = "shopping: cart: choose another deal";
    analyticsUtag/* link */.p4(analyticsData);
    router.push("".concat(urlPrefix, "/deals")).then(function () {
      window.scrollTo(0, 0);
      setLoadingState(false);
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [modalShow && !isMobile && /*#__PURE__*/(0,jsx_runtime.jsx)(ChangeLabelWithOutOfStock/* default */.Z, {
      renderPage: renderPage,
      selectedOptions: optionObj,
      optList: optList,
      variant: "cart",
      show: modalShow,
      centered: true,
      onHide: function onHide() {
        return setModalShow(false);
      },
      closeChangeable: closeChangeable,
      configProduct: __typename === labels/* default.lbl_product_typeName_configurable */.Z.lbl_product_typeName_configurable ? cartProduct : null,
      originalPrice: finalPrice,
      buyOptionId: cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$config_c = cartProduct.config_custom_options) === null || _cartProduct$config_c === void 0 ? void 0 : (_cartProduct$config_c2 = _cartProduct$config_c[0]) === null || _cartProduct$config_c2 === void 0 ? void 0 : _cartProduct$config_c2.id,
      buyOptionTypeId: cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$config_c3 = cartProduct.config_custom_options) === null || _cartProduct$config_c3 === void 0 ? void 0 : (_cartProduct$config_c4 = _cartProduct$config_c3[0]) === null || _cartProduct$config_c4 === void 0 ? void 0 : (_cartProduct$config_c5 = _cartProduct$config_c4.values) === null || _cartProduct$config_c5 === void 0 ? void 0 : (_cartProduct$config_c6 = _cartProduct$config_c5[0]) === null || _cartProduct$config_c6 === void 0 ? void 0 : _cartProduct$config_c6.value
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Row, {
      className: (CartProductCard_module_default())["cart-product"],
      id: "".concat(cartProduct === null || cartProduct === void 0 ? void 0 : cartProduct.id) + "_cartProduct",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Col, {
        md: 8,
        className: (CartProductCard_module_default())["cart-product--display"],
        children: [!isVASProduct && /*#__PURE__*/(0,jsx_runtime.jsx)(image_image["default"], {
          img_path: small_image,
          img_width: "5rem",
          img_height: "5rem",
          className: (CartProductCard_module_default())["product-image-style"],
          alt: "image"
        }), isVASProduct && !isMobile && /*#__PURE__*/(0,jsx_runtime.jsx)(image_image["default"], {
          img_path: small_image,
          img_width: "5rem",
          img_height: "3.75rem",
          className: (CartProductCard_module_default())["product-image-style"],
          alt: "image"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: !isVASProduct ? (CartProductCard_module_default())["cart-product--specs"] : (CartProductCard_module_default())["cart-vasproduct--specs"],
          children: [(cartProduct === null || cartProduct === void 0 ? void 0 : cartProduct.hasBackOrderLabel) && renderBackOrderTag(), (cartProduct === null || cartProduct === void 0 ? void 0 : cartProduct.hasPreOrderLabel) && renderPreOrderTag(), !!lowStockCount && !!lowStockFlag && renderLowStockTag(), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
            className: "d-flex ".concat((CartProductCard_module_default())["cart-product-header"]),
            children: [!isVASProduct && /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
              className: isDealProduct ? (CartProductCard_module_default())["cart-product--deal-label"] : (CartProductCard_module_default())["cart-product--label"],
              children: name
            }), isVASProduct && !isMobile && /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
              className: isDealProduct ? (CartProductCard_module_default())["cart-product--deal-label"] : (CartProductCard_module_default())["cart-product--label"],
              children: name
            }), isDealProduct && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("label", {
                className: (CartProductCard_module_default())["deal-promo"],
                children: "on ".concat(promoForDeal)
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
                className: (CartProductCard_module_default())["show-details"],
                onClick: toggleDeal,
                children: showDeal ? !isMobile ? "Hide deal details" : "" : "Show details"
              })]
            })]
          }), !isMobile && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
            children: isVASProduct && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (CartProductCard_module_default())["cart-vas-desc"],
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
                  className: (CartProductCard_module_default())["cart-vas-desc--text"],
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    dangerouslySetInnerHTML: (0,helperServices/* createMarkup */.KU)((_vasDescription = vasDescription) === null || _vasDescription === void 0 ? void 0 : _vasDescription.html)
                  })
                })
              })
            })
          }), renderRenderSelectedSpecs(), (cartProduct === null || cartProduct === void 0 ? void 0 : cartProduct.isDoubleDeal) && renderSecondaryDeal(), isDealProduct && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: showDeal && /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
              className: (CartProductCard_module_default())["deal-includes"],
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LabelText["default"], {
                className: (CartProductCard_module_default())["this-deal-heading"],
                children: "This deal includes:"
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
                className: "".concat((CartProductCard_module_default())["detail-container"]),
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
                  className: (CartProductCard_module_default())["highlights-container"],
                  children: getHighlights(cartProduct === null || cartProduct === void 0 ? void 0 : cartProduct.product).map(function (item) {
                    return /*#__PURE__*/(0,jsx_runtime.jsx)(IconWithText/* default */.Z, {
                      icon: item.icon,
                      value: item.value,
                      description: item.displayUnit,
                      imageClass: (CartProductCard_module_default()).img,
                      valueStyle: (CartProductCard_module_default()).value,
                      typeStyle: (CartProductCard_module_default()).type,
                      className: (CartProductCard_module_default())["icon-text"],
                      descriptionStyle: (CartProductCard_module_default()).description
                    }, item.id);
                  })
                }), nonPromoArray.map(function (value, index) {
                  return /*#__PURE__*/(0,jsx_runtime.jsx)(IconWithText/* default */.Z, {
                    icon: "".concat(imagePrefix, "/assets/images/add-copy.svg"),
                    value: value,
                    imageClass: (CartProductCard_module_default()).img,
                    valueStyle: (CartProductCard_module_default()).value,
                    className: (CartProductCard_module_default())["icon-text"],
                    descriptionStyle: (CartProductCard_module_default()).description
                  }, "promo-".concat(index));
                })]
              }), !isMobile && /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
                className: (CartProductCard_module_default())["change-deal"],
                onClick: navigateToDealSelection,
                children: "Change Deal"
              })]
            })
          }), isMobile && /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
            className: (CartProductCard_module_default())["hide-details"],
            onClick: toggleDeal,
            children: showDeal && "Hide details"
          }), promoSection, vasSection]
        }), isVASProduct && isMobile && /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(image_image["default"], {
              img_path: small_image,
              className: (CartProductCard_module_default())["vasProduct-image-style"],
              alt: "image"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
              className: (CartProductCard_module_default())["vasProduct-label"],
              children: name
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (CartProductCard_module_default())["cart-vas-desc"],
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
              className: (CartProductCard_module_default())["cart-vas-desc--text"],
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                dangerouslySetInnerHTML: (0,helperServices/* createMarkup */.KU)(vasDescription.html)
              })
            })
          })]
        }), isMobile && /*#__PURE__*/(0,jsx_runtime.jsx)(image_image["default"], {
          img_path: "".concat(imagePrefix, "/assets/images/menu-dots.svg"),
          img_width: "20px",
          img_height: "20px",
          className: (CartProductCard_module_default())["cart-product--price-container"],
          onClick: showOptions,
          id: "".concat(cartProduct === null || cartProduct === void 0 ? void 0 : cartProduct.id, "-options")
        })]
      }), isMobile && /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Col, {
        xs: 12,
        className: (CartProductCard_module_default())["price-container"],
        children: [!isDealProduct && !isVASProduct && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          style: {
            display: "inline-block"
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(StepCounter/* default */.Z, {
            id: cartProduct === null || cartProduct === void 0 ? void 0 : cartProduct.id,
            value: cartProductQuantity,
            stepDecrement: stepDecrement,
            stepIncrement: stepIncrement,
            totalQuantity: totalQuantity,
            disableIncrement: lowStockFlag && lowStockCount === cartProductQuantity ? true : false
          })
        }), PriceComponent]
      }), !isMobile && RenderRightComponent]
    }), showModal && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Modal, {
      show: showModal,
      onHide: closeOptions,
      dialogClassName: "custom-dialog",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(CartProductOptions/* default */.Z, {
        renderPage: renderPage,
        selectedOptions: optionObj,
        optList: optList,
        variant: "cart",
        cartProduct: cartProduct,
        show: showModal,
        originalPrice: finalPrice,
        onHide: closeOptions,
        selectedVariant: selectedVariant,
        removeCartProduct: function removeCartProduct(cartid, id, name, isDealProduct) {
          return _removeCartProduct(cartid, id, name, isDealProduct);
        },
        updateCartProduct: function updateCartProduct(cartId, id, qty, name, isDealProduct) {
          return _updateCartProduct(cartId, id, qty, name, isDealProduct);
        },
        promoTag: promoTag,
        disableIncrement: lowStockFlag && lowStockCount === cartProductQuantity ? true : false,
        isRenderActiveStepCounter: isRenderStepCounter(),
        changeDeal: navigateToDealSelection,
        buyOptionId: cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$config_c7 = cartProduct.config_custom_options) === null || _cartProduct$config_c7 === void 0 ? void 0 : (_cartProduct$config_c8 = _cartProduct$config_c7[0]) === null || _cartProduct$config_c8 === void 0 ? void 0 : _cartProduct$config_c8.id,
        buyOptionTypeId: cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$config_c9 = cartProduct.config_custom_options) === null || _cartProduct$config_c9 === void 0 ? void 0 : (_cartProduct$config_c10 = _cartProduct$config_c9[0]) === null || _cartProduct$config_c10 === void 0 ? void 0 : (_cartProduct$config_c11 = _cartProduct$config_c10.values) === null || _cartProduct$config_c11 === void 0 ? void 0 : (_cartProduct$config_c12 = _cartProduct$config_c11[0]) === null || _cartProduct$config_c12 === void 0 ? void 0 : _cartProduct$config_c12.value
      })
    })]
  });
};

var mapStateToProps = function mapStateToProps(state) {
  var _state$cartDetails, _state$cartDetails2;

  return {
    totalQuantity: (_state$cartDetails = state.cartDetails) === null || _state$cartDetails === void 0 ? void 0 : _state$cartDetails.totalQuantity,
    cartProductItems: (_state$cartDetails2 = state.cartDetails) === null || _state$cartDetails2 === void 0 ? void 0 : _state$cartDetails2.cartProductItems
  };
};

/* harmony default export */ var cartProductCard_CartProductCard = ((0,es/* connect */.$j)(mapStateToProps)(CartProductCard));
// EXTERNAL MODULE: ./components/molecules/VasModal/VasModal.module.scss
var VasModal_module = __webpack_require__(13754);
var VasModal_module_default = /*#__PURE__*/__webpack_require__.n(VasModal_module);
// EXTERNAL MODULE: ./config/constants.js
var constants = __webpack_require__(58223);
;// CONCATENATED MODULE: ./components/molecules/VasModal/VasModal.jsx


function VasModal_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = VasModal_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function VasModal_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return VasModal_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return VasModal_arrayLikeToArray(o, minLen); }

function VasModal_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function VasModal_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function VasModal_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? VasModal_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : VasModal_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }














var VasModal = function VasModal(_ref) {
  var handleCancel = _ref.handleCancel,
      handleAddToCart = _ref.handleAddToCart,
      showModal = _ref.showModal,
      cartData = _ref.cartData;
  var env = (config_default()).env;
  var imagePrefix = (config_default()).envConfigs[env].imagePrefix;
  var isMobile = (0,helperServices/* componentCheckSize */.Qj)() < constants/* MOBILE_WIDTH */.P_;
  var isDesktop = (0,helperServices/* componentCheckSize */.Qj)() > constants/* TABLET_WIDE_WIDTH */.PH;

  var _useState = (0,react.useState)(0),
      totalPrice = _useState[0],
      setTotalPrice = _useState[1];

  var _useState2 = (0,react.useState)([]),
      vasDataSource = _useState2[0],
      setvasDataSource = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      noContentText = _useState3[0],
      setNoContentText = _useState3[1];

  var _useState4 = (0,react.useState)(true),
      updateOnce = _useState4[0],
      setUpdateOnce = _useState4[1];

  var _useState5 = (0,react.useState)(),
      selectedDealPrice = _useState5[0],
      setSelectedDealPrice = _useState5[1];

  var selectedItem = function selectedItem(selectedVasItem, dealPrice, shouldUpdate) {
    dealPrice = (Math.round(dealPrice * 100) / 100).toFixed(2);
    var updatedVasArray = vasDataSource.map(function (vasItem) {
      if (selectedVasItem) {
        if (!shouldUpdate) {
          if (vasItem.vidCode === selectedVasItem.product.sku) {
            vasItem.isAdded = true;
          }
        } else {
          if (vasItem.vidCode === selectedVasItem.vidCode) {
            vasItem.isAdded = !vasItem.isAdded;
          }
        }
      }

      return VasModal_objectSpread({}, vasItem);
    });

    var _iterator = VasModal_createForOfIteratorHelper(updatedVasArray),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var iterator = _step.value;

        if (iterator !== null && iterator !== void 0 && iterator.isAdded) {
          dealPrice = Math.round((+dealPrice + +iterator.price) * 100) / 100;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    setTotalPrice(dealPrice);

    if (shouldUpdate) {
      setvasDataSource(updatedVasArray);
    }
  };

  var getDealWithPrice = function getDealWithPrice() {
    var dealProduct = cartData.find(function (cartProduct) {
      var _cartProduct$product;

      return (cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product = cartProduct.product) === null || _cartProduct$product === void 0 ? void 0 : _cartProduct$product.is_deal_product) === 1;
    });
    setSelectedDealPrice(dealProduct.product.monthly_recurring);
    return dealProduct;
  };

  var getVASFromCart = function getVASFromCart(currentDeal) {
    var vasProduct = cartData.filter(function (cartProduct) {
      return (cartProduct === null || cartProduct === void 0 ? void 0 : cartProduct.parent_product_sku) == currentDeal.product.sku;
    });
    return vasProduct;
  };

  var setErrorAnalytics = function setErrorAnalytics() {
    analyticsUtag/* link */.p4({
      page_name: "shopping: deal details",
      page_form_event: "error",
      page_errors: "There are no insurance products available for this deal",
      page_error_type: "page"
    });
  };

  (0,react.useEffect)(function () {
    var deal = getDealWithPrice();
    var mounted = true;
    showSpinner();
    (0,vasDataService/* getVasItems */.VM)(deal.product.sku).then(function (data) {
      hideSpinner();

      if (mounted) {
        if (data && data.length === 0) {
          setErrorAnalytics();
          setNoContentText(true);
        } else {
          setvasDataSource(data);
        }
      }
    })["catch"](function (error) {
      hideSpinner();
      setNoContentText(true);
    });
    return function () {
      mounted = false;
    };
  }, []);
  (0,react.useEffect)(function () {
    if (vasDataSource) {
      updateModalDataSource();
    }
  }, [vasDataSource]);

  var updateModalDataSource = function updateModalDataSource() {
    var deal = getDealWithPrice();
    var dealPrice = deal.product.monthly_recurring;

    if (vasDataSource.length !== 0) {
      var vasProducts = getVASFromCart(deal);

      if (updateOnce) {
        if (vasProducts && vasProducts.length) {
          vasProducts.forEach(function (item) {
            selectedItem(item, dealPrice, false);
          });
        } else {
          selectedItem(undefined, dealPrice, false);
        }
      } //To avoid calling selectedItem everytime vasDataSource is updated


      setUpdateOnce(false);
    }
  };

  var getVasCategory = function getVasCategory(vasData, type) {
    var vasProperty;

    if (vasData) {
      try {
        if (type === 'icon') {
          var _vasData$vasDetails, _vasData$vasDetails$i;

          vasProperty = vasData === null || vasData === void 0 ? void 0 : (_vasData$vasDetails = vasData.vasDetails) === null || _vasData$vasDetails === void 0 ? void 0 : (_vasData$vasDetails$i = _vasData$vasDetails.image) === null || _vasData$vasDetails$i === void 0 ? void 0 : _vasData$vasDetails$i.url;

          if (vasProperty.includes("No_image")) {
            var _vasData$vasDetails2;

            var vasCategoryIcon = vasData === null || vasData === void 0 ? void 0 : (_vasData$vasDetails2 = vasData.vasDetails) === null || _vasData$vasDetails2 === void 0 ? void 0 : _vasData$vasDetails2.categories.sort(function (a, b) {
              return b.level - a.level;
            })[0];
            vasProperty = vasCategoryIcon.image;
          }
        } else if (type === 'category_url') {
          var _vasData$vasDetails3;

          var vasCategoryUrl = vasData === null || vasData === void 0 ? void 0 : (_vasData$vasDetails3 = vasData.vasDetails) === null || _vasData$vasDetails3 === void 0 ? void 0 : _vasData$vasDetails3.categories.sort(function (a, b) {
            return b.level - a.level;
          })[0];
          vasProperty = vasCategoryUrl.category_url;
        }
      } catch (error) {
        vasProperty = '';
      }
    }

    return vasProperty;
  };

  var showSpinner = function showSpinner() {
    var element = document.getElementById("modalLoader");

    if (element) {
      element.classList.add("showspin");
    }
  };

  var hideSpinner = function hideSpinner() {
    var element = document.getElementById("modalLoader");

    if (element) {
      element.classList.remove("showspin");
    }
  };

  return showModal && /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Modal, {
    show: showModal,
    dialogClassName: "".concat((VasModal_module_default())["vas-modal"]),
    onHide: handleCancel,
    centered: true,
    children: [!isMobile && /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Modal.Header, {
      className: (VasModal_module_default())["vasmodal-header"],
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(image_image["default"], {
        className: (VasModal_module_default())["close-button"],
        img_path: "".concat(imagePrefix, "/assets/images/modal-close.svg"),
        onClick: handleCancel
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        children: "Add contract / device insurance"
      })]
    }), isMobile && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Modal.Header, {
      className: (VasModal_module_default())["vasmodal-header"],
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(image_image["default"], {
        className: (VasModal_module_default())["close-button"],
        img_path: "".concat(imagePrefix, "/assets/images/modal-close.svg"),
        onClick: handleCancel
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Modal.Body, {
      className: noContentText ? (VasModal_module_default())["modal-noContent"] : (VasModal_module_default())["modal-body"],
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        id: "modalLoader",
        className: (VasModal_module_default()).loader
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: (VasModal_module_default()).container,
        children: vasDataSource.map(function (item, index) {
          var _item$vasDetails, _item$vasDetails2, _item$vasDetails2$des;

          return /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
            className: (VasModal_module_default()).card,
            onClick: function onClick() {
              selectedItem(item, selectedDealPrice, true);
            },
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
              className: (VasModal_module_default())["card-container"],
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
                className: (VasModal_module_default())["card__image-container"],
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                  className: (VasModal_module_default()).card__image,
                  src: getVasCategory(item, 'icon')
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
                  className: (VasModal_module_default())["card__image-text"],
                  children: item === null || item === void 0 ? void 0 : (_item$vasDetails = item.vasDetails) === null || _item$vasDetails === void 0 ? void 0 : _item$vasDetails.name
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
                  className: (VasModal_module_default()).card__description,
                  dangerouslySetInnerHTML: (0,helperServices/* createMarkup */.KU)(item === null || item === void 0 ? void 0 : (_item$vasDetails2 = item.vasDetails) === null || _item$vasDetails2 === void 0 ? void 0 : (_item$vasDetails2$des = _item$vasDetails2.description) === null || _item$vasDetails2$des === void 0 ? void 0 : _item$vasDetails2$des.html)
                }), isDesktop && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
                  className: (VasModal_module_default()).card__link,
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Link, {
                    legacyBehavior: true,
                    href: getVasCategory(item, 'category_url'),
                    passHref: true,
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                      target: "_blank",
                      className: (VasModal_module_default()).card__link,
                      children: "See more info"
                    })
                  })
                })]
              }), isDesktop && /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
                className: (VasModal_module_default()).card__price,
                children: ["+ R", (0,helperServices/* numberFormat */.i8)(item.price), " PM"]
              }), isDesktop && /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
                children: [(item === null || item === void 0 ? void 0 : item.isAdded) && /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                  className: (VasModal_module_default()).card__selected,
                  src: "".concat(imagePrefix, "/assets/images/tick-marks.svg")
                }), !(item !== null && item !== void 0 && item.isAdded) && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
                  className: (VasModal_module_default()).card__unselected
                })]
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
              className: (VasModal_module_default()).footer,
              children: [!isDesktop && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
                className: (VasModal_module_default()).card__link,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Link, {
                  legacyBehavior: true,
                  href: getVasCategory(item, 'category_url'),
                  passHref: true,
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                    target: "_blank",
                    className: (VasModal_module_default()).card__link,
                    children: "See more info"
                  })
                })
              }), !isDesktop && /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
                className: (VasModal_module_default()).footer__price,
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
                  className: (VasModal_module_default()).card__price,
                  children: ["+ R", (0,helperServices/* numberFormat */.i8)(item.price), " PM"]
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
                  children: [(item === null || item === void 0 ? void 0 : item.isAdded) && /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                    className: (VasModal_module_default()).card__selected,
                    src: "".concat(imagePrefix, "/assets/images/tick-marks.svg")
                  }), !(item !== null && item !== void 0 && item.isAdded) && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
                    className: (VasModal_module_default()).card__unselected
                  })]
                })]
              })]
            })]
          }, index);
        })
      }), noContentText && /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
        className: (VasModal_module_default())["noContent-container"],
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
          className: (VasModal_module_default()).noContent,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            className: (VasModal_module_default())["noContent-info-button"],
            src: "".concat(imagePrefix, "/assets/images/icon-info.svg")
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            children: "There are no insurance products available for this deal"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          className: (VasModal_module_default()).close,
          onClick: handleCancel,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
            className: (VasModal_module_default()).label,
            children: "Close"
          })
        })]
      })]
    }), !isMobile && vasDataSource.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Row, {
      className: (VasModal_module_default())["modal-footer"],
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Col, {
        className: (VasModal_module_default())["modal-footer-total"],
        children: ["Your monthly total:", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: (VasModal_module_default())["modal-footer-amount"],
          children: "R".concat((0,helperServices/* numberFormat */.i8)(totalPrice))
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Row, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Col, {
          className: (VasModal_module_default())["modal-footer-cancel"],
          onClick: handleCancel,
          children: "Cancel"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          className: (VasModal_module_default())["modal-footer-cancel-button"],
          disabled: !vasDataSource.length,
          onClick: function onClick(e) {
            e.stopPropagation();
            handleAddToCart(vasDataSource);
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
            className: (VasModal_module_default())["button-label"],
            children: "Add to cart"
          })
        })]
      })]
    }), isMobile && vasDataSource.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
      className: (VasModal_module_default())["modal-footer"],
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
        className: (VasModal_module_default())["modal-footer-total"],
        children: ["Your monthly total:", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: (VasModal_module_default())["modal-footer-amount"],
          children: "R".concat((0,helperServices/* numberFormat */.i8)(totalPrice))
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
        className: (VasModal_module_default())["modal-footer-cancel-button"],
        disabled: !vasDataSource.length,
        onClick: function onClick(e) {
          e.stopPropagation();
          handleAddToCart(vasDataSource);
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
          className: (VasModal_module_default())["button-label"],
          children: "Add to cart"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: (VasModal_module_default())["modal-footer-cancel"],
        children: "Cancel"
      })]
    })]
  });
};

VasModal.propType = {
  handleCancel: (prop_types_default()).func,
  handleAddToCart: (prop_types_default()).func,
  showModal: (prop_types_default()).bool,
  cartData: (prop_types_default()).array
};
/* harmony default export */ var VasModal_VasModal = (VasModal);
// EXTERNAL MODULE: ./components/organisms/CartListContainer/CartListContainer.module.scss
var CartListContainer_module = __webpack_require__(11005);
var CartListContainer_module_default = /*#__PURE__*/__webpack_require__.n(CartListContainer_module);
;// CONCATENATED MODULE: ./components/organisms/CartListContainer/CartListContainer.jsx


function CartListContainer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function CartListContainer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? CartListContainer_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : CartListContainer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



















var CartListContainer = function CartListContainer(_ref) {
  var _prices$subtotal_incl;

  var _removeCartProduct = _ref.removeCartProduct,
      _updateCartProduct = _ref.updateCartProduct,
      monthlyCartProducts = _ref.monthlyCartProducts,
      onceoffCartProducts = _ref.onceoffCartProducts,
      applicationType = _ref.applicationType,
      alertFlag = _ref.alertFlag,
      handleAddRemoveToCartForVAS = _ref.handleAddRemoveToCartForVAS,
      shouldCloseModal = _ref.shouldCloseModal,
      cartDetails = _ref.cartDetails,
      isVAS = _ref.isVAS;
  var isMobile = (0,helperServices/* componentResize */.Y4)();
  var router = (0,DependencyHelper.useRouter)();
  var env = (config_default()).env;
  var imagePrefix = (config_default()).envConfigs[env].imagePrefix;
  var shoppingUrlPrefix = (config_default()).envConfigs[env].shoppingUrlPrefix;

  var _useState = (0,react.useState)(false),
      showVasModal = _useState[0],
      setShowVasModal = _useState[1];

  var _ref2 = cartDetails || {},
      cartProductItems = _ref2.cartProductItems,
      prices = _ref2.prices,
      totalQuantity = _ref2.totalQuantity,
      cartLimits = _ref2.cartLimits;

  var subTotalIncludingTax = prices === null || prices === void 0 ? void 0 : (_prices$subtotal_incl = prices.subtotal_including_tax) === null || _prices$subtotal_incl === void 0 ? void 0 : _prices$subtotal_incl.value;
  var dispatch = (0,es/* useDispatch */.I0)();

  var setLoadingState = function setLoadingState(isLoading) {
    return dispatch({
      type: actionTypes/* SET_IS_LOADING */.GA,
      payload: isLoading
    });
  };

  var addVasToDealModal = function addVasToDealModal() {
    var pageName = analyticsUtag/* getUtagData */.GS(["page_name"]).page_name;
    analyticsUtag/* link */.p4({
      link_type: "o",
      link_name: "".concat(pageName, ": add contract device insurance")
    });
    setShowVasModal(true);
  };

  var closeVasModal = function closeVasModal() {
    setShowVasModal(false);
  };

  (0,react.useEffect)(function () {
    if (shouldCloseModal) {
      setShowVasModal(false);
    }
  }, [shouldCloseModal]);

  var navigateToShopLandingPage = function navigateToShopLandingPage() {
    setLoadingState(true);

    if (cartProductItems.length) {
      var sales_order_discount = [];
      var sales_product_category = [];
      var sales_product_id = [];
      var sales_product_price = [];
      var sales_product_quantity = [];
      var sales_promo_name = [];
      var page_tool_event = [];
      var page_tool_name = [];
      cartProductItems.forEach(function (item) {
        var _item$product, _item$prices, _item$prices$row_tota, _item$product2, _item$product2$catego, _item$product2$catego2, _item$product3, _item$product5;

        sales_order_discount.push((0,helperServices/* getAmountOffValue */.Dd)(item === null || item === void 0 ? void 0 : item.product));
        sales_product_id.push(item === null || item === void 0 ? void 0 : (_item$product = item.product) === null || _item$product === void 0 ? void 0 : _item$product.name);
        sales_product_price.push(item === null || item === void 0 ? void 0 : (_item$prices = item.prices) === null || _item$prices === void 0 ? void 0 : (_item$prices$row_tota = _item$prices.row_total_including_tax) === null || _item$prices$row_tota === void 0 ? void 0 : _item$prices$row_tota.value);
        sales_product_quantity.push(item === null || item === void 0 ? void 0 : item.quantity);
        sales_product_category.push((item === null || item === void 0 ? void 0 : (_item$product2 = item.product) === null || _item$product2 === void 0 ? void 0 : (_item$product2$catego = _item$product2.categories) === null || _item$product2$catego === void 0 ? void 0 : (_item$product2$catego2 = _item$product2$catego[0]) === null || _item$product2$catego2 === void 0 ? void 0 : _item$product2$catego2.name) || "");

        if (item !== null && item !== void 0 && (_item$product3 = item.product) !== null && _item$product3 !== void 0 && _item$product3.promotion_tag_label) {
          var _item$product4;

          sales_promo_name.push(item === null || item === void 0 ? void 0 : (_item$product4 = item.product) === null || _item$product4 === void 0 ? void 0 : _item$product4.promotion_tag_label);
        } else {
          sales_promo_name.push("");
        }

        if ((item === null || item === void 0 ? void 0 : (_item$product5 = item.product) === null || _item$product5 === void 0 ? void 0 : _item$product5.stock_status.toLowerCase()) === "out_of_stock") {
          page_tool_event.push("use");
          page_tool_name.push("shopping:cart:out of stock");
        } else {
          page_tool_event.push("");
          page_tool_name.push("");
        }
      });
      analyticsUtag/* link */.p4(CartListContainer_objectSpread(CartListContainer_objectSpread({}, analyticsUtag/* getUtagData */.GS(["page_name", "page_channel", "page_master_tab", "visitor_login_status", "visitor_subscription_type", "visitor_msisdn_hash"])), {}, {
        link_type: "o",
        link_name: "shopping: cart: continue shopping",
        sales_order_discount: sales_order_discount,
        sales_product_category: sales_product_category,
        sales_product_id: sales_product_id,
        sales_product_price: sales_product_price,
        sales_product_quantity: sales_product_quantity,
        sales_promo_name: sales_promo_name
      }));
    } else {
      analyticsUtag/* link */.p4(CartListContainer_objectSpread(CartListContainer_objectSpread({}, analyticsUtag/* getUtagData */.GS(["page_name", "page_channel", "page_master_tab", "visitor_login_status", "visitor_subscription_type", "visitor_msisdn_hash"])), {}, {
        link_type: "o",
        link_name: "shopping: cart: continue shopping"
      }));
    }

    router.push("".concat(shoppingUrlPrefix, "/products")).then(function () {
      window.scrollTo(0, 0);
      setLoadingState(false);
    });
  };

  var dealProduct = monthlyCartProducts.filter(function (cartProduct) {
    var _cartProduct$product, _cartProduct$product2;

    return (cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product = cartProduct.product) === null || _cartProduct$product === void 0 ? void 0 : _cartProduct$product.is_deal_product) === 1 && (cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product2 = cartProduct.product) === null || _cartProduct$product2 === void 0 ? void 0 : _cartProduct$product2.__typename) === labels/* default.lbl_product_type_bundle */.Z.lbl_product_type_bundle;
  });
  var dealSku = [];
  dealProduct.forEach(function (prod) {
    var _prod$product;

    if (prod !== null && prod !== void 0 && (_prod$product = prod.product) !== null && _prod$product !== void 0 && _prod$product.sku) {
      var _prod$product2;

      dealSku.push(prod === null || prod === void 0 ? void 0 : (_prod$product2 = prod.product) === null || _prod$product2 === void 0 ? void 0 : _prod$product2.sku);
    }
  });
  var duplicateCounts = false,
      maxVas = 0;
  var dealVasProduct = [];
  dealSku.forEach(function (prodSku) {
    cartProductItems.forEach(function (cartProduct) {
      if (prodSku && (cartProduct === null || cartProduct === void 0 ? void 0 : cartProduct.parent_product_sku) == prodSku) {
        dealVasProduct.push(cartProduct);
      }
    });
  });
  var dealVasPrice = 0;
  dealVasProduct.forEach(function (item) {
    if (dealSku && item !== null && item !== void 0 && item.monthly_recurring && (item === null || item === void 0 ? void 0 : item.parent_product_sku) == dealSku) {
      dealVasPrice = parseFloat(dealVasPrice) + parseFloat(item === null || item === void 0 ? void 0 : item.monthly_recurring);
    }

    maxVas++;
  });
  dealVasProduct.map(function (v) {
    var _v$product;

    return v === null || v === void 0 ? void 0 : (_v$product = v.product) === null || _v$product === void 0 ? void 0 : _v$product.sku;
  }).sort().sort(function (a, b) {
    if (a === b) duplicateCounts = true;
  });
  var dealPrice = 0;

  if (dealProduct && dealProduct.length > 1) {
    dealPrice = "R".concat((0,helperServices/* formatNumbersWithComma */.G0)(0));
  } else {
    if (dealVasPrice) {
      var _dealProduct$, _dealProduct$$product, _dealProduct$2, _dealProduct$2$produc;

      dealVasPrice = parseFloat((_dealProduct$ = dealProduct[0]) === null || _dealProduct$ === void 0 ? void 0 : (_dealProduct$$product = _dealProduct$.product) === null || _dealProduct$$product === void 0 ? void 0 : _dealProduct$$product.monthly_recurring) + parseFloat(dealVasPrice);
      dealPrice = "R".concat((0,helperServices/* formatNumbersWithComma */.G0)(dealVasPrice), " \xD7 ").concat((_dealProduct$2 = dealProduct[0]) === null || _dealProduct$2 === void 0 ? void 0 : (_dealProduct$2$produc = _dealProduct$2.product) === null || _dealProduct$2$produc === void 0 ? void 0 : _dealProduct$2$produc.payment_terms_label);
    } else {
      var _dealProduct$3, _dealProduct$3$produc, _dealProduct$4, _dealProduct$4$produc;

      dealPrice = "R".concat((0,helperServices/* formatNumbersWithComma */.G0)((_dealProduct$3 = dealProduct[0]) === null || _dealProduct$3 === void 0 ? void 0 : (_dealProduct$3$produc = _dealProduct$3.product) === null || _dealProduct$3$produc === void 0 ? void 0 : _dealProduct$3$produc.monthly_recurring), " \xD7 ").concat((_dealProduct$4 = dealProduct[0]) === null || _dealProduct$4 === void 0 ? void 0 : (_dealProduct$4$produc = _dealProduct$4.product) === null || _dealProduct$4$produc === void 0 ? void 0 : _dealProduct$4$produc.payment_terms_label);
    }
  }

  var renderPopUp;

  if (duplicateCounts) {
    renderPopUp = labels/* default.lbl_only_uniq_vas_allowed */.Z.lbl_only_uniq_vas_allowed;
  } else if (maxVas > 4) {
    renderPopUp = labels/* default.lbl_add_up_to_four */.Z.lbl_add_up_to_four;
  }

  if (totalQuantity > (cartLimits === null || cartLimits === void 0 ? void 0 : cartLimits.cart_qty_limit)) {
    renderPopUp = labels/* default.lbl_cart_items_max_msg.replace */.Z.lbl_cart_items_max_msg.replace("<XY>", cartLimits === null || cartLimits === void 0 ? void 0 : cartLimits.cart_qty_limit);
  } else if (subTotalIncludingTax > (cartLimits === null || cartLimits === void 0 ? void 0 : cartLimits.order_value_limit)) {
    renderPopUp = labels/* default.lbl_cart_order_max_msg.replace */.Z.lbl_cart_order_max_msg.replace("<RXX>", "R".concat((0,helperServices/* numberToLocaleString */.oN)(cartLimits === null || cartLimits === void 0 ? void 0 : cartLimits.order_value_limit)));
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
    className: (CartListContainer_module_default())["cart-list-container"],
    children: [alertFlag && renderPopUp && /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
      className: (CartListContainer_module_default()).limit,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(image_image["default"], {
        className: (CartListContainer_module_default()).img,
        img_path: "".concat(imagePrefix, "/assets/images/info-s-copy.svg"),
        img_width: "1.3125rem",
        img_height: "1.3125rem"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(LabelText["default"], {
        className: (CartListContainer_module_default())["cart-limit-label"],
        children: renderPopUp
      })]
    }), monthlyCartProducts && monthlyCartProducts.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: (CartListContainer_module_default())["cart-label-container"],
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(LabelText["default"], {
          className: (CartListContainer_module_default())["cart-label"],
          children: applicationType
        })
      }), monthlyCartProducts.map(function (cartProduct, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(cartProductCard_CartProductCard, {
          cartProduct: cartProduct,
          dealSku: dealSku,
          removeCartProduct: function removeCartProduct(cartid, id, name, isDealProduct) {
            return _removeCartProduct(cartid, id, name, isDealProduct);
          },
          updateCartProduct: function updateCartProduct(cartId, id, qty, name, isDealProduct) {
            return _updateCartProduct(cartId, id, qty, name, isDealProduct);
          }
        }, "cart-item-".concat(index, "-").concat(dealSku));
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: (CartListContainer_module_default()).add_contract,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Row, {
          className: (CartListContainer_module_default()).add_contract_cart,
          id: "add_contract_cartProduct",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Col, {
            className: (CartListContainer_module_default()).add_contract_cart_btn,
            children: isVAS && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
              children: [!alertFlag && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                onClick: addVasToDealModal,
                className: (CartListContainer_module_default()).add_contract_cart_btn_display,
                children: labels/* default.deal_details.lbl_new_contract_deal_vas */.Z.deal_details.lbl_new_contract_deal_vas
              }), alertFlag && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (CartListContainer_module_default()).add_contract_cart_btn_disable,
                children: labels/* default.deal_details.lbl_new_contract_deal_vas */.Z.deal_details.lbl_new_contract_deal_vas
              })]
            })
          })
        })
      }), !isMobile && (0,helperServices/* isArrayNotEmpty */.wh)(monthlyCartProducts) && !(0,helperServices/* isArrayNotEmpty */.wh)(onceoffCartProducts) && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: (CartListContainer_module_default())["cart-left-align"],
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(BackButton["default"], {
          labelText: "Continue shopping",
          labelStyle: (CartListContainer_module_default())["backbutton-label"],
          handleClick: navigateToShopLandingPage,
          id: "cart-to-productlistBtn"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
        className: (CartListContainer_module_default())["deal-total-due"],
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LabelText["default"], {
          className: (CartListContainer_module_default())["cart-price-label"],
          children: labels/* default.deal_details.lbl_total_monthly_due */.Z.deal_details.lbl_total_monthly_due
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(LabelText["default"], {
          className: (CartListContainer_module_default())["cart-price"],
          children: dealPrice
        })]
      })]
    }), onceoffCartProducts && onceoffCartProducts.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: (CartListContainer_module_default())["cart-label-container"],
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(LabelText["default"], {
          className: (CartListContainer_module_default())["cart-label"],
          children: labels/* default.lbl_once_off_purchase */.Z.lbl_once_off_purchase
        })
      }), onceoffCartProducts.map(function (cartProduct) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(cartProductCard_CartProductCard, {
          cartProduct: cartProduct,
          removeCartProduct: function removeCartProduct(cartid, id, name, isDealProduct) {
            return _removeCartProduct(cartid, id, name, isDealProduct);
          },
          updateCartProduct: function updateCartProduct(cartId, id, qty) {
            return _updateCartProduct(cartId, id, qty);
          }
        }, cartProduct === null || cartProduct === void 0 ? void 0 : cartProduct.id);
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
      className: (CartListContainer_module_default())["cart-bar"],
      children: [!isMobile && ((0,helperServices/* isArrayNotEmpty */.wh)(monthlyCartProducts) && (0,helperServices/* isArrayNotEmpty */.wh)(onceoffCartProducts) || !(0,helperServices/* isArrayNotEmpty */.wh)(monthlyCartProducts) && (0,helperServices/* isArrayNotEmpty */.wh)(onceoffCartProducts)) ? /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: (CartListContainer_module_default())["cart-left-align"],
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(BackButton["default"], {
          labelText: "Continue shopping",
          labelStyle: (CartListContainer_module_default())["backbutton-label"],
          handleClick: navigateToShopLandingPage,
          id: "cart-to-productlistBtn"
        })
      }) : null, onceoffCartProducts && onceoffCartProducts.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
        className: (CartListContainer_module_default())["cart-right-align"],
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LabelText["default"], {
          className: (CartListContainer_module_default())["cart-price-label"],
          children: labels/* default.lbl_total_once_off_due */.Z.lbl_total_once_off_due
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(LabelText["default"], {
          className: (CartListContainer_module_default())["cart-price"],
          children: "R".concat((0,helperServices/* formatNumbersWithComma */.G0)(subTotalIncludingTax))
        })]
      }), showVasModal && /*#__PURE__*/(0,jsx_runtime.jsx)(VasModal_VasModal, {
        showModal: showVasModal,
        handleCancel: closeVasModal,
        handleAddToCart: handleAddRemoveToCartForVAS,
        cartData: cartProductItems
      })]
    })]
  });
};

var CartListContainer_mapStateToProps = function mapStateToProps(state) {
  var _state$common$feature;

  return {
    cartDetails: state.cartDetails,
    isVAS: (_state$common$feature = state.common.features) === null || _state$common$feature === void 0 ? void 0 : _state$common$feature.vas
  };
};

/* harmony default export */ var CartListContainer_CartListContainer = ((0,es/* connect */.$j)(CartListContainer_mapStateToProps)(CartListContainer));
// EXTERNAL MODULE: ./components/atoms/CTAButton/CTAButton.jsx
var CTAButton = __webpack_require__(79549);
// EXTERNAL MODULE: ./components/atoms/pendingOrder/PendingOrder.module.scss
var PendingOrder_module = __webpack_require__(37323);
var PendingOrder_module_default = /*#__PURE__*/__webpack_require__.n(PendingOrder_module);
;// CONCATENATED MODULE: ./components/atoms/pendingOrder/PendingOrder.jsx


function PendingOrder_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function PendingOrder_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? PendingOrder_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : PendingOrder_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }












var PendingOrder = function PendingOrder(_ref) {
  var className = _ref.className;
  var env = (config_default()).env;
  var imagePrefix = (config_default()).envConfigs[env].imagePrefix;
  var urlPrefix = (config_default()).envConfigs[env].shoppingUrlPrefix;
  var router = (0,DependencyHelper.useRouter)();

  var viewOrderHistory = function viewOrderHistory() {
    (0,helperServices/* showSpinner */.yh)();
    router.push("".concat(urlPrefix, "/view-order-history"));

    var analyticsData = PendingOrder_objectSpread({
      sales_event: "view order",
      page_name: "shopping: cart: view order",
      page_channel: "shopping",
      page_master_tab: "personal",
      link_type: "o",
      link_name: "shopping: cart: view order"
    }, analyticsUtag/* getUtagData */.GS(["visitor_login_status", "visitor_subscription_type", "visitor_msisdn_hash", "visitor_id_hash"]));

    analyticsUtag/* link */.p4(analyticsData);
  };

  var RenderBox = function RenderBox(classStyle) {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
      className: "".concat(classStyle, " position-relative"),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(image_image["default"], {
        img_path: "".concat(imagePrefix, "/assets/images/bundles.svg"),
        img_width: "3.75rem",
        img_height: "3.75rem"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: (PendingOrder_module_default()).alertCircle,
        children: "!"
      })]
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
    className: "".concat((PendingOrder_module_default()).orderRemainder, " ").concat(className),
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
      className: "d-flex",
      children: [RenderBox("d-none d-sm-block mr-m"), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
          className: (PendingOrder_module_default()).imageTextBox,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
            children: RenderBox("d-flex d-sm-none mr-s")
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (PendingOrder_module_default()).context,
            children: labels/* default.lbl_order_waiting */.Z.lbl_order_waiting
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (PendingOrder_module_default()).subContext,
          children: labels/* default.lbl_order_not_final */.Z.lbl_order_not_final
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
          className: (PendingOrder_module_default()).timerBox,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(image_image["default"], {
            img_path: "".concat(imagePrefix, "/assets/images/clock.svg"),
            img_width: "1rem",
            img_height: "1rem"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: (PendingOrder_module_default()).timerText,
            children: labels/* default.lbl_hurry_text */.Z.lbl_hurry_text
          })]
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
      className: (PendingOrder_module_default()).buttonContainer,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(CTAButton["default"], {
        className: "roundBtn mt-l ".concat((PendingOrder_module_default()).buttonStyle),
        variant: "solid black",
        handleClick: function handleClick() {
          return viewOrderHistory();
        },
        children: labels/* default.lbl_view_order */.Z.lbl_view_order
      })
    })]
  });
};

/* harmony default export */ var pendingOrder_PendingOrder = (PendingOrder);
// EXTERNAL MODULE: ./components/molecules/errorToolTip/ErrorTooltip.jsx
var ErrorTooltip = __webpack_require__(94029);
;// CONCATENATED MODULE: ./pages/shopping/cart.js




function cart_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function cart_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? cart_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : cart_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function cart_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = cart_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function cart_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return cart_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return cart_arrayLikeToArray(o, minLen); }

function cart_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }









































var CartOrderSummary = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 1826).then(__webpack_require__.bind(__webpack_require__, 11826));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(11826)];
    }
  }
});
var TextBoxCard = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 7092).then(__webpack_require__.bind(__webpack_require__, 87092));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(87092)];
    }
  }
});
var cart_LabelText = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 38975));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(38975)];
    }
  }
});
var SnackBar = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 52932));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(52932)];
    }
  }
});
var cart_CTAButton = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 79549));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(79549)];
    }
  }
});
var Image = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 39489));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(39489)];
    }
  }
});
var CartOrderDescription = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 3779).then(__webpack_require__.bind(__webpack_require__, 33779));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(33779)];
    }
  }
});
var PromoTextCard = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 6504).then(__webpack_require__.bind(__webpack_require__, 26504));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(26504)];
    }
  }
});
var CartFooter = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(4309), __webpack_require__.e(690)]).then(__webpack_require__.bind(__webpack_require__, 90690));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(90690)];
    }
  }
});

var CartPage = function CartPage(_ref) {
  var _cartDetails$notifica, _dealProduct$customiz, _dealProduct$customiz2, _cartDetails$prices, _cartDetails$prices$s, _cartDetails$cartLimi, _cartDetails$cartLimi2, _allPrices$subtotal_e, _allPrices$applied_ta, _allPrices$applied_ta2;

  var recentlyViewed = _ref.recentlyViewed,
      cartProductItems = _ref.cartProductItems,
      prices = _ref.prices,
      metadata = _ref.metadata,
      addCouponToCart = _ref.addCouponToCart,
      errorMsg = _ref.errorMsg,
      cartDetails = _ref.cartDetails,
      userLoggedIn = _ref.userLoggedIn,
      profileData = _ref.profileData,
      isCheckoutLogin = _ref.isCheckoutLogin,
      deleteItemsFromCart = _ref.deleteItemsFromCart,
      updateItemsofCart = _ref.updateItemsofCart,
      profileLoading = _ref.profileLoading,
      removeCouponFromCart = _ref.removeCouponFromCart,
      getShippingAndBilling = _ref.getShippingAndBilling,
      showGuestCart = _ref.showGuestCart,
      resetSyncUserProfile = _ref.resetSyncUserProfile,
      syncUserProfile = _ref.syncUserProfile,
      setProfileData = _ref.setProfileData,
      setCheckoutLogin = _ref.setCheckoutLogin,
      userProfileSync = _ref.userProfileSync,
      addGuestCartProducts = _ref.addGuestCartProducts,
      canReciveOTP = _ref.canReciveOTP,
      isChildAllowed = _ref.isChildAllowed,
      upgradeResponse = _ref.upgradeResponse,
      resetGuestCart = _ref.resetGuestCart,
      setHelpLeadBucket = _ref.setHelpLeadBucket,
      geoLocation = _ref.geoLocation,
      setChangeStore = _ref.setChangeStore,
      setStoreDetails = _ref.setStoreDetails,
      setChangeMethods = _ref.setChangeMethods,
      isMiniApp = _ref.isMiniApp,
      features = _ref.features,
      checkFeatures = _ref.checkFeatures;
  var env = (config_default()).env;
  var imagePrefix = (config_default()).envConfigs[env].imagePrefix;
  var urlPrefix = (config_default()).envConfigs[env].shoppingUrlPrefix;
  var loginUrl = (config_default()).envConfigs[env].DIDLoginUrl;
  var legacyEnv = (config_default()).envConfigs[env].legacyEnv;

  var _useState = (0,react.useState)(""),
      redirectURL = _useState[0],
      setRedirectURL = _useState[1];

  var productsCookie = (0,helperServices/* getCookieValue */.Do)("products");
  var cartId = (0,helperServices/* getCookieValue */.Do)("cart_id");

  var _useState2 = (0,react.useState)([]),
      productsViewed = _useState2[0],
      setProductsViewed = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      showModal = _useState3[0],
      setShowModal = _useState3[1];

  var _useState4 = (0,react.useState)(),
      positionFromTop = _useState4[0],
      setPositionFromTop = _useState4[1];

  var _useState5 = (0,react.useState)(recentlyViewed ? recentlyViewed : []),
      updatedCookieProduct = _useState5[0],
      setUpdatedCookieProduct = _useState5[1];

  var _useState6 = (0,react.useState)([]),
      cartItems = _useState6[0],
      setCartItems = _useState6[1];

  var _useState7 = (0,react.useState)(null),
      allPrices = _useState7[0],
      setAllPrices = _useState7[1];

  var _useState8 = (0,react.useState)([]),
      productItems = _useState8[0],
      setProductItems = _useState8[1];

  var _useState9 = (0,react.useState)(""),
      updateCartDetails = _useState9[0],
      setUpdateCartDetails = _useState9[1];

  var _useState10 = (0,react.useState)(false),
      continueDisabled = _useState10[0],
      setContinueDisabled = _useState10[1];

  var _useState11 = (0,react.useState)(""),
      text = _useState11[0],
      setText = _useState11[1];

  var _useState12 = (0,react.useState)(false),
      showCouponAlert = _useState12[0],
      setShowCouponAlert = _useState12[1];

  var _useState13 = (0,react.useState)(false),
      showSnackBar = _useState13[0],
      setShowSnackBar = _useState13[1];

  var _useState14 = (0,react.useState)(false),
      addCouponMsg = _useState14[0],
      setAddCoupon = _useState14[1];

  var _useState15 = (0,react.useState)(false),
      updateMsg = _useState15[0],
      setUpdateMsg = _useState15[1];

  var _useState16 = (0,react.useState)(false),
      removeMsg = _useState16[0],
      setRemoveMsg = _useState16[1];

  var _useState17 = (0,react.useState)(false),
      removeCoupon = _useState17[0],
      setRemoveCoupon = _useState17[1];

  var _useState18 = (0,react.useState)(false),
      isDealRemove = _useState18[0],
      setIsDealRemove = _useState18[1];

  var _useState19 = (0,react.useState)(null),
      cartProductName = _useState19[0],
      setCartProductName = _useState19[1];

  var _useState20 = (0,react.useState)(false),
      cartApiError = _useState20[0],
      setCartApiError = _useState20[1];

  var _useState21 = (0,react.useState)(false),
      refreshUser = _useState21[0],
      setRefreshUser = _useState21[1];

  var _useState22 = (0,react.useState)(false),
      isUserProfileSync = _useState22[0],
      setIsUserProfileSync = _useState22[1];

  var _useState23 = (0,react.useState)(false),
      checkoutDisabled = _useState23[0],
      setCheckoutDisabled = _useState23[1];

  var _useState24 = (0,react.useState)(false),
      showLoginModal = _useState24[0],
      setShowLoginModal = _useState24[1];

  var _useState25 = (0,react.useState)(false),
      hideVasModal = _useState25[0],
      setHideVasModal = _useState25[1];

  var _useState26 = (0,react.useState)(false),
      showPreOrderInfo = _useState26[0],
      setShowPreOrderInfo = _useState26[1];

  var _useState27 = (0,react.useState)(""),
      preOrderDeliveryMessage = _useState27[0],
      setPreOrderDeliveryMessage = _useState27[1];

  var _useState28 = (0,react.useState)({}),
      startEmptyCart = _useState28[0],
      setStartEmptyCart = _useState28[1];

  var repeatedDealVas = [];
  var isPendingOrder = (_cartDetails$notifica = cartDetails.notificationData) !== null && _cartDetails$notifica !== void 0 && _cartDetails$notifica.is_pending_orders ? true : false;

  var _useState29 = (0,react.useState)({}),
      voucherAnalytics = _useState29[0],
      setVoucherAnalytics = _useState29[1];

  var isMobile = (0,helperServices/* componentResize */.Y4)();
  var isTablet = (0,helperServices/* componentCheckSize */.Qj)() <= 992;
  var router = (0,DependencyHelper.useRouter)();
  var dispatch = (0,es/* useDispatch */.I0)();

  var setLoadingState = function setLoadingState(isLoading) {
    return dispatch({
      type: actionTypes/* SET_IS_LOADING */.GA,
      payload: isLoading
    });
  };

  var newRedirectURL = features !== null && features !== void 0 && features.shakaEnabled && (features === null || features === void 0 ? void 0 : features.shakaEnabled) !== undefined ? 'checkout' : 'shopping';

  var handleChange = function handleChange(e) {
    setText(e.target.value);
  };

  function updateGeoLocationState() {
    return _updateGeoLocationState.apply(this, arguments);
  }

  function _updateGeoLocationState() {
    _updateGeoLocationState = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee11() {
      return regenerator_default().wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              if (geoLocation) {
                if (geoLocation !== null && geoLocation !== void 0 && geoLocation.storeDetails) {
                  setStoreDetails(false);
                  setChangeMethods(false);
                  setChangeStore(false);
                }
              }

            case 1:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11);
    }));
    return _updateGeoLocationState.apply(this, arguments);
  }

  (0,react.useEffect)(function () {
    checkFeatures();
    window.scrollTo(0, 0);
    setTimeout(function () {
      var headerFragment = document.getElementById("headerFragment");
      var fragmentHeight;

      if (headerFragment) {
        fragmentHeight = (headerFragment === null || headerFragment === void 0 ? void 0 : headerFragment.offsetHeight) || 0;
        setPositionFromTop(fragmentHeight);
      }
    }, 1000);
    setHelpLeadBucket(constants/* LEAD_BUCKETS.general */.xO.general);
    updateGeoLocationState();
    emptyCartContainer();
  }, []);
  var btnConfig = {
    buttonStyle: "outline black",
    buttonLabel: "Start shopping"
  };

  var emptyCartContainer = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var emptyContainerData, resultData;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return ajaxServices/* default.httpGet */.Z.httpGet("drupalBaseUrl", "", "api", "shoppingCartEmpty");

            case 3:
              resultData = _context.sent;

              if (!(resultData.status === "success")) {
                _context.next = 8;
                break;
              }

              emptyContainerData = {
                icon: resultData.sections[0].items[0].icon,
                title: resultData.sections[0].items[0].title,
                callToActionUri: resultData.sections[0].callToActionUri,
                callToActionLabel: resultData.sections[0].callToActionLabel
              };
              _context.next = 9;
              break;

            case 8:
              throw new Error();

            case 9:
              _context.next = 15;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](0);
              console.log("error", _context.t0);
              emptyContainerData = {
                icon: "".concat(imagePrefix, "/assets/images/cart-o-copy.svg"),
                title: labels/* default */.Z === null || labels/* default */.Z === void 0 ? void 0 : labels/* default.lbl_empty_cart_msg */.Z.lbl_empty_cart_msg,
                callToActionUri: "internal:/products",
                callToActionLabel: btnConfig === null || btnConfig === void 0 ? void 0 : btnConfig.buttonLabel
              };

            case 15:
              _context.prev = 15;
              setStartEmptyCart(emptyContainerData);
              return _context.finish(15);

            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 11, 15, 18]]);
    }));

    return function emptyCartContainer() {
      return _ref2.apply(this, arguments);
    };
  }();

  (0,react.useEffect)(function () {
    var allow_place_order = cartDetails.allow_place_order;

    if (typeof allow_place_order !== "undefined" && Number(allow_place_order) === 0) {
      setCheckoutDisabled(true);
    } else {
      setCheckoutDisabled(false);
    }
  }, [cartDetails === null || cartDetails === void 0 ? void 0 : cartDetails.allow_place_order]);
  var monthlyCartProducts,
      repeatedDeal = [];
  var duplicateVas = false,
      maxVas = 0;

  var _splitCartItems = (0,helperServices/* splitCartItems */.zp)(cartProductItems),
      dealCartProducts = _splitCartItems.dealCartProducts,
      onceOffCartProducts = _splitCartItems.onceOffCartProducts;

  monthlyCartProducts = dealCartProducts; // ??? CQ

  var _iterator = cart_createForOfIteratorHelper(dealCartProducts),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _item = _step.value;

      for (var index = 0; index < _item.quantity; index++) {
        repeatedDeal.push(_item);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  monthlyCartProducts = repeatedDeal;
  var filteredDeals = monthlyCartProducts.filter(function (deal) {
    var _deal$product;

    return (deal === null || deal === void 0 ? void 0 : (_deal$product = deal.product) === null || _deal$product === void 0 ? void 0 : _deal$product.is_deal_product) === 1;
  });
  var manyMonthlyDeals = (filteredDeals === null || filteredDeals === void 0 ? void 0 : filteredDeals.length) > 1;
  (0,react.useEffect)(function () {
    if (manyMonthlyDeals) {
      filteredDeals.forEach(function (deal) {
        var _deal$product2;

        if ((deal === null || deal === void 0 ? void 0 : (_deal$product2 = deal.product) === null || _deal$product2 === void 0 ? void 0 : _deal$product2.is_deal_product) === 1 && (deal === null || deal === void 0 ? void 0 : deal.quantity) > 1) {
          updateCartProduct(cartId, deal === null || deal === void 0 ? void 0 : deal.id, 1, true);
        }
      });
    }
  }, [manyMonthlyDeals]);
  var dealSku = "",
      monthlyCartVasProducts = [];

  if (Array.isArray(dealCartProducts)) {
    dealCartProducts.forEach(function (item) {
      var _item$product;

      dealSku = item === null || item === void 0 ? void 0 : (_item$product = item.product) === null || _item$product === void 0 ? void 0 : _item$product.sku;
      cartProductItems.forEach(function (item) {
        if (item !== null && item !== void 0 && item.parent_product_sku && (item === null || item === void 0 ? void 0 : item.parent_product_sku) == dealSku) {
          monthlyCartVasProducts.push(item);
        }
      });
    });
  } else {
    var _monthlyCartProducts, _monthlyCartProducts$;

    dealSku = (_monthlyCartProducts = monthlyCartProducts) === null || _monthlyCartProducts === void 0 ? void 0 : (_monthlyCartProducts$ = _monthlyCartProducts.product) === null || _monthlyCartProducts$ === void 0 ? void 0 : _monthlyCartProducts$.sku;
    monthlyCartVasProducts = cartProductItems.filter(function (cartProduct) {
      return (cartProduct === null || cartProduct === void 0 ? void 0 : cartProduct.monthly_recurring) && (cartProduct === null || cartProduct === void 0 ? void 0 : cartProduct.parent_product_sku) == dealSku;
    });
  }

  var _iterator2 = cart_createForOfIteratorHelper(monthlyCartVasProducts),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _item2 = _step2.value;

      for (var _index = 0; _index < _item2.quantity; _index++) {
        repeatedDealVas.push(_item2);
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  monthlyCartVasProducts = repeatedDealVas;

  if (Array.isArray(monthlyCartVasProducts)) {
    var _iterator3 = cart_createForOfIteratorHelper(monthlyCartVasProducts),
        _step3;

    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var item = _step3.value;
        monthlyCartProducts.push(item);
        maxVas++;
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  }

  monthlyCartVasProducts.map(function (v) {
    var _v$product;

    return v === null || v === void 0 ? void 0 : (_v$product = v.product) === null || _v$product === void 0 ? void 0 : _v$product.sku;
  }).sort().sort(function (a, b) {
    if (a === b) duplicateVas = true;
  });
  var dealProduct = dealCartProducts.find(function (cartProduct) {
    var _cartProduct$product;

    return (cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product = cartProduct.product) === null || _cartProduct$product === void 0 ? void 0 : _cartProduct$product.__typename) === labels/* default.lbl_product_type_bundle */.Z.lbl_product_type_bundle;
  });
  var outOfStockFlag = false;
  var applicationType;

  if ((dealProduct === null || dealProduct === void 0 ? void 0 : (_dealProduct$customiz = dealProduct.customizable_options[0]) === null || _dealProduct$customiz === void 0 ? void 0 : (_dealProduct$customiz2 = _dealProduct$customiz.values[0]) === null || _dealProduct$customiz2 === void 0 ? void 0 : _dealProduct$customiz2.label.toLowerCase()) === labels/* default.deal_details.lbl_upgrade_deal_option_lower_case */.Z.deal_details.lbl_upgrade_deal_option_lower_case) {
    applicationType = labels/* default.deal_details.lbl_upgrade_deal_option */.Z.deal_details.lbl_upgrade_deal_option;
  } else {
    applicationType = labels/* default.deal_details.lbl_new_contract_deal */.Z.deal_details.lbl_new_contract_deal;
  }

  var subTotalIncludingTax = cartDetails === null || cartDetails === void 0 ? void 0 : (_cartDetails$prices = cartDetails.prices) === null || _cartDetails$prices === void 0 ? void 0 : (_cartDetails$prices$s = _cartDetails$prices.subtotal_including_tax) === null || _cartDetails$prices$s === void 0 ? void 0 : _cartDetails$prices$s.value;
  var alertFlag = (cartDetails === null || cartDetails === void 0 ? void 0 : cartDetails.totalQuantity) > (cartDetails === null || cartDetails === void 0 ? void 0 : (_cartDetails$cartLimi = cartDetails.cartLimits) === null || _cartDetails$cartLimi === void 0 ? void 0 : _cartDetails$cartLimi.cart_qty_limit) || subTotalIncludingTax > (cartDetails === null || cartDetails === void 0 ? void 0 : (_cartDetails$cartLimi2 = cartDetails.cartLimits) === null || _cartDetails$cartLimi2 === void 0 ? void 0 : _cartDetails$cartLimi2.order_value_limit) || cartProductItems.some(function (cartProduct) {
    var _cartProduct$product2;

    return (cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product2 = cartProduct.product) === null || _cartProduct$product2 === void 0 ? void 0 : _cartProduct$product2.stock_status) === labels/* default.lbl_out_of_stock */.Z.lbl_out_of_stock;
  }) || (cartDetails === null || cartDetails === void 0 ? void 0 : cartDetails.isMulti) && !features.multiCartEnabled || manyMonthlyDeals || duplicateVas || maxVas > 4;
  (0,react.useEffect)(function () {
    if (router.query && router.query.login && !profileLoading && !userLoggedIn) {
      var _redirectURL = loginUrl + "?redirectUrl=" + window.location.href.split("?")[0];

      return window.location.replace(_redirectURL);
    }
  }, [userLoggedIn, profileLoading]);
  (0,react.useEffect)(function () {
    setCartItems(cartProductItems);
    setAllPrices(prices);
  }, [cartProductItems, prices]);
  (0,react.useEffect)(function () {
    if (showSnackBar) {
      var timer = setTimeout(function () {
        return closeSnackBar();
      }, 3000);
      return function () {
        clearTimeout(timer);
      };
    }
  }, [showSnackBar]);
  (0,react.useEffect)(function () {
    if (true) {
      setRedirectURL(window.location.href);
    }

    setRefreshUser(false);
    setIsUserProfileSync(false);
    resetSyncUserProfile();
    router.prefetch("".concat(urlPrefix, "/shop"));
  }, []);
  (0,react.useEffect)(function () {
    function updateCartValue() {
      return _updateCartValue.apply(this, arguments);
    }

    function _updateCartValue() {
      _updateCartValue = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
        return regenerator_default().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                setLoadingState(true);
                showGuestCart(cartId).then(function (data) {
                  if ((data === null || data === void 0 ? void 0 : data.status) === 422) {
                    (0,helperServices/* handleCartActionFailure */.rO)(data, fetchProductItems, handleProfileSync);
                    setLoadingState(false);
                  } else {
                    if (updateCartDetails.includes("beforeCheckout")) {
                      checkStockStatusBeforeCheckout(data).then(function (stockStatus) {
                        if (stockStatus && stockStatus.some(function (item) {
                          return item.outOfStock;
                        })) {
                          // should not allow user to do checkout
                          return;
                        } // should allow user to do checkout


                        setTimeout(function () {
                          handleCheckout();
                        }, 3000);
                      })["catch"](function (err) {
                        console.log("An error occurred, unable to check stock status", err);
                        setLoadingState(false);
                      });
                    }

                    fetchProductItems();
                  }
                })["catch"](function (err) {
                  console.log("An error occurred, unable to fetch showGuestCart", err);
                  setLoadingState(false);
                });

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return _updateCartValue.apply(this, arguments);
    }

    if (cartId && updateCartDetails) {
      updateCartValue();
    }
  }, [updateCartDetails]);
  /**
   * To check each cart item is OUT_OF_STOCK or IN_STOCK
   * @param {*} cartData
   * @returns boolean values for each existing item
   */

  var checkStockStatusBeforeCheckout = function checkStockStatusBeforeCheckout(cartData) {
    return new Promise(function (resolve) {
      try {
        if (cartData) {
          var cartItemStockStatus = [];
          cartData.cart.items.map(function (item) {
            if (item) {
              if (item.product.stock_status.includes("OUT_OF_STOCK")) {
                cartItemStockStatus.push({
                  productId: item.product.id,
                  variantId: undefined,
                  outOfStock: true
                });
              } else {
                var selectedConfigurableOptions = item.configurable_options.map(function (selectedItem) {
                  return selectedItem.value_id;
                });
                var getSelectedVariant = item.product.variants.map(function (variantItem) {
                  var selectedVariant = variantItem.attributes.filter(function (vItem) {
                    return selectedConfigurableOptions.some(function (sItem) {
                      return sItem === vItem.value_index;
                    });
                  });

                  if (selectedVariant.length === selectedConfigurableOptions.length) {
                    return variantItem;
                  }
                });

                if (getSelectedVariant.length) {
                  getSelectedVariant.map(function (vStatus) {
                    if (vStatus) {
                      if (vStatus.product.stock_status.includes("OUT_OF_STOCK")) {
                        cartItemStockStatus.push({
                          productId: item.product.id,
                          variantId: vStatus.product.id,
                          outOfStock: true
                        });
                      } else {
                        cartItemStockStatus.push({
                          productId: item.product.id,
                          variantId: vStatus.product.id,
                          outOfStock: false
                        });
                      }
                    }
                  });
                }
              }
            }
          });
          resolve(cartItemStockStatus);
        }
      } catch (error) {
        resolve([]);
      }
    });
  };

  var handleProfileSync = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3() {
      var JWTtoken, cartId, pageAction, dataResult, oAuthToken, _oAuthToken, getLoggedInCardId;

      return regenerator_default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              setLoadingState(true);
              JWTtoken = (0,helperServices/* getCookieValue */.Do)("vod-web-auth-token");
              cartId = (0,helperServices/* getCookieValue */.Do)("cart_id");
              pageAction = "CartProductCard";
              _context3.next = 6;
              return syncUserProfile({
                JWTtoken: JWTtoken,
                cartId: cartId,
                pageAction: pageAction
              });

            case 6:
              dataResult = _context3.sent;

              if (!(dataResult.type === actionTypes/* SYNC_USER_PROFILE_SUCCESS */.Zd)) {
                _context3.next = 21;
                break;
              }

              if (!(dataResult.requestPayload.cartId && dataResult.requestPayload.cartId.length)) {
                _context3.next = 13;
                break;
              }

              oAuthToken = (0,helperServices/* getAuthToken */.bW)(dataResult);

              if (oAuthToken) {
                fetchProductItems();
              }

              _context3.next = 19;
              break;

            case 13:
              _oAuthToken = (0,helperServices/* getAuthToken */.bW)(dataResult);

              if (!_oAuthToken) {
                _context3.next = 19;
                break;
              }

              _context3.next = 17;
              return (0,helperServices/* getCustomerActiveCartService */.t5)();

            case 17:
              getLoggedInCardId = _context3.sent;

              if (getLoggedInCardId && !getLoggedInCardId.fail && getLoggedInCardId.length) {
                (0,helperServices/* setCookieConsentWrapper */.ol)("cart_id", [(config_default()).cookie_category.strictly_necessary], "document.cookie='cart_id=".concat(getLoggedInCardId, ";path=/'"));
                fetchProductItems();
              }

            case 19:
              _context3.next = 24;
              break;

            case 21:
              fetchProductItems();
              resetSyncUserProfile();
              setLoadingState(false);

            case 24:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function handleProfileSync() {
      return _ref3.apply(this, arguments);
    };
  }();

  (0,react.useEffect)(function () {
    resetGuestCart();
    if (cartId) fetchProductItems();
    analyticsUtag/* setAutoTagging */.fv(false);
  }, []);

  var fetchProductItems = /*#__PURE__*/function () {
    var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4() {
      var cartId, viewed, product, ids, dealFound;
      return regenerator_default().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              cartId = (0,helperServices/* getCookieValue */.Do)("cart_id");
              setLoadingState(true);
              _context4.next = 4;
              return getShippingAndBilling(cartId);

            case 4:
              if (productsCookie) {
                viewed = JSON.parse(productsCookie);
                ids = viewed.map(function (product) {
                  return product.sku;
                });
              }

              showGuestCart(cartId).then(function (guestCartProductsData) {
                if (guestCartProductsData && guestCartProductsData !== null && guestCartProductsData !== void 0 && guestCartProductsData.errors || (guestCartProductsData === null || guestCartProductsData === void 0 ? void 0 : guestCartProductsData.status) === 500) {
                  if ((guestCartProductsData === null || guestCartProductsData === void 0 ? void 0 : guestCartProductsData.status) === 422) {
                    (0,helperServices/* handleCartActionFailure */.rO)(guestCartProductsData, fetchProductItems, handleProfileSync);
                  } else {
                    var _guestCartProductsDat, _guestCartProductsDat2, _guestCartProductsDat3;

                    var cartNotEmpty = guestCartProductsData === null || guestCartProductsData === void 0 ? void 0 : (_guestCartProductsDat = guestCartProductsData.cart) === null || _guestCartProductsDat === void 0 ? void 0 : (_guestCartProductsDat2 = _guestCartProductsDat.items) === null || _guestCartProductsDat2 === void 0 ? void 0 : _guestCartProductsDat2.some(function (i) {
                      return i === null || i === void 0 ? void 0 : i.product;
                    });

                    if (!cartNotEmpty || guestCartProductsData.status === 500) {
                      setCartApiError(true);
                    }

                    var analyticsData = analyticsUtag/* getUtagData */.GS(["visitor_login_status", "visitor_customer_id", "visitor_subscription_type", "visitor_msisdn_hash"]);
                    analyticsUtag/* link */.p4({
                      page_name: "shopping: cart",
                      page_form_event: "error",
                      page_errors: "".concat(guestCartProductsData.errors ? (_guestCartProductsDat3 = guestCartProductsData.errors) === null || _guestCartProductsDat3 === void 0 ? void 0 : _guestCartProductsDat3[0].message : ""),
                      page_errors_code: "cart-dxl-p-pl-".concat(guestCartProductsData.status)
                    });
                    analyticsUtag/* view */.ei(cart_objectSpread({
                      page_event: "view",
                      page_name: "page not loaded error",
                      page_channel: "shopping",
                      page_master_tab: "personal"
                    }, analyticsData));
                  }
                }

                if (guestCartProductsData) {
                  var _guestCartProductsDat4, _guestCartProductsDat6, _guestCartProductsDat8, _guestCartProductsDat9;

                  if (guestCartProductsData !== null && guestCartProductsData !== void 0 && (_guestCartProductsDat4 = guestCartProductsData.cart) !== null && _guestCartProductsDat4 !== void 0 && _guestCartProductsDat4.items) {
                    var _guestCartProductsDat5;

                    setCartItems((0,helperServices/* mapCartProductItems */.$T)((guestCartProductsData === null || guestCartProductsData === void 0 ? void 0 : (_guestCartProductsDat5 = guestCartProductsData.cart) === null || _guestCartProductsDat5 === void 0 ? void 0 : _guestCartProductsDat5.items) || []));
                  }

                  if (guestCartProductsData !== null && guestCartProductsData !== void 0 && (_guestCartProductsDat6 = guestCartProductsData.cart) !== null && _guestCartProductsDat6 !== void 0 && _guestCartProductsDat6.prices) {
                    var _guestCartProductsDat7;

                    setAllPrices(guestCartProductsData === null || guestCartProductsData === void 0 ? void 0 : (_guestCartProductsDat7 = guestCartProductsData.cart) === null || _guestCartProductsDat7 === void 0 ? void 0 : _guestCartProductsDat7.prices);
                  }

                  var userMetaData = analyticsUtag/* getProfileData */.$y(userLoggedIn, profileData);

                  if (guestCartProductsData !== null && guestCartProductsData !== void 0 && (_guestCartProductsDat8 = guestCartProductsData.cart) !== null && _guestCartProductsDat8 !== void 0 && (_guestCartProductsDat9 = _guestCartProductsDat8.items) !== null && _guestCartProductsDat9 !== void 0 && _guestCartProductsDat9.length) {
                    var _guestCartProductsDat10;

                    var sales_order_discount = [];
                    var sales_product_category = [];
                    var sales_product_id = [];
                    var sales_product_price = [];
                    var sales_product_quantity = [];
                    var sales_promo_name = [];
                    var page_tool_event = [];
                    var page_tool_name = [];
                    var stockStatus = [];
                    var filteredCartProducts = (0,helperServices/* mapCartProductItems */.$T)((guestCartProductsData === null || guestCartProductsData === void 0 ? void 0 : (_guestCartProductsDat10 = guestCartProductsData.cart) === null || _guestCartProductsDat10 === void 0 ? void 0 : _guestCartProductsDat10.items) || []);
                    filteredCartProducts.forEach(function (item) {
                      var _item$product2, _item$prices, _item$prices$row_tota, _item$prices2, _item$prices2$row_tot, _item$product3, _item$product4, _item$prices3, _item$product5, _item$product5$catego, _item$product6, _item$product7, _item$product9, _item$product10;

                      var isDealProduct = (item === null || item === void 0 ? void 0 : (_item$product2 = item.product) === null || _item$product2 === void 0 ? void 0 : _item$product2.is_deal_product) === 1;
                      var sales_order_discount_value = Math.abs((item === null || item === void 0 ? void 0 : (_item$prices = item.prices) === null || _item$prices === void 0 ? void 0 : (_item$prices$row_tota = _item$prices.row_total_original) === null || _item$prices$row_tota === void 0 ? void 0 : _item$prices$row_tota.value) - (item === null || item === void 0 ? void 0 : (_item$prices2 = item.prices) === null || _item$prices2 === void 0 ? void 0 : (_item$prices2$row_tot = _item$prices2.row_total_including_tax) === null || _item$prices2$row_tot === void 0 ? void 0 : _item$prices2$row_tot.value));
                      sales_order_discount.push("".concat(sales_order_discount_value));
                      sales_product_id.push(item === null || item === void 0 ? void 0 : (_item$product3 = item.product) === null || _item$product3 === void 0 ? void 0 : _item$product3.name);
                      sales_product_price.push("".concat(isDealProduct ? item === null || item === void 0 ? void 0 : (_item$product4 = item.product) === null || _item$product4 === void 0 ? void 0 : _item$product4.monthly_recurring : item === null || item === void 0 ? void 0 : (_item$prices3 = item.prices) === null || _item$prices3 === void 0 ? void 0 : _item$prices3.row_total_including_tax.value));
                      sales_product_quantity.push("".concat(item === null || item === void 0 ? void 0 : item.quantity));
                      sales_product_category.push(item === null || item === void 0 ? void 0 : (_item$product5 = item.product) === null || _item$product5 === void 0 ? void 0 : (_item$product5$catego = _item$product5.categories[item === null || item === void 0 ? void 0 : (_item$product6 = item.product) === null || _item$product6 === void 0 ? void 0 : _item$product6.is_deal_product]) === null || _item$product5$catego === void 0 ? void 0 : _item$product5$catego.name);

                      if (item !== null && item !== void 0 && (_item$product7 = item.product) !== null && _item$product7 !== void 0 && _item$product7.promotion_tag_label) {
                        var _item$product8;

                        sales_promo_name.push(item === null || item === void 0 ? void 0 : (_item$product8 = item.product) === null || _item$product8 === void 0 ? void 0 : _item$product8.promotion_tag_label);
                      } else {
                        sales_promo_name.push("");
                      }

                      if ((item === null || item === void 0 ? void 0 : (_item$product9 = item.product) === null || _item$product9 === void 0 ? void 0 : _item$product9.stock_status.toLowerCase()) === "out_of_stock") {
                        page_tool_event.push("use");
                        page_tool_name.push("shopping:cart:out of stock");
                      } else {
                        page_tool_event.push("");
                        page_tool_name.push("");
                      }

                      stockStatus.push(item.isDealProduct && item.isOutOfStock ? "no_longer_available" : item === null || item === void 0 ? void 0 : (_item$product10 = item.product) === null || _item$product10 === void 0 ? void 0 : _item$product10.stock_status.toLowerCase());
                    });

                    var _analyticsData = cart_objectSpread({
                      page_event: "view",
                      page_name: "shopping: cart",
                      page_channel: "shopping",
                      page_master_tab: "personal",
                      sales_event: "cart_view, cart_open",
                      sales_order_discount: sales_order_discount,
                      sales_product_category: sales_product_category,
                      sales_product_id: sales_product_id,
                      sales_product_price: sales_product_price,
                      sales_product_quantity: sales_product_quantity,
                      sales_promo_name: sales_promo_name,
                      out_of_stock: stockStatus
                    }, userMetaData);

                    _analyticsData.multicart_flag = cartDetails !== null && cartDetails !== void 0 && cartDetails.isMulti ? true : false;
                    analyticsUtag/* view */.ei(_analyticsData); //check if there is at least 1 product that is Pre-order

                    checkPreOrder(guestCartProductsData);
                  } else {
                    analyticsUtag/* view */.ei(cart_objectSpread({
                      page_event: "view",
                      page_name: "shopping: cart",
                      page_form_event: "error",
                      page_errors: "You don't have anything in your cart right now",
                      page_channel: "shopping",
                      page_master_tab: "personal",
                      sales_event: "cart_view,cart_open",
                      sales_order_discount: "",
                      sales_product_category: "",
                      sales_product_id: "",
                      sales_product_price: "",
                      sales_product_quantity: ["0"]
                    }, userMetaData));
                  }
                }
              });

              if (!(0,helperServices/* isArrayNotEmpty */.wh)(viewed)) {
                _context4.next = 11;
                break;
              }

              _context4.next = 9;
              return ajaxServices/* default.fetchGraphQLPOSTRequest */.Z.fetchGraphQLPOSTRequest(queries/* CartRecentProducts */.R6, {
                ids: ids
              });

            case 9:
              product = _context4.sent;

              if (product && product.products && product.products.items && product.products.items.length) {
                setProductItems(product.products.items); //disable checkout button if different types of products in the cart

                dealFound = product.products.items.filter(function (item) {
                  return item.is_deal_product == 1;
                });

                if (dealFound.length !== 0 && dealFound.length !== product.products.items.length || dealFound.length > 1) {
                  setContinueDisabled(true);
                } else {
                  setContinueDisabled(false);
                }
              }

            case 11:
              setLoadingState(false);

            case 12:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function fetchProductItems() {
      return _ref4.apply(this, arguments);
    };
  }();

  (0,react.useEffect)(function () {
    if (updatedCookieProduct && updatedCookieProduct.length > 0 && productItems.length > 0) {
      var checkProduct, updatedProducts;
      checkProduct = productItems.some(function (products) {
        return updatedCookieProduct.some(function (cookieProducts) {
          return cookieProducts.sku === products.sku;
        });
      });

      if (checkProduct) {
        updatedProducts = productItems.filter(function (products) {
          return updatedCookieProduct.some(function (cookieProducts) {
            return cookieProducts.sku === products.sku;
          });
        }).sort(function (a, b) {
          return updatedCookieProduct.findIndex(function (cookie) {
            return cookie.sku === a.sku;
          }) - updatedCookieProduct.findIndex(function (cookie) {
            return cookie.sku === b.sku;
          });
        });
        var productCookie = updatedProducts.map(function (cookieProduct) {
          var obj = {
            sku: cookieProduct.sku
          };

          if (cookieProduct.__typename === labels/* default.lbl_product_typeName_configurable */.Z.lbl_product_typeName_configurable && cookieProduct.variants && cookieProduct.variants.length > 0) {
            var cookieVariantConfig = updatedCookieProduct.find(function (config) {
              var _config$variantConfig;

              return (config === null || config === void 0 ? void 0 : (_config$variantConfig = config.variantConfig) === null || _config$variantConfig === void 0 ? void 0 : _config$variantConfig.sku) === cookieProduct.sku;
            });
            obj.variantConfig = cookieVariantConfig === null || cookieVariantConfig === void 0 ? void 0 : cookieVariantConfig.variantConfig;
          }

          return obj;
        });
        setUpdatedCookieProduct((0,toConsumableArray/* default */.Z)(productCookie));
      }
    }

    if (productItems.length > 0) {
      var cookieSkus = (0,helperServices/* getCookieValue */.Do)("rv_products");
      var parsedSkus;

      if (cookieSkus) {
        parsedSkus = JSON.parse(cookieSkus);
      }

      setProductsViewed((0,helperServices/* getProductsCookie */.X$)(parsedSkus, productItems));
    }
  }, [productItems]);

  if (true) {
    (0,helperServices/* setCookieConsentWrapper */.ol)("products_cookie", [config.cookie_category.strictly_necessary], "document.cookie='products=".concat(encodeURIComponent(JSON.stringify(updatedCookieProduct).replace(/'/g, "\\'")), ";path=/'"));
  }

  var beforeCheckout = function beforeCheckout() {
    var randomNumber = Math.floor(Math.random() * 10) + 1;
    setUpdateCartDetails("beforeCheckout-".concat(randomNumber));
    setCheckoutLogin(true);
  };

  var onlyOnceOffProducts = !cartDetails.contract && cartDetails.onceOff;
  var onlyOneDeal = cartDetails.contract && !cartDetails.onceOff;

  if (!onlyOneDeal) {
    var isVas = 0;
    var dealsSku;
    cartItems.forEach(function (item) {
      var _item$product11;

      if ((item === null || item === void 0 ? void 0 : (_item$product11 = item.product) === null || _item$product11 === void 0 ? void 0 : _item$product11.is_deal_product) === 1) {
        var _item$product12;

        dealsSku = item === null || item === void 0 ? void 0 : (_item$product12 = item.product) === null || _item$product12 === void 0 ? void 0 : _item$product12.sku;
      }

      if (item !== null && item !== void 0 && item.monthly_recurring && (item === null || item === void 0 ? void 0 : item.parent_product_sku) == dealsSku) {
        isVas++;
      }
    });

    if (isVas > 0) {
      onlyOneDeal = true;
    }
  }

  var handleCheckout = function handleCheckout() {
    setLoadingState(true);

    var analyticsData = cart_objectSpread({
      page_name: "shopping: cart",
      page_channel: "shopping",
      page_master_tab: "personal",
      sales_event: "order_checkout",
      link_type: "o",
      link_name: "shopping: cart: checkout now"
    }, analyticsUtag/* getUtagData */.GS(["visitor_login_status", "visitor_subscription_type", "visitor_id_has", "visitor_msisdn_hash"]));

    analyticsUtag/* link */.p4(analyticsData);
    DependencyHelper.Cookie.remove("product_id");
    setCheckoutLogin(false);

    if (!profileLoading && !userLoggedIn && (0,helperServices/* isArrayNotEmpty */.wh)(monthlyCartProducts) && monthlyCartProducts.length - maxVas === 1) {
      if (true) {
        setRedirectURL("".concat(window.location.origin).concat(urlPrefix, "/post-checkout"));
      }

      setShowLoginModal(true);
    } else if (userLoggedIn && (0,helperServices/* isArrayNotEmpty */.wh)(monthlyCartProducts) && monthlyCartProducts.length - maxVas === 1) {
      if (applicationType === labels/* default.deal_details.lbl_upgrade_deal_option */.Z.deal_details.lbl_upgrade_deal_option) {
        if (features !== null && features !== void 0 && features.upgradeEnabled) {
          router.push("".concat(urlPrefix, "/post-checkout")).then(function () {
            window.scrollTo(0, 0);
            setLoadingState(false);
          });
        } else {
          var _dealProduct$product, _dealProduct$product2;

          (0,upgradeService/* handoverUpgradeeSession */.I0)(canReciveOTP, isChildAllowed, upgradeResponse);
          router.push("https://www".concat(legacyEnv, ".vodacom.co.za/cloud/shopping/order-summary?salesChannel=Upgrade&dealId=").concat(dealProduct === null || dealProduct === void 0 ? void 0 : (_dealProduct$product = dealProduct.product) === null || _dealProduct$product === void 0 ? void 0 : _dealProduct$product.id, "&dealSheetNumber=").concat(dealProduct === null || dealProduct === void 0 ? void 0 : (_dealProduct$product2 = dealProduct.product) === null || _dealProduct$product2 === void 0 ? void 0 : _dealProduct$product2.sku).concat(isMiniApp ? "&miniApp=true" : ""));
        }
      } else {
        if (features !== null && features !== void 0 && features.addLineEnabled || features !== null && features !== void 0 && features.newLineEnabled) {
          router.push("".concat(urlPrefix, "/post-checkout")).then(function () {
            window.scrollTo(0, 0);
            setLoadingState(false);
          });
        } else {
          var _dealProduct$product3;

          router.push("https://www".concat(legacyEnv, ".vodacom.co.za/cloud/").concat(newRedirectURL, "/order-summary?salesChannel=Contract&dealSheetNumber=").concat(dealProduct === null || dealProduct === void 0 ? void 0 : (_dealProduct$product3 = dealProduct.product) === null || _dealProduct$product3 === void 0 ? void 0 : _dealProduct$product3.sku).concat(isMiniApp ? "&miniApp=true" : ""));
        }
      }
    } else if (!profileLoading && !userLoggedIn && onlyOnceOffProducts) {
      if (true) {
        setRedirectURL("".concat(window.location.origin).concat(urlPrefix, "/checkout"));
      }

      setShowLoginModal(true);
    } else if (userLoggedIn && cartDetails !== null && cartDetails !== void 0 && cartDetails.isMulti) {
      router.push("".concat(urlPrefix, "/post-checkout")).then(function () {
        window.scrollTo(0, 0);
        setLoadingState(false);
      });
    } else {
      router.push("".concat(urlPrefix, "/checkout")).then(function () {
        window.scrollTo(0, 0);
        setLoadingState(false);
      });
    }

    var sales_order_discount = [];
    var sales_product_category = [];
    var sales_product_id = [];
    var sales_product_price = [];
    var sales_product_quantity = [];
    var sales_promo_name = [];
    cartProductItems.forEach(function (item) {
      var _item$product13, _item$product14, _item$product14$categ, _item$product14$categ2, _item$product15;

      sales_order_discount.push("".concat((0,helperServices/* getAmountOffValue */.Dd)(item === null || item === void 0 ? void 0 : item.product)));
      sales_product_id.push(item === null || item === void 0 ? void 0 : (_item$product13 = item.product) === null || _item$product13 === void 0 ? void 0 : _item$product13.name);
      sales_product_price.push("".concat((0,helperServices/* getFinalPrice */.eZ)(item === null || item === void 0 ? void 0 : item.product)));
      sales_product_quantity.push("".concat(item === null || item === void 0 ? void 0 : item.quantity));
      sales_product_category.push(item === null || item === void 0 ? void 0 : (_item$product14 = item.product) === null || _item$product14 === void 0 ? void 0 : (_item$product14$categ = _item$product14.categories) === null || _item$product14$categ === void 0 ? void 0 : (_item$product14$categ2 = _item$product14$categ[0]) === null || _item$product14$categ2 === void 0 ? void 0 : _item$product14$categ2.name);

      if (item !== null && item !== void 0 && (_item$product15 = item.product) !== null && _item$product15 !== void 0 && _item$product15.promotion_tag_label) {
        var _item$product16;

        sales_promo_name.push(item === null || item === void 0 ? void 0 : (_item$product16 = item.product) === null || _item$product16 === void 0 ? void 0 : _item$product16.promotion_tag_label);
      } else {
        sales_promo_name.push("");
      }
    });
    setLoadingState(false);
  };

  var handleApplyCode = /*#__PURE__*/function () {
    var _ref5 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee5(code) {
      var result, _result$applyCouponTo, _result$applyCouponTo2, _result$applyCouponTo3, _result$applyCouponTo4, _result$applyCouponTo5, _result$applyCouponTo6, sales_order_discount, sales_product_category, sales_product_id, sales_product_price, sales_product_quantity, sales_promo_name, sales_voucher_discount, totalValue;

      return regenerator_default().wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              if (!(text === "")) {
                _context5.next = 2;
                break;
              }

              return _context5.abrupt("return");

            case 2:
              setLoadingState(true);
              _context5.next = 5;
              return addCouponToCart(cartId, code);

            case 5:
              result = _context5.sent;
              setLoadingState(false);

              if (result && result.errors && result.errors.length > 0 && result.errors[0].message && result.errors[0].message === labels/* default.lbl_magento_invalid_coupon_error */.Z.lbl_magento_invalid_coupon_error || result && result.errors && result.errors.length > 0 && result.errors[0].message) {
                window.scrollTo(0, 0);
                setShowCouponAlert(true);
                analyticsUtag/* link */.p4({
                  page_name: "shopping: cart",
                  page_form_name: "shopping: cart: voucher",
                  page_form_event: "error",
                  page_errors: labels/* default.lbl_magento_invalid_coupon_error */.Z.lbl_magento_invalid_coupon_error,
                  page_errors_code: "cart-dxl-p-ac-".concat(result.status),
                  sales_voucher_name: code
                });
              } else {
                setShowCouponAlert(false);
              }

              if (result && !result.errors) {
                closePromoModal();
                setUpdateCartDetails("addedCoupon");
                setUpdateMsg(false);
                setRemoveMsg(false);
                setRemoveCoupon(false);
                setShowSnackBar(true);
                setAddCoupon(true);
                setIsDealRemove(false);
                setText("");
                sales_order_discount = [];
                sales_product_category = [];
                sales_product_id = [];
                sales_product_price = [];
                sales_product_quantity = [];
                sales_promo_name = [];
                sales_voucher_discount = [];
                cartProductItems.forEach(function (item) {
                  var _item$product17, _item$prices4, _item$product18, _item$product18$categ, _item$product18$categ2, _item$prices5, _item$prices5$row_tot, _item$prices6, _item$prices6$row_tot, _item$product19;

                  sales_product_id.push(item === null || item === void 0 ? void 0 : (_item$product17 = item.product) === null || _item$product17 === void 0 ? void 0 : _item$product17.name);
                  sales_product_price.push("".concat(item === null || item === void 0 ? void 0 : (_item$prices4 = item.prices) === null || _item$prices4 === void 0 ? void 0 : _item$prices4.row_total_including_tax.value));
                  sales_product_quantity.push("".concat(item === null || item === void 0 ? void 0 : item.quantity));
                  sales_product_category.push((item === null || item === void 0 ? void 0 : (_item$product18 = item.product) === null || _item$product18 === void 0 ? void 0 : (_item$product18$categ = _item$product18.categories) === null || _item$product18$categ === void 0 ? void 0 : (_item$product18$categ2 = _item$product18$categ[0]) === null || _item$product18$categ2 === void 0 ? void 0 : _item$product18$categ2.name) || "");
                  var sales_order_discount_value = Math.abs((item === null || item === void 0 ? void 0 : (_item$prices5 = item.prices) === null || _item$prices5 === void 0 ? void 0 : (_item$prices5$row_tot = _item$prices5.row_total_original) === null || _item$prices5$row_tot === void 0 ? void 0 : _item$prices5$row_tot.value) - (item === null || item === void 0 ? void 0 : (_item$prices6 = item.prices) === null || _item$prices6 === void 0 ? void 0 : (_item$prices6$row_tot = _item$prices6.row_total_including_tax) === null || _item$prices6$row_tot === void 0 ? void 0 : _item$prices6$row_tot.value));
                  sales_order_discount.push("".concat(sales_order_discount_value));

                  if (item !== null && item !== void 0 && (_item$product19 = item.product) !== null && _item$product19 !== void 0 && _item$product19.promotion_tag_label) {
                    var _item$product20;

                    sales_promo_name.push(item === null || item === void 0 ? void 0 : (_item$product20 = item.product) === null || _item$product20 === void 0 ? void 0 : _item$product20.promotion_tag_label);
                  } else {
                    sales_promo_name.push("");
                  }
                });
                totalValue = result === null || result === void 0 ? void 0 : (_result$applyCouponTo = result.applyCouponToCart) === null || _result$applyCouponTo === void 0 ? void 0 : (_result$applyCouponTo2 = _result$applyCouponTo.cart) === null || _result$applyCouponTo2 === void 0 ? void 0 : (_result$applyCouponTo3 = _result$applyCouponTo2.prices) === null || _result$applyCouponTo3 === void 0 ? void 0 : (_result$applyCouponTo4 = _result$applyCouponTo3.grand_total) === null || _result$applyCouponTo4 === void 0 ? void 0 : _result$applyCouponTo4.value;
                result === null || result === void 0 ? void 0 : (_result$applyCouponTo5 = result.applyCouponToCart) === null || _result$applyCouponTo5 === void 0 ? void 0 : (_result$applyCouponTo6 = _result$applyCouponTo5.cart) === null || _result$applyCouponTo6 === void 0 ? void 0 : _result$applyCouponTo6.items.map(function (cartItem) {
                  var _cartItem$prices, _cartItem$prices$tota;

                  sales_voucher_discount.push("".concat(cartItem === null || cartItem === void 0 ? void 0 : (_cartItem$prices = cartItem.prices) === null || _cartItem$prices === void 0 ? void 0 : (_cartItem$prices$tota = _cartItem$prices.total_item_discount) === null || _cartItem$prices$tota === void 0 ? void 0 : _cartItem$prices$tota.value));
                });
                analyticsUtag/* link */.p4(cart_objectSpread(cart_objectSpread({}, analyticsUtag/* getUtagData */.GS(["page_name", "page_channel", "page_master_tab", "visitor_login_status", "visitor_msisdn_hash", "visitor_customer_id", "visitor_id_hash", "visitor_subscription_type"])), {}, {
                  sales_event: "sales_voucher_redemption",
                  page_tool_event: "use",
                  page_tool_name: "shopping: cart: add voucher",
                  sales_voucher_name: code,
                  sales_product_category: sales_product_category,
                  sales_product_price: sales_product_price,
                  sales_product_quantity: sales_product_quantity,
                  sales_order_discount: sales_order_discount,
                  sales_promo_name: sales_promo_name,
                  sales_product_id: sales_product_id,
                  sales_order_sub_total: "".concat(totalValue),
                  sales_voucher_discount: sales_voucher_discount
                }));
                setVoucherAnalytics({
                  sales_voucher_discount: sales_voucher_discount
                });
              }

            case 9:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function handleApplyCode(_x) {
      return _ref5.apply(this, arguments);
    };
  }();

  var hideCouponAlert = function hideCouponAlert() {
    setShowCouponAlert(false);
  };

  var showPromoModal = function showPromoModal() {
    setShowModal(true);
  };

  var closePromoModal = function closePromoModal() {
    setShowModal(false);
  };

  var renderPromoCodeSection = /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PromoTextCard, {
      label: labels/* default.lbl_promocode_query */.Z.lbl_promocode_query,
      placeholder: labels/* default.lbl_enter_promo */.Z.lbl_enter_promo,
      img_url: "".concat(imagePrefix, "/assets/images/caret-right.svg"),
      img_width: 11,
      img_height: 11,
      onSelect: showPromoModal,
      className: "promo-section"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextBoxCard, {
      text: text,
      label: labels/* default.lbl_promocode_query */.Z.lbl_promocode_query,
      placeHolder: labels/* default.lbl_enter_promo */.Z.lbl_enter_promo,
      buttonText: labels/* default.lbl_apply_code */.Z.lbl_apply_code,
      buttonHandler: handleApplyCode,
      className: "promo-section-box",
      handleChange: handleChange
    }), isTablet && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
      className: "border-style"
    })]
  });

  var urlRedirect = function urlRedirect(url) {
    if (url.includes("internal:")) {
      url = url.split("internal:")[1];
    }

    router.push("".concat(urlPrefix).concat(url)).then(function () {
      window.scrollTo(0, 0);
      setLoadingState(false);
    });
  };

  var goToProducts = function goToProducts() {
    setLoadingState(true);
    urlRedirect(startEmptyCart === null || startEmptyCart === void 0 ? void 0 : startEmptyCart.callToActionUri);
    analyticsUtag/* link */.p4(cart_objectSpread({
      link_type: "o",
      link_name: "shopping: cart: start shopping"
    }, analyticsUtag/* getUtagData */.GS(["page_name", "page_channel", "page_master_tab", "visitor_login_status", "visitor_msisdn_hash", "visitor_customer_id", "visitor_id_hash", "visitor_subscription_type"])));
  };

  var closeSnackBar = function closeSnackBar() {
    setShowSnackBar(false);
  };

  var emptyContainer = /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
    className: "mainContainer",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Image, {
      img_path: startEmptyCart === null || startEmptyCart === void 0 ? void 0 : startEmptyCart.icon,
      img_width: "5rem",
      img_height: "5rem"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(cart_LabelText, {
      className: "content",
      children: startEmptyCart === null || startEmptyCart === void 0 ? void 0 : startEmptyCart.title
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
      className: "buttonContainer",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(cart_CTAButton, {
        className: "roundBtn",
        variant: btnConfig.buttonStyle,
        handleClick: goToProducts,
        id: startEmptyCart === null || startEmptyCart === void 0 ? void 0 : startEmptyCart.callToActionLabel,
        children: startEmptyCart === null || startEmptyCart === void 0 ? void 0 : startEmptyCart.callToActionLabel
      })
    })]
  });

  var renderInvalidCouponAlert = function renderInvalidCouponAlert() {
    var customProps = {};

    if (positionFromTop) {
      customProps.customStyle = {
        top: (isMobile || isTablet) && showModal ? 0 : positionFromTop
      };
    } else {
      customProps.className = "error_tool_tip";
    }

    return /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorTooltip/* default */.Z, cart_objectSpread({
      errorMsg: errorMsg === labels/* default.lbl_magento_invalid_coupon_error */.Z.lbl_magento_invalid_coupon_error ? labels/* default.lbl_invalid_coupon */.Z.lbl_invalid_coupon : errorMsg,
      buttonHandler: hideCouponAlert,
      type: "warning"
    }, customProps));
  };

  var chkOutOfStockItems = function chkOutOfStockItems() {
    return cartDetails.cartProductItems.every(function (e) {
      return e.isOutOfStock === true;
    });
  };

  var renderOutOfStockMessage = function renderOutOfStockMessage() {
    var scenario = 0;
    var errMsg = errorMessages/* default.out_of_stock.any_out_of_stock */.Z.out_of_stock.any_out_of_stock;
    /*
               1: // standalone out of stock
               2: // Low stock
               3: // Postpaid only - Backorder
               - 4: // Multi - Postpaid on backorder
               5: // Multi - Once-off out of stock
               - 6: // Multi - contract out of stock x
               7: // Multi - Both out of stock
               8: // Multi - Postpaid on pre-order
               9: // Contract only out of stock
              10: // Only one type product allowed
              11: // Only one deal allowed
              12: // Only unique vas allowed
              13: // Only 4 vas allowed
              14: // Both standalone and deal out of stock
        */

    if (!(cartDetails !== null && cartDetails !== void 0 && cartDetails.isMulti) && cartDetails !== null && cartDetails !== void 0 && cartDetails.contractMissed) {
      scenario = 9;
    }

    if (cartDetails !== null && cartDetails !== void 0 && cartDetails.onceOffMissed) {
      scenario = cartDetails !== null && cartDetails !== void 0 && cartDetails.isMulti ? 5 : 1;
      outOfStockFlag = true;
    }

    if (cartDetails !== null && cartDetails !== void 0 && cartDetails.contractMissed) {
      scenario = cartDetails !== null && cartDetails !== void 0 && cartDetails.isMulti ? 6 : 3;

      if (!(cartDetails !== null && cartDetails !== void 0 && cartDetails.hasBackOrder)) {
        outOfStockFlag = true;
      }
    }

    if (cartDetails !== null && cartDetails !== void 0 && cartDetails.isMulti && cartDetails !== null && cartDetails !== void 0 && cartDetails.contractMissed && cartDetails !== null && cartDetails !== void 0 && cartDetails.onceOffMissed) {
      scenario = 7;
    }

    if (cartDetails !== null && cartDetails !== void 0 && cartDetails.hasPreOrder) {
      scenario = 8;
    }

    if (cartDetails !== null && cartDetails !== void 0 && cartDetails.isMulti && !features.multiCartEnabled && typeof features.multiCartEnabled === "boolean") {
      scenario = 10;
      errMsg = labels/* default.lbl_only_one_type_product */.Z.lbl_only_one_type_product;
    }

    if (manyMonthlyDeals) {
      scenario = 11;
      errMsg = labels/* default.lbl_only_one_deal_allowed */.Z.lbl_only_one_deal_allowed;
    }

    if (duplicateVas) {
      scenario = 12;
      errMsg = labels/* default.lbl_only_uniq_vas_allowed */.Z.lbl_only_uniq_vas_allowed;
    }

    if (!manyMonthlyDeals && chkOutOfStockItems() && cartDetails !== null && cartDetails !== void 0 && cartDetails.isMulti) {
      scenario = 14;
      errMsg = errorMessages/* default.out_of_stock.any_out_of_stock */.Z.out_of_stock.any_out_of_stock;
    }

    return (scenario > 0 || cartDetails.hasBackOrder) && /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
      children: [[5, 7, 10, 11, 12, 13, 14].indexOf(scenario) !== -1 && /*#__PURE__*/(0,jsx_runtime.jsx)(InfoBox/* default */.Z, {
        type: "error",
        imageSrc: "".concat(imagePrefix, "/assets/images/error-circle.svg"),
        imageWidth: "1.3125rem",
        imageHeight: "1.3125rem",
        text: errMsg
      }), [3, 9].indexOf(scenario) !== -1 && /*#__PURE__*/(0,jsx_runtime.jsx)(infoClickCollect_InfoClickCollect, {
        type: "info",
        imageSrc: "".concat(imagePrefix, "/assets/images/info_white.svg"),
        text: errorMessages/* default.out_of_stock.collect_info */.Z.out_of_stock.collect_info
      }), ((cartDetails === null || cartDetails === void 0 ? void 0 : cartDetails.hasBackOrder) || [3, 6, 7, 8, 9].indexOf(scenario)) !== -1 && /*#__PURE__*/(0,jsx_runtime.jsx)(InfoBox/* default */.Z, {
        type: "info",
        imageSrc: "".concat(imagePrefix, "/assets/images/info_white.svg"),
        imageWidth: "1.3125rem",
        imageHeight: "1.3125rem",
        text: errorMessages/* default.out_of_stock.long_delivery */.Z.out_of_stock.long_delivery
      })]
    });
  };

  var checkIfEmpty = function checkIfEmpty() {
    var isNotEmpty = cartItems && cartItems.length > 0 || allPrices && allPrices.subtotal_including_tax && allPrices.subtotal_including_tax.value && allPrices.subtotal_including_tax.value > 0;
    return isNotEmpty;
  };

  var updateCartProduct = /*#__PURE__*/function () {
    var _ref6 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee6(cartId, cartProductId, qty, name, isDealProduct) {
      var _cartProductItemsData, _cartProductItemsData2, _cartProductItemsData3, _cartProductItemsData4, _cartProductItemsData5, _cartProductItemsData6, _cartProductItemsData7, _cartProductItemsData8, _cartProductItemsData9, _result$updateCartIte;

      var cartProductItemsData, buyOptionId, buyOptionTypeId, attributesOptions, customizable_options, result;
      return regenerator_default().wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              cartProductItemsData = getOptionsId(cartProductItems, cartProductId);
              buyOptionId = cartProductItemsData === null || cartProductItemsData === void 0 ? void 0 : (_cartProductItemsData = cartProductItemsData[0]) === null || _cartProductItemsData === void 0 ? void 0 : (_cartProductItemsData2 = _cartProductItemsData.config_custom_options) === null || _cartProductItemsData2 === void 0 ? void 0 : (_cartProductItemsData3 = _cartProductItemsData2[0]) === null || _cartProductItemsData3 === void 0 ? void 0 : _cartProductItemsData3.id;
              buyOptionTypeId = cartProductItemsData === null || cartProductItemsData === void 0 ? void 0 : (_cartProductItemsData4 = cartProductItemsData[0]) === null || _cartProductItemsData4 === void 0 ? void 0 : (_cartProductItemsData5 = _cartProductItemsData4.config_custom_options) === null || _cartProductItemsData5 === void 0 ? void 0 : (_cartProductItemsData6 = _cartProductItemsData5[0]) === null || _cartProductItemsData6 === void 0 ? void 0 : (_cartProductItemsData7 = _cartProductItemsData6.values) === null || _cartProductItemsData7 === void 0 ? void 0 : (_cartProductItemsData8 = _cartProductItemsData7[0]) === null || _cartProductItemsData8 === void 0 ? void 0 : _cartProductItemsData8.value;
              attributesOptions = setOptionsAttributes(cartProductItemsData === null || cartProductItemsData === void 0 ? void 0 : (_cartProductItemsData9 = cartProductItemsData[0]) === null || _cartProductItemsData9 === void 0 ? void 0 : _cartProductItemsData9.configurable_options);
              customizable_options = buyOptionId && buyOptionTypeId ? [{
                id: buyOptionId,
                value_string: buyOptionTypeId === null || buyOptionTypeId === void 0 ? void 0 : buyOptionTypeId.toString()
              }] : [];
              setCartProductName(name);
              setLoadingState(true);
              _context6.next = 9;
              return updateItemsofCart(cartId, cartProductId, qty, attributesOptions, customizable_options);

            case 9:
              result = _context6.sent;
              setLoadingState(false);

              if (result !== null && result !== void 0 && (_result$updateCartIte = result.updateCartItems) !== null && _result$updateCartIte !== void 0 && _result$updateCartIte.cart) {
                setUpdateCartDetails("updateCartProduct");

                if (isDealProduct === 1) {
                  setUpdateMsg(false);
                  setIsDealRemove(true);
                } else {
                  setUpdateMsg(true);
                  setIsDealRemove(false);
                }

                setAddCoupon(false);
                setRemoveMsg(false);
                setRemoveCoupon(false);
                setShowSnackBar(true);
              }

            case 12:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    return function updateCartProduct(_x2, _x3, _x4, _x5, _x6) {
      return _ref6.apply(this, arguments);
    };
  }();

  var getOptionsId = function getOptionsId(cartProductItemsData, cartProductIdValue) {
    return cartProductItemsData.filter(function (item) {
      return item.id === cartProductIdValue;
    });
  };

  var setOptionsAttributes = function setOptionsAttributes(optionsAttributes) {
    var attributes = [];

    if (optionsAttributes) {
      optionsAttributes.forEach(function (list) {
        attributes.push({
          id: list.id,
          value_string: list.value_id
        });
      });
    }

    return attributes;
  };

  var removeCartProduct = /*#__PURE__*/function () {
    var _ref7 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee7(cartId, cartProductId, name, isDealProduct) {
      var _result$removeItemFro, _result$removeItemFro2;

      var result;
      return regenerator_default().wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              setCartProductName(name);
              setLoadingState(true);
              _context7.next = 4;
              return deleteItemsFromCart(cartId, cartProductId);

            case 4:
              result = _context7.sent;
              setLoadingState(false);

              if (!(addCouponMsg && (0,helperServices/* isArrayNotEmpty */.wh)(onceOffCartProducts) && onceOffCartProducts.length === 1 && result !== null && result !== void 0 && (_result$removeItemFro = result.removeItemFromCart) !== null && _result$removeItemFro !== void 0 && _result$removeItemFro.cart)) {
                _context7.next = 9;
                break;
              }

              _context7.next = 9;
              return removeCouponFromCart(cartId);

            case 9:
              if (result !== null && result !== void 0 && (_result$removeItemFro2 = result.removeItemFromCart) !== null && _result$removeItemFro2 !== void 0 && _result$removeItemFro2.cart) {
                setUpdateCartDetails("updateCartProduct");
                setAddCoupon(false);
                setUpdateMsg(false);

                if (isDealProduct === 1) {
                  setRemoveMsg(false);
                  setIsDealRemove(true);
                } else {
                  setRemoveMsg(true);
                  setIsDealRemove(false);
                }

                setRemoveCoupon(false);
                setShowSnackBar(true);
                checkPreOrder(result === null || result === void 0 ? void 0 : result.removeItemFromCart);
              }

            case 10:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));

    return function removeCartProduct(_x7, _x8, _x9, _x10) {
      return _ref7.apply(this, arguments);
    };
  }();

  var removeVoucherCode = /*#__PURE__*/function () {
    var _ref8 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee8() {
      var _cartDetails$applied_, _result$removeCouponF;

      var salesVoucherName, result, _result$removeCouponF2, _result$removeCouponF3, _result$removeCouponF4, _result$removeCouponF5;

      return regenerator_default().wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              setLoadingState(true);
              salesVoucherName = cartDetails === null || cartDetails === void 0 ? void 0 : (_cartDetails$applied_ = cartDetails.applied_coupons) === null || _cartDetails$applied_ === void 0 ? void 0 : _cartDetails$applied_[0].code;
              _context8.next = 4;
              return removeCouponFromCart(cartId);

            case 4:
              result = _context8.sent;
              setLoadingState(false);

              if (result !== null && result !== void 0 && (_result$removeCouponF = result.removeCouponFromCart) !== null && _result$removeCouponF !== void 0 && _result$removeCouponF.cart) {
                setUpdateCartDetails("removeVoucherCode");
                setAddCoupon(false);
                setUpdateMsg(false);
                setShowSnackBar(true);
                setRemoveMsg(false);
                setRemoveCoupon(true);
                setIsDealRemove(false);
                DependencyHelper.Cookie.remove("total_zero");
                analyticsUtag/* link */.p4(cart_objectSpread(cart_objectSpread(cart_objectSpread({}, analyticsUtag/* getUtagData */.GS(["page_name", "page_channel", "page_master_tab", "visitor_login_status", "visitor_msisdn_hash", "visitor_customer_id", "visitor_id_hash", "visitor_subscription_type", "sales_voucher_name", "sales_product_category", "sales_product_price", "sales_product_quantity", "sales_order_discount", "sales_promo_name", "sales_product_id", "sales_voucher_discount"])), {}, {
                  sales_event: "sales_voucher_removal",
                  page_tool_event: "use",
                  page_tool_name: "shopping: cart: remove voucher",
                  sales_order_sub_total: "".concat(result === null || result === void 0 ? void 0 : (_result$removeCouponF2 = result.removeCouponFromCart) === null || _result$removeCouponF2 === void 0 ? void 0 : (_result$removeCouponF3 = _result$removeCouponF2.cart) === null || _result$removeCouponF3 === void 0 ? void 0 : (_result$removeCouponF4 = _result$removeCouponF3.prices) === null || _result$removeCouponF4 === void 0 ? void 0 : (_result$removeCouponF5 = _result$removeCouponF4.grand_total) === null || _result$removeCouponF5 === void 0 ? void 0 : _result$removeCouponF5.value)
                }, voucherAnalytics), {}, {
                  sales_voucher_name: salesVoucherName
                }));
              }

            case 7:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }));

    return function removeVoucherCode() {
      return _ref8.apply(this, arguments);
    };
  }();

  var snackBarMsg = function snackBarMsg() {
    var msg;

    if (addCouponMsg) {
      msg = labels/* default.lbl_coupon_applied_successfully */.Z.lbl_coupon_applied_successfully;
      return msg;
    }

    if (updateMsg) {
      msg = labels/* default.lbl_updated_cart */.Z.lbl_updated_cart;
      return msg;
    }

    if (removeMsg) {
      msg = "".concat(cartProductName, " ").concat(labels/* default.lbl_removed_from_cart */.Z.lbl_removed_from_cart);
      return msg;
    }

    if (removeCoupon) {
      msg = labels/* default.lbl_coupon_code_removed_successfully */.Z.lbl_coupon_code_removed_successfully;
      return msg;
    }

    if (isDealRemove) {
      var productName = cartProductName.length > 20 ? "".concat(cartProductName.substr(0, 20), "...") : cartProductName;
      msg = "This ".concat(productName, " deal ").concat(labels/* default.lbl_deal_remove_from_cart */.Z.lbl_deal_remove_from_cart);
      return msg;
    }
  };

  (0,react.useEffect)(function () {
    if (userProfileSync !== null && userProfileSync !== void 0 && userProfileSync.userDetails && (userProfileSync === null || userProfileSync === void 0 ? void 0 : userProfileSync.userDetails) != null) {
      setIsUserProfileSync(false);

      var _userProfileSync$user = userProfileSync === null || userProfileSync === void 0 ? void 0 : userProfileSync.userDetails,
          apiStatus = _userProfileSync$user.apiStatus;

      if (apiStatus && !refreshUser) {
        var _cartId = (0,helperServices/* getCookieValue */.Do)("cart_id");

        updateCookieConsentWrapper(userProfileSync === null || userProfileSync === void 0 ? void 0 : userProfileSync.userDetails, _cartId);
        setRefreshUser(true);
      } else {
        var _userProfileSync$user2;

        resetSyncUserProfile();
        setRefreshUser(false);

        if ((userProfileSync === null || userProfileSync === void 0 ? void 0 : (_userProfileSync$user2 = userProfileSync.userDetails) === null || _userProfileSync$user2 === void 0 ? void 0 : _userProfileSync$user2.apiFailStatus) == "401") {
          (0,helperServices/* clearUserToken */.Zj)();
          setTimeout(function () {
            window.location.replace(loginUrl + "?redirectUrl=" + redirectURL);
          }, 100);
          return;
        }

        setLoadingState(false);
      }
    }
  }, [userProfileSync]);

  var updateCookieConsentWrapper = function updateCookieConsentWrapper(profileInfo, cartId) {
    try {
      var _profileInfo$result, _profileInfo$result$m, _profileInfo$result$m2, _profileInfo$result2, _profileInfo$result2$;

      var oAuthToken = profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$result = profileInfo.result) === null || _profileInfo$result === void 0 ? void 0 : (_profileInfo$result$m = _profileInfo$result.magentoProfileResponse[0]) === null || _profileInfo$result$m === void 0 ? void 0 : (_profileInfo$result$m2 = _profileInfo$result$m.OAuthTokenDetails[0]) === null || _profileInfo$result$m2 === void 0 ? void 0 : _profileInfo$result$m2.OAuthToken;
      cartId = profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$result2 = profileInfo.result) === null || _profileInfo$result2 === void 0 ? void 0 : (_profileInfo$result2$ = _profileInfo$result2.magentoProfileResponse[0]) === null || _profileInfo$result2$ === void 0 ? void 0 : _profileInfo$result2$.mergedCartID;
      (0,helperServices/* setCookieConsentWrapper */.ol)("auth_token", [(config_default()).cookie_category.strictly_necessary], "document.cookie='auth_token=".concat(oAuthToken, ";path=/'"));
      (0,helperServices/* setCookieConsentWrapper */.ol)("cart_id", [(config_default()).cookie_category.strictly_necessary], "document.cookie='cart_id=".concat(cartId, ";path=/'"));
    } catch (error) {
      console.log("");
    } finally {
      var updatedProfileInfo = profileInfo === null || profileInfo === void 0 ? void 0 : profileInfo.result;
      setRefreshUser(false);
      setLoadingState(false);

      if (updatedProfileInfo) {
        setProfileData(profileInfo); // handleAddToCart();

        setIsUserProfileSync(false);
        resetSyncUserProfile();
      } else {
        setIsUserProfileSync(false);
        resetSyncUserProfile();
      }
    }
  };

  var errorMessagesLabel = {
    heading: labels/* default.errorMessages.lbl_page_error */.Z.errorMessages.lbl_page_error,
    subHeading1: labels/* default.errorMessages.lbl_page_error_subheading1 */.Z.errorMessages.lbl_page_error_subheading1,
    subHeading2: labels/* default.errorMessages.lbl_page_error_subheading2 */.Z.errorMessages.lbl_page_error_subheading2
  };

  var hideLoginModal = function hideLoginModal() {
    setShowLoginModal(false);
  };

  var guestNavigation = function guestNavigation() {
    setLoadingState(true);
    router.push("".concat(urlPrefix, "/checkout")).then(function () {
      window.scrollTo(0, 0);
      setLoadingState(false);
    });
  };

  var checkPreOrder = function checkPreOrder(cartData) {
    var _cartData$cart;

    var preOrderFound = cartData === null || cartData === void 0 ? void 0 : (_cartData$cart = cartData.cart) === null || _cartData$cart === void 0 ? void 0 : _cartData$cart.items.filter(function (item) {
      return item.product.badges_label && item.product.badges_label.toLowerCase().indexOf(types/* default.TYPE_PREORDER.toLowerCase */.Z.TYPE_PREORDER.toLowerCase()) > -1;
    });

    if (preOrderFound && preOrderFound.length > 0) {
      if (!showPreOrderInfo) {
        fetchPreOrderContent();
      }
    } else {
      setShowPreOrderInfo(false);
    }
  };

  var fetchPreOrderContent = /*#__PURE__*/function () {
    var _ref9 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee9() {
      var _result$sections$, result;

      return regenerator_default().wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              setLoadingState(true);
              _context9.prev = 1;
              _context9.next = 4;
              return ajaxServices/* default.httpGet */.Z.httpGet("drupalBaseUrl", "", "api", "preOrderProductInfo");

            case 4:
              result = _context9.sent;

              if (result !== null && result !== void 0 && (_result$sections$ = result.sections[0]) !== null && _result$sections$ !== void 0 && _result$sections$.items) {
                setPreOrderDeliveryMessage(result.sections[0].items[0].description);
                setShowPreOrderInfo(true);
              }

              setLoadingState(false);
              _context9.next = 12;
              break;

            case 9:
              _context9.prev = 9;
              _context9.t0 = _context9["catch"](1);
              setLoadingState(false);

            case 12:
              _context9.prev = 12;
              setLoadingState(false);
              return _context9.finish(12);

            case 15:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, null, [[1, 9, 12, 15]]);
    }));

    return function fetchPreOrderContent() {
      return _ref9.apply(this, arguments);
    };
  }();

  var captureRemovedVasAnalytics = function captureRemovedVasAnalytics(removedVasArray) {
    if (removedVasArray && removedVasArray.length) {
      removedVasArray.forEach(function (cartProduct) {
        var _cartProduct$product3, _cartProduct$product4, _cartProduct$product5, _cartProduct$product6;

        var analyticsRemovedVas = cart_objectSpread({
          sales_event: "cart_remove",
          sales_order_discount: [(0,helperServices/* getAmountOffValue */.Dd)(cartProduct === null || cartProduct === void 0 ? void 0 : cartProduct.product)],
          page_name: "shopping: cart",
          page_channel: "shopping",
          page_master_tab: "personal",
          link_type: "o",
          link_name: "shopping: cart: remove",
          sales_order_sub_total: cartProduct === null || cartProduct === void 0 ? void 0 : cartProduct.monthly_recurring,
          sales_product_category: [cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product3 = cartProduct.product) === null || _cartProduct$product3 === void 0 ? void 0 : (_cartProduct$product4 = _cartProduct$product3.categories) === null || _cartProduct$product4 === void 0 ? void 0 : (_cartProduct$product5 = _cartProduct$product4[0]) === null || _cartProduct$product5 === void 0 ? void 0 : _cartProduct$product5.name],
          sales_product_id: [cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product6 = cartProduct.product) === null || _cartProduct$product6 === void 0 ? void 0 : _cartProduct$product6.name],
          sales_product_price: [cartProduct === null || cartProduct === void 0 ? void 0 : cartProduct.monthly_recurring],
          sales_product_quantity: [cartProduct.quantity]
        }, analyticsUtag/* getUtagData */.GS(["visitor_login_status", "visitor_subscription_type", "visitor_msisdn_hash", "visitor_id_hash"]));

        analyticsUtag/* link */.p4(analyticsRemovedVas);
      });
    }
  };

  var captureAddedVasAnalytics = function captureAddedVasAnalytics(newlyAddedVasArray) {
    if (newlyAddedVasArray && newlyAddedVasArray.length) {
      newlyAddedVasArray.forEach(function (cartProduct) {
        var _cartProduct$vasDetai, _cartProduct$vasDetai2, _cartProduct$vasDetai3;

        var analyticsAddedVas = cart_objectSpread({
          sales_event: "cart_add",
          sales_order_discount: [(0,helperServices/* getAmountOffValue */.Dd)(cartProduct === null || cartProduct === void 0 ? void 0 : cartProduct.product)],
          page_name: "shopping: cart",
          page_channel: "shopping",
          page_master_tab: "personal",
          link_type: "o",
          link_name: "shopping: cart: add",
          sales_order_sub_total: cartProduct === null || cartProduct === void 0 ? void 0 : cartProduct.price,
          sales_product_category: [cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$vasDetai = cartProduct.vasDetails) === null || _cartProduct$vasDetai === void 0 ? void 0 : (_cartProduct$vasDetai2 = _cartProduct$vasDetai.categories) === null || _cartProduct$vasDetai2 === void 0 ? void 0 : (_cartProduct$vasDetai3 = _cartProduct$vasDetai2[0]) === null || _cartProduct$vasDetai3 === void 0 ? void 0 : _cartProduct$vasDetai3.name],
          sales_product_id: [cartProduct === null || cartProduct === void 0 ? void 0 : cartProduct.name],
          sales_product_price: [cartProduct === null || cartProduct === void 0 ? void 0 : cartProduct.price],
          sales_product_quantity: [1]
        }, analyticsUtag/* getUtagData */.GS(["visitor_login_status", "visitor_subscription_type", "visitor_msisdn_hash", "visitor_id_hash"]));

        analyticsUtag/* link */.p4(analyticsAddedVas);
      });
    }
  };

  var handleAddRemoveToCartForVAS = /*#__PURE__*/function () {
    var _ref10 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee10(selectedVasData) {
      var dealData, dealsSku, cartVasArray, removedVasArray, removedVasItem, _iterator4, _step4, iterator, _iterator5, _step5, cartVas, newlyAddedVasArray, result;

      return regenerator_default().wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              dealData = cartItems.filter(function (cartProduct) {
                var _cartProduct$product7;

                return (cartProduct === null || cartProduct === void 0 ? void 0 : (_cartProduct$product7 = cartProduct.product) === null || _cartProduct$product7 === void 0 ? void 0 : _cartProduct$product7.is_deal_product) === 1;
              });
              dealsSku = dealData[0].product.sku;
              cartVasArray = cartItems.filter(function (item) {
                return (item === null || item === void 0 ? void 0 : item.monthly_recurring) && (item === null || item === void 0 ? void 0 : item.parent_product_sku) == dealsSku;
              });
              removedVasArray = [];
              removedVasItem = [];
              _iterator4 = cart_createForOfIteratorHelper(selectedVasData);

              try {
                for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                  iterator = _step4.value;
                  _iterator5 = cart_createForOfIteratorHelper(cartVasArray);

                  try {
                    for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                      cartVas = _step5.value;

                      if (cartVas.product.sku === iterator.vidCode) {
                        if (!iterator.isAdded) {
                          removedVasArray.push(cartVas.id);
                          removedVasItem.push(cartVas);
                        }
                      }
                    }
                  } catch (err) {
                    _iterator5.e(err);
                  } finally {
                    _iterator5.f();
                  }
                }
              } catch (err) {
                _iterator4.e(err);
              } finally {
                _iterator4.f();
              }

              newlyAddedVasArray = selectedVasData.filter(function (mItem) {
                return !cartVasArray.some(function (cItem) {
                  return cItem.product.sku === mItem.vidCode;
                }) && mItem.isAdded;
              });

              if (!(removedVasArray.length || newlyAddedVasArray.length)) {
                _context10.next = 16;
                break;
              }

              if (!cartId) {
                _context10.next = 16;
                break;
              }

              setLoadingState(true);
              setHideVasModal(true);
              _context10.next = 14;
              return (0,vasDataService/* updateTheCartWithVASProduct */.u)(cartId, dealsSku, removedVasArray, newlyAddedVasArray);

            case 14:
              result = _context10.sent;

              if (result && result.status === 200) {
                setUpdateCartDetails("addOrRemoveVAS_".concat(Math.random()));
                setHideVasModal(false);
                captureRemovedVasAnalytics(removedVasItem);
                captureAddedVasAnalytics(newlyAddedVasArray);
              } else {
                setLoadingState(false);
              }

            case 16:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10);
    }));

    return function handleAddRemoveToCartForVAS(_x11) {
      return _ref10.apply(this, arguments);
    };
  }();

  var redirectToNextSteps = function redirectToNextSteps() {
    if (monthlyCartProducts.length > 0 || onceOffCartProducts.length > 0) {
      handleCheckout();
    }
  };

  (0,react.useEffect)(function () {
    if (Object.keys(features).length > 0) {
      if (userLoggedIn && isCheckoutLogin) {
        redirectToNextSteps();
      }
    }
  }, [features, monthlyCartProducts]);

  if (cartApiError) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
      className: "error-container",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorCard/* default */.Z, {
        errorMsg: errorMessagesLabel,
        fullWidth: 1
      })
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [showLoginModal && /*#__PURE__*/(0,jsx_runtime.jsx)(LoginModal/* default */.Z, {
      show: showLoginModal,
      handleCancel: hideLoginModal,
      applicationType: onlyOnceOffProducts ? "normal" : "contract",
      navigate: guestNavigation,
      redirectTo: redirectURL,
      setGuestCart: function setGuestCart() {
        return addGuestCartProducts(cartItems, cartDetails.totalQuantity, cartDetails.applied_coupons);
      },
      resetGuestCart: function resetGuestCart() {
        return addGuestCartProducts([], 0, null);
      }
    }), showSnackBar && /*#__PURE__*/(0,jsx_runtime.jsx)(SnackBar, {
      message: snackBarMsg(),
      className: addCouponMsg ? "snackBarStyling" : "defaultSnackBarStyling",
      closeSnackBar: closeSnackBar,
      isVisible: showSnackBar,
      labelStyling: "msg-label"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Seo/* default */.Z, {
      title: metadata === null || metadata === void 0 ? void 0 : metadata.title,
      content: metadata === null || metadata === void 0 ? void 0 : metadata.description,
      url: metadata === null || metadata === void 0 ? void 0 : metadata.canonical_url,
      keywords: metadata === null || metadata === void 0 ? void 0 : metadata.keywords,
      robots: metadata === null || metadata === void 0 ? void 0 : metadata.robots
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Container, {
      className: "main-container",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
        className: "cart-container",
        children: [showCouponAlert ? renderInvalidCouponAlert() : /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Row, {
          noGutters: true,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Col, {
            md: 12,
            className: "p-0",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
              className: "cart-container__top-spacing",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(PageHeading/* default */.Z, {
                className: "heading",
                text: labels/* default.lbl_your_cart */.Z.lbl_your_cart,
                level: 3
              })
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Row, {
          noGutters: true,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
            className: showCouponAlert ? "alertSpacing" : "cart-container__section",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Col, {
              md: 12,
              className: "p-0",
              children: isPendingOrder && /*#__PURE__*/(0,jsx_runtime.jsx)(pendingOrder_PendingOrder, {
                className: "pendingOrder"
              })
            }), checkIfEmpty() ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Col, {
                lg: 8,
                xl: 8,
                className: "cart-col-left",
                children: [checkoutDisabled && /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorTooltip/* default */.Z, {
                  type: "not_allow_place_order",
                  errorMsg: errorMessages/* default.not_allow_place_order */.Z.not_allow_place_order,
                  hideDismissButton: true
                }), showPreOrderInfo && /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
                  className: "pre-order-message-container",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Image, {
                    className: "pre-order-message-img",
                    img_path: "".concat(imagePrefix, "/assets/images/info_white.svg"),
                    img_width: "1.125rem",
                    img_height: "1.125rem"
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
                    className: "pre-order-message",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                      dangerouslySetInnerHTML: (0,helperServices/* createMarkup */.KU)(preOrderDeliveryMessage)
                    })
                  })]
                }), renderOutOfStockMessage(), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
                  className: "cart-container__section__left",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(CartListContainer_CartListContainer, {
                    removeCartProduct: removeCartProduct,
                    updateCartProduct: updateCartProduct,
                    monthlyCartProducts: monthlyCartProducts,
                    onceoffCartProducts: onceOffCartProducts,
                    applicationType: applicationType,
                    alertFlag: alertFlag,
                    handleAddRemoveToCartForVAS: handleAddRemoveToCartForVAS,
                    shouldCloseModal: hideVasModal
                  })
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Col, {
                lg: 4,
                xl: 4,
                className: "cart-col-right",
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
                  className: "cart-container__section__right",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CartOrderSummary, {
                    applicationType: applicationType,
                    disabledFlag: alertFlag || outOfStockFlag,
                    subTotal: "R".concat((0,helperServices/* formatNumbersWithComma */.G0)(Math.round(allPrices.subtotal_including_tax.value * 100) / 100)),
                    delivery: allPrices && allPrices !== null && allPrices !== void 0 && (_allPrices$subtotal_e = allPrices.subtotal_excluding_tax) !== null && _allPrices$subtotal_e !== void 0 && _allPrices$subtotal_e.value ? (0,helperServices/* calculateShipping */.QP)(cartDetails, allPrices.subtotal_excluding_tax.value) : null,
                    vat: allPrices && (allPrices === null || allPrices === void 0 ? void 0 : (_allPrices$applied_ta = allPrices.applied_taxes) === null || _allPrices$applied_ta === void 0 ? void 0 : _allPrices$applied_ta.length) > 0 ? "R".concat((0,helperServices/* formatNumbersWithComma */.G0)(Math.round(allPrices.applied_taxes[0].amount.value * 100) / 100)) : null,
                    total: (0,helperServices/* getCartGrandTotal */.h_)(cartDetails),
                    handleCheckout: beforeCheckout,
                    checkoutDisabled: checkoutDisabled,
                    vatLabel: allPrices && (allPrices === null || allPrices === void 0 ? void 0 : (_allPrices$applied_ta2 = allPrices.applied_taxes) === null || _allPrices$applied_ta2 === void 0 ? void 0 : _allPrices$applied_ta2.length) > 0 && allPrices.applied_taxes[0].label ? allPrices.applied_taxes[0].label : labels/* default.lbl_vat */.Z.lbl_vat,
                    removeVoucherCode: removeVoucherCode,
                    btnDisabled: continueDisabled,
                    monthlyCartProducts: monthlyCartProducts,
                    onceoffCartProducts: onceOffCartProducts
                  }), (0,helperServices/* isArrayNotEmpty */.wh)(onceOffCartProducts) && renderPromoCodeSection]
                })
              })]
            }) : emptyContainer, productsViewed && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Col, {
              md: 12,
              className: "cart-col-footer p-s-8",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(CartFooter, {
                recentViewed: productsViewed,
                isCartEmpty: checkIfEmpty(),
                triggerCallback: isUserProfileSync,
                setUpdateCartDetails: setUpdateCartDetails
              })
            })]
          })
        }), checkIfEmpty() ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Row, {
            noGutters: true,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Col, {
              md: 12,
              className: "p-0",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
                className: "cart-container__description",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(CartOrderDescription, {})
              })
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Modal, {
            show: showModal,
            onHide: closePromoModal,
            dialogClassName: "custom-dialog ".concat(!isMobile ? "modal-dialog-centered" : "", " promo-code-modal "),
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextBoxCard, {
              isMobile: true,
              onHide: closePromoModal,
              text: text,
              label: labels/* default.lbl_promocode_query */.Z.lbl_promocode_query,
              placeHolder: labels/* default.lbl_enter_promo */.Z.lbl_enter_promo,
              buttonText: labels/* default.lbl_apply_code */.Z.lbl_apply_code,
              buttonHandler: handleApplyCode,
              handleChange: handleChange
            })
          })]
        }) : ""]
      })
    })]
  });
};

CartPage.getInitialProps = /*#__PURE__*/function () {
  var _ref12 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee12(_ref11) {
    var req, query, recentlyViewed, cookies, previewMode, seodata;
    return regenerator_default().wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            req = _ref11.req, query = _ref11.query;
            cookies = parseCookies(req);

            if (cookies && cookies.products) {
              recentlyViewed = JSON.parse(cookies.products);
            }

            previewMode = (query === null || query === void 0 ? void 0 : query.previewMode) === "on";
            _context12.next = 6;
            return pageService/* getPageComponents */.eU(["cart/CBU".concat((query === null || query === void 0 ? void 0 : query.previewMode) === "on" ? (config_default()).pageServiceQueryData.preview : (config_default()).pageServiceQueryData.status)]);

          case 6:
            seodata = _context12.sent;
            return _context12.abrupt("return", {
              recentlyViewed: recentlyViewed,
              metadata: seodata === null || seodata === void 0 ? void 0 : seodata.seoMetadata,
              previewMode: previewMode
            });

          case 8:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12);
  }));

  return function (_x12) {
    return _ref12.apply(this, arguments);
  };
}();

var cart_mapStateToProps = function mapStateToProps(state) {
  return {
    cartProductItems: state.cartDetails.cartProductItems,
    prices: state.cartDetails.prices,
    errorMsg: state.cartDetails.errorMsg,
    cartDetails: state.cartDetails,
    userLoggedIn: state.navDetails.isUserLoggedIn,
    profileData: state.navDetails.profileData,
    profileLoading: state.navDetails.isProfileLoading,
    isCheckoutLogin: state.navDetails.isCheckoutLogin,
    userProfileSync: state.userProfileSync,
    canReciveOTP: state.upgrade.canReciveOTP,
    isChildAllowed: state.upgrade.isChildAllowed,
    upgradeResponse: state.upgrade.upgradeResponse,
    geoLocation: state.geoLocation,
    isMiniApp: state.navDetails.isMiniApp,
    setHelpLeadBucket: (prop_types_default()).func,
    features: state.common.features
  };
};

/* harmony default export */ var cart = ((0,es/* connect */.$j)(cart_mapStateToProps, {
  addCouponToCart: cartAction/* addCouponToCart */.vD,
  deleteItemsFromCart: cartAction/* deleteItemsFromCart */.dY,
  updateItemsofCart: cartAction/* updateItemsofCart */.iq,
  removeCouponFromCart: cartAction/* removeCouponFromCart */.r$,
  getShippingAndBilling: cartAction/* getShippingAndBilling */.wJ,
  showGuestCart: cartAction/* showGuestCart */.cD,
  resetSyncUserProfile: userProfileAction/* resetSyncUserProfile */.h,
  syncUserProfile: userProfileAction/* syncUserProfile */.c,
  setProfileData: navAction/* setProfileData */._J,
  setCheckoutLogin: navAction/* setCheckoutLogin */.Oh,
  addGuestCartProducts: cartAction/* addGuestCartProducts */.Pj,
  resetGuestCart: cartAction/* resetGuestCart */.Jj,
  setHelpLeadBucket: getHelpAction/* setHelpLeadBucket */.A,
  setChangeStore: geoLocationAction/* setChangeStore */.oA,
  setStoreDetails: geoLocationAction/* setStoreDetails */.Gi,
  setChangeMethods: geoLocationAction/* setChangeMethods */.p5,
  checkFeatures: commonAction/* checkFeatures */.k
})(CartPage));

/***/ }),

/***/ 76173:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HZ": function() { return /* binding */ productCarouselService; },
/* harmony export */   "eU": function() { return /* binding */ getPageComponents; }
/* harmony export */ });
/* unused harmony export postPageComponents */
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50029);
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_ajaxServices__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18517);
/* harmony import */ var _config_queries__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91250);




var postPageComponents = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(data) {
    var result;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return ajaxService.httpPost("drupalBaseUrl", JSON.stringify(data), "api", "getPage");

          case 3:
            result = _context.sent;
            return _context.abrupt("return", result);

          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            console.log("page service failure", _context.t0);

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 7]]);
  }));

  return function postPageComponents(_x) {
    return _ref.apply(this, arguments);
  };
}()));
var getPageComponents = /*#__PURE__*/function () {
  var _ref2 = (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)( /*#__PURE__*/_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(url) {
    var result;
    return _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return _utils_ajaxServices__WEBPACK_IMPORTED_MODULE_1__/* ["default"].httpGet */ .Z.httpGet("drupalBaseUrl", "", "api", "getPage", url);

          case 3:
            result = _context2.sent;
            return _context2.abrupt("return", result);

          case 7:
            _context2.prev = 7;
            _context2.t0 = _context2["catch"](0);
            console.log("page service failure", _context2.t0);

          case 10:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 7]]);
  }));

  return function getPageComponents(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
var productCarouselService = /*#__PURE__*/function () {
  var _ref3 = (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)( /*#__PURE__*/_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee3(sku) {
    var result;
    return _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return _utils_ajaxServices__WEBPACK_IMPORTED_MODULE_1__/* ["default"].fetchGraphQLPOSTRequest */ .Z.fetchGraphQLPOSTRequest(_config_queries__WEBPACK_IMPORTED_MODULE_3__/* .ProductCarouselData */ .Ky, {
              id: sku
            });

          case 2:
            result = _context3.sent;
            return _context3.abrupt("return", result);

          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function productCarouselService(_x3) {
    return _ref3.apply(this, arguments);
  };
}();

/***/ }),

/***/ 63222:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shopping/cart",
      function () {
        return __webpack_require__(23390);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7249:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"back-button":"backButton_back-button__mgroE","back-button__arrow-left":"backButton_back-button__arrow-left__yf2Mq","back-button__counter":"backButton_back-button__counter__yjU9l","back-button__label":"backButton_back-button__label__QQO3w","backToOrderBtn":"backButton_backToOrderBtn__Tu8jk","backToOrderBtnLabel":"backButton_backToOrderBtnLabel__f6n0u","backToOrderBtnArrow":"backButton_backToOrderBtnArrow___G5Nn","returnToProductsBtnArrow":"backButton_returnToProductsBtnArrow__NM5f0","returnToProducts":"backButton_returnToProducts__t73j5"};

/***/ }),

/***/ 36345:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"info-click-collect":"InfoClickCollect_info-click-collect__Ip2HL","info-click-collect--img":"InfoClickCollect_info-click-collect--img__S4W6q","info-click-collect--label":"InfoClickCollect_info-click-collect--label__bfh3f","info":"InfoClickCollect_info__g4Lj0","warn":"InfoClickCollect_warn__l2tOi","error":"InfoClickCollect_error__lDi50"};

/***/ }),

/***/ 88447:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"label-text":"LabelText_label-text__ss__o"};

/***/ }),

/***/ 9213:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"page-heading":"pageHeading_page-heading__uox05","page-heading--section":"pageHeading_page-heading--section__xr7ob","page-heading--head":"pageHeading_page-heading--head__XVL9B","page-heading--tabs-heading":"pageHeading_page-heading--tabs-heading__npoPE","page-heading--campaign":"pageHeading_page-heading--campaign__1oeAi","page-heading--orderHistoryMainHeader":"pageHeading_page-heading--orderHistoryMainHeader__R1j6f","page-heading--orderDetailsMainHeader":"pageHeading_page-heading--orderDetailsMainHeader__sdB2v","page-heading--orderTrackingMainHeader":"pageHeading_page-heading--orderTrackingMainHeader__4FnyW","page-heading--product-details-heading":"pageHeading_page-heading--product-details-heading__dlAcP","alignment--left":"pageHeading_alignment--left__ngPMy","alignment--right":"pageHeading_alignment--right__nXm9c","alignment--center":"pageHeading_alignment--center__DoolE","page-heading--compare-product-header-mobile":"pageHeading_page-heading--compare-product-header-mobile__wU1ZV"};

/***/ }),

/***/ 37323:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"orderRemainder":"PendingOrder_orderRemainder__FpaAw","context":"PendingOrder_context__R6Y_U","subContext":"PendingOrder_subContext__MTcw0","imageTextBox":"PendingOrder_imageTextBox__bll0a","timerBox":"PendingOrder_timerBox__3gCAg","timerText":"PendingOrder_timerText__D8YDC","buttonContainer":"PendingOrder_buttonContainer__8mWH4","alertCircle":"PendingOrder_alertCircle__ao98h","buttonStyle":"PendingOrder_buttonStyle__E3adG"};

/***/ }),

/***/ 58428:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tag":"tag_tag__9y82S","brand-new":"tag_brand-new__f_W4F","currently-viewing":"tag_currently-viewing__fdjKe","discount":"tag_discount__NyMX6","buy-one-get-one-free":"tag_buy-one-get-one-free__z2hQ2","device-deal":"tag_device-deal__CvIF0","limited-offer":"tag_limited-offer__u9CQE","read-hot-dealz":"tag_read-hot-dealz__ITnUK","low-stock":"tag_low-stock__GjK3M","no-stock":"tag_no-stock__vzFpN","red-hot-deal":"tag_red-hot-deal___yuSu","on-backorder":"tag_on-backorder___5HF0","pre-order":"tag_pre-order__OiaYK","exclusive-to-online":"tag_exclusive-to-online__MHLGd","one-time-offer":"tag_one-time-offer__FSShN","today-only":"tag_today-only__coPUD","for-today-only":"tag_for-today-only__C4Ugl","top-pick":"tag_top-pick__xGezC","black-friday":"tag_black-friday__wPq1G","badge-style-1":"tag_badge-style-1__wvGOX","Recommended":"tag_Recommended__ci3Kx"};

/***/ }),

/***/ 13754:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"vas-modal":"VasModal_vas-modal__mCp_G","vasmodal-header":"VasModal_vasmodal-header__193lq","close-button":"VasModal_close-button__bxUz7","loader":"VasModal_loader__bv7Wn","modal-body":"VasModal_modal-body__sqSFv","container":"VasModal_container__jBB86","modal-noContent":"VasModal_modal-noContent__0hGGj","modal-footer":"VasModal_modal-footer__B0wD6","modal-footer-total":"VasModal_modal-footer-total__sQU1W","modal-footer-amount":"VasModal_modal-footer-amount__UGRKb","modal-footer-cancel":"VasModal_modal-footer-cancel__t4Teu","modal-footer-cancel-button":"VasModal_modal-footer-cancel-button__aZH6j","footer":"VasModal_footer__RjB0S","footer__price":"VasModal_footer__price__2o8Fl","card":"VasModal_card__M1Cei","card-container":"VasModal_card-container__u58hL","card__image":"VasModal_card__image__TXtJU","card__image-container":"VasModal_card__image-container__HPhLV","card__image-text":"VasModal_card__image-text__PR6ze","card__description":"VasModal_card__description___EkWe","card__link":"VasModal_card__link__U0BNu","card__price":"VasModal_card__price__HoXJ5","card__selected":"VasModal_card__selected__sG_53","card__unselected":"VasModal_card__unselected__4amj_","row":"VasModal_row__cPg7z","vas-header":"VasModal_vas-header__MU_6U","noContent":"VasModal_noContent__l1b7B","noContent-info-button":"VasModal_noContent-info-button__95auU","noContent-container":"VasModal_noContent-container__Gf_a1","close":"VasModal_close__qNE0B","label":"VasModal_label__neuLF"};

/***/ }),

/***/ 50641:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cart-product":"CartProductCard_cart-product__Vep3n","cart-product--image":"CartProductCard_cart-product--image__0J9In","vas-link":"CartProductCard_vas-link__M8EP0","cart-product--specs":"CartProductCard_cart-product--specs__kk7EZ","low-stock-tag":"CartProductCard_low-stock-tag__SFKYL","stock-label":"CartProductCard_stock-label__PRl6a","deal-promo":"CartProductCard_deal-promo__yzXni","show-details":"CartProductCard_show-details__LjxW1","hide-details":"CartProductCard_hide-details__r3OZ_","change-deal":"CartProductCard_change-deal__syacj","deal-includes":"CartProductCard_deal-includes__X3gvU","this-deal":"CartProductCard_this-deal__6UaPT","detail-container":"CartProductCard_detail-container__Aj16o","highlights-container":"CartProductCard_highlights-container__MIoqU","icon-text":"CartProductCard_icon-text__ubQk_","description":"CartProductCard_description__Lw3QP","img":"CartProductCard_img__MjIES","value":"CartProductCard_value__03Wq7","type":"CartProductCard_type__Czh_q","cart-product--label":"CartProductCard_cart-product--label__GJrbD","cart-product--deal-label":"CartProductCard_cart-product--deal-label__sh7T1","cart-vas-desc":"CartProductCard_cart-vas-desc__wKVRa","cart-product--finalprice":"CartProductCard_cart-product--finalprice__b0s16","cart-product--display":"CartProductCard_cart-product--display__O0XTg","cart-product--display-specs":"CartProductCard_cart-product--display-specs__Bli7W","changeEvent":"CartProductCard_changeEvent__Oo9ZS","cart-product--price":"CartProductCard_cart-product--price__NVGmg","cart-product--deal-price":"CartProductCard_cart-product--deal-price__OyI1H","cart-product--price-container":"CartProductCard_cart-product--price-container__o32qc","cart-product--display-flex":"CartProductCard_cart-product--display-flex__KdUYU","cart-product--buttons":"CartProductCard_cart-product--buttons__Ak1LD","action-btn":"CartProductCard_action-btn__VVCsA","cart-product-vas--buttons":"CartProductCard_cart-product-vas--buttons__gUElq","cart-product--value":"CartProductCard_cart-product--value__xl0Fw","cart-product--value-line":"CartProductCard_cart-product--value-line__2hoBJ","promo-container":"CartProductCard_promo-container__S9Ckh","promo-label":"CartProductCard_promo-label__0ceQh","promo-label-name":"CartProductCard_promo-label-name__qe5aQ","order-tag--container":"CartProductCard_order-tag--container__AkHKb","order-tag--label":"CartProductCard_order-tag--label__7jY9Q","tag-padding-top":"CartProductCard_tag-padding-top__AL3gf","msg-margin-bottom":"CartProductCard_msg-margin-bottom__Mv24I","product-details":"CartProductCard_product-details__qpkD5","product-details--title":"CartProductCard_product-details--title__F4k8Y","product-details--device-name":"CartProductCard_product-details--device-name__ml7JW","secondary-product":"CartProductCard_secondary-product__CQ07l","product-image--secondary":"CartProductCard_product-image--secondary__NRWun","secondary-product-details":"CartProductCard_secondary-product-details__LuJVq","secondary-product-details--title":"CartProductCard_secondary-product-details--title__a8Fhm","secondary-product-details--device-name":"CartProductCard_secondary-product-details--device-name__uDqPk","cart-product-header":"CartProductCard_cart-product-header__ERMVM","price-container":"CartProductCard_price-container__9WNL2","product-image-style":"CartProductCard_product-image-style__nBtnr","vasProduct-image-style":"CartProductCard_vasProduct-image-style__uKwZJ","promotion-tag":"CartProductCard_promotion-tag__vUa07","snackBarStyling":"CartProductCard_snackBarStyling__xlpPy","cart-vasproduct":"CartProductCard_cart-vasproduct__dRBNl","cart-vasproduct--specs":"CartProductCard_cart-vasproduct--specs__0tdrS","vasProduct-label":"CartProductCard_vasProduct-label__f255h","dialogClassName":"CartProductCard_dialogClassName__ZTg48","promo-top-spacing":"CartProductCard_promo-top-spacing__Bi_8j","dropdown-item":"CartProductCard_dropdown-item__fw8CE","out-of-stock-label":"CartProductCard_out-of-stock-label__cC2o0"};

/***/ }),

/***/ 90609:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"error-card-block":"ErrorCard_error-card-block__a5i2d","error-sub-text":"ErrorCard_error-sub-text__SOeNv","error-card-image":"ErrorCard_error-card-image__UNBmk","error-card":"ErrorCard_error-card__uAWyz","error-card__heading":"ErrorCard_error-card__heading__BvUl0","error-card__subheading":"ErrorCard_error-card__subheading__JxMX_"};

/***/ }),

/***/ 46043:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"p-xxs":"IconWithText_p-xxs__tnz0x","pl-xxs":"IconWithText_pl-xxs__McDjC","pr-xxs":"IconWithText_pr-xxs__yGT8Y","pb-xxs":"IconWithText_pb-xxs__QOqCD","pt-xxs":"IconWithText_pt-xxs__cob6U","m-xxs":"IconWithText_m-xxs__L4gd5","ml-xxs":"IconWithText_ml-xxs__DFAgV","mr-xxs":"IconWithText_mr-xxs__g0_yF","mb-xxs":"IconWithText_mb-xxs__QAMFq","mt-xxs":"IconWithText_mt-xxs__mWRxv","px-xxs":"IconWithText_px-xxs__PxcK8","mx-xxs":"IconWithText_mx-xxs__tFtqp","my-xxs":"IconWithText_my-xxs__QCtMF","py-xxs":"IconWithText_py-xxs__5CWzj","font-size-xxs":"IconWithText_font-size-xxs__SQDio","p-xs":"IconWithText_p-xs__fOgU4","pl-xs":"IconWithText_pl-xs__wmFP7","pr-xs":"IconWithText_pr-xs__jt_31","pb-xs":"IconWithText_pb-xs__9oStr","pt-xs":"IconWithText_pt-xs__xI55f","m-xs":"IconWithText_m-xs__V7tmN","ml-xs":"IconWithText_ml-xs__XVGaA","mr-xs":"IconWithText_mr-xs____vnU","mb-xs":"IconWithText_mb-xs__OdQrQ","mt-xs":"IconWithText_mt-xs__nFZMJ","px-xs":"IconWithText_px-xs__seNmR","mx-xs":"IconWithText_mx-xs__AY6PN","my-xs":"IconWithText_my-xs__7XYaM","py-xs":"IconWithText_py-xs__8KcNZ","font-size-xs":"IconWithText_font-size-xs__HlPgw","p-ss":"IconWithText_p-ss__D_fyQ","pl-ss":"IconWithText_pl-ss__nIzqA","pr-ss":"IconWithText_pr-ss__yo6W2","pb-ss":"IconWithText_pb-ss__HR8rg","pt-ss":"IconWithText_pt-ss__JXA4J","m-ss":"IconWithText_m-ss__7T210","ml-ss":"IconWithText_ml-ss__g1xbW","mr-ss":"IconWithText_mr-ss__ruepg","mb-ss":"IconWithText_mb-ss__yZx0F","mt-ss":"IconWithText_mt-ss__fO2x8","px-ss":"IconWithText_px-ss__b8XRF","mx-ss":"IconWithText_mx-ss__zepwA","my-ss":"IconWithText_my-ss__V8AWk","py-ss":"IconWithText_py-ss__XLVzk","font-size-ss":"IconWithText_font-size-ss__vAaVg","p-ms":"IconWithText_p-ms__pRJd_","pl-ms":"IconWithText_pl-ms__fYJXr","pr-ms":"IconWithText_pr-ms__kUEMj","pb-ms":"IconWithText_pb-ms__ERWcL","pt-ms":"IconWithText_pt-ms__duIuv","m-ms":"IconWithText_m-ms__Oj_EO","ml-ms":"IconWithText_ml-ms__BHMhB","mr-ms":"IconWithText_mr-ms__GWr_v","mb-ms":"IconWithText_mb-ms__yir6A","mt-ms":"IconWithText_mt-ms__bMmzs","px-ms":"IconWithText_px-ms__HnbA9","mx-ms":"IconWithText_mx-ms__KXc90","my-ms":"IconWithText_my-ms__ACc0F","py-ms":"IconWithText_py-ms__nc_a2","font-size-ms":"IconWithText_font-size-ms___sDfv","p-s":"IconWithText_p-s__zyZuB","pl-s":"IconWithText_pl-s__r8EmS","pr-s":"IconWithText_pr-s__ElP9w","pb-s":"IconWithText_pb-s__PtLjw","pt-s":"IconWithText_pt-s__GFZ3o","m-s":"IconWithText_m-s__LDEyH","ml-s":"IconWithText_ml-s__X73Co","mr-s":"IconWithText_mr-s__RzgFn","mb-s":"IconWithText_mb-s__nt3N8","mt-s":"IconWithText_mt-s__Gdzpl","px-s":"IconWithText_px-s__mFlhx","mx-s":"IconWithText_mx-s__nIvYZ","my-s":"IconWithText_my-s__sNoQg","py-s":"IconWithText_py-s__V0mFp","font-size-s":"IconWithText_font-size-s__xGPD5","p-m":"IconWithText_p-m__OOmgt","pl-m":"IconWithText_pl-m__y8orI","pr-m":"IconWithText_pr-m__bhWWk","pb-m":"IconWithText_pb-m__7n_uD","pt-m":"IconWithText_pt-m__1HRCy","m-m":"IconWithText_m-m__VE8Qd","ml-m":"IconWithText_ml-m__KWcZ5","mr-m":"IconWithText_mr-m__GD6bH","mb-m":"IconWithText_mb-m___Zegq","mt-m":"IconWithText_mt-m__gKabN","px-m":"IconWithText_px-m__UuukG","mx-m":"IconWithText_mx-m__PKr5u","my-m":"IconWithText_my-m__DfK0_","py-m":"IconWithText_py-m__Q5eyX","font-size-m":"IconWithText_font-size-m__1QMy7","p-l":"IconWithText_p-l__I08KU","pl-l":"IconWithText_pl-l__DKBl_","pr-l":"IconWithText_pr-l__VIeQ6","pb-l":"IconWithText_pb-l__ICt0L","pt-l":"IconWithText_pt-l__9wGxl","m-l":"IconWithText_m-l__KiY0l","ml-l":"IconWithText_ml-l__7M74V","mr-l":"IconWithText_mr-l__B7HFR","mb-l":"IconWithText_mb-l__2QxZ1","mt-l":"IconWithText_mt-l__3AUSt","px-l":"IconWithText_px-l__dZt5e","mx-l":"IconWithText_mx-l__Gx0Dh","my-l":"IconWithText_my-l__SZ0ho","py-l":"IconWithText_py-l__nSCaR","font-size-l":"IconWithText_font-size-l__ylsKA","p-xl":"IconWithText_p-xl__Gnz9S","pl-xl":"IconWithText_pl-xl__7qx9T","pr-xl":"IconWithText_pr-xl__2cSiZ","pb-xl":"IconWithText_pb-xl__X_f_s","pt-xl":"IconWithText_pt-xl__9_caS","m-xl":"IconWithText_m-xl__NQgV8","ml-xl":"IconWithText_ml-xl__pmUqX","mr-xl":"IconWithText_mr-xl__c71uf","mb-xl":"IconWithText_mb-xl__nxv6D","mt-xl":"IconWithText_mt-xl__5IRlC","px-xl":"IconWithText_px-xl__czUO2","mx-xl":"IconWithText_mx-xl__Z3JWJ","my-xl":"IconWithText_my-xl__MSN8F","py-xl":"IconWithText_py-xl__HEpVR","font-size-xl":"IconWithText_font-size-xl__YP2KQ","p-xxl":"IconWithText_p-xxl__9ANqo","pl-xxl":"IconWithText_pl-xxl__0HUD0","pr-xxl":"IconWithText_pr-xxl__JmF8O","pb-xxl":"IconWithText_pb-xxl__0r6ED","pt-xxl":"IconWithText_pt-xxl__sj_Zx","m-xxl":"IconWithText_m-xxl__aSnwq","ml-xxl":"IconWithText_ml-xxl__0z_PA","mr-xxl":"IconWithText_mr-xxl__yQT1a","mb-xxl":"IconWithText_mb-xxl__pO3ij","mt-xxl":"IconWithText_mt-xxl__K4LC2","px-xxl":"IconWithText_px-xxl__9h9vh","mx-xxl":"IconWithText_mx-xxl__oVI3N","my-xxl":"IconWithText_my-xxl__HKfoB","py-xxl":"IconWithText_py-xxl__5J8VK","font-size-xxl":"IconWithText_font-size-xxl__Al_fP","overflow-hidden":"IconWithText_overflow-hidden__nCvdd","topMargin":"IconWithText_topMargin__ODcHh","detail-container":"IconWithText_detail-container__zPIgg","icon":"IconWithText_icon__oqVbW","value":"IconWithText_value__69bWT","type":"IconWithText_type__75gd_","description":"IconWithText_description__JqdEm"};

/***/ }),

/***/ 11005:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cart-list-container":"CartListContainer_cart-list-container__35D0O","cart-label":"CartListContainer_cart-label__7ImvP","product-container":"CartListContainer_product-container__L_hDL","price-label":"CartListContainer_price-label__Lgjml","cart-right-align":"CartListContainer_cart-right-align___nmn_","cart-left-align":"CartListContainer_cart-left-align__uKCcH","backbutton-label":"CartListContainer_backbutton-label__EKKR_","cart-price-label":"CartListContainer_cart-price-label__nAMRv","cart-price":"CartListContainer_cart-price__GxxfP","limit":"CartListContainer_limit__FE7yp","img":"CartListContainer_img__eaQ04","cart-limit-label":"CartListContainer_cart-limit-label__B0MZS","deal-total-due":"CartListContainer_deal-total-due__2sL6a","delivery-container":"CartListContainer_delivery-container__jhHYw","msg":"CartListContainer_msg__vfSGK","text-style":"CartListContainer_text-style__ItoUN","add_contract":"CartListContainer_add_contract__qN0t8","add_contract_cart":"CartListContainer_add_contract_cart__EKY0H","add_contract_cart_btn":"CartListContainer_add_contract_cart_btn__7UffO","add_contract_cart_btn_display":"CartListContainer_add_contract_cart_btn_display__KZvrv","add_contract_cart_btn_disable":"CartListContainer_add_contract_cart_btn_disable__0Ug3u","cart-bar":"CartListContainer_cart-bar__2VqMD","cart-label-container":"CartListContainer_cart-label-container__zyPLD"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5642,3729,9774,2888,179], function() { return __webpack_exec__(63222); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);